(function ($, undefined) {
    
    var smapi = window.smapi = window.smapi || {},
        extend = $.extend,
        each = $.each,
        proxy = $.proxy,
        noop = $.noop,
        isFunction = $.isFunction,
        globalize = window.Globalize;
    
    extend(smapi, { entities: {} });
    
    function AssemblyVersionModel(options) {
        var defaults = {
            AssemblyName: '',
            FullAssemblyName: '',
            CodeBase: '',
            VersionString: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AssemblyName = ko.validatedObservable(settings.AssemblyName);
        this.FullAssemblyName = ko.validatedObservable(settings.FullAssemblyName);
        this.CodeBase = ko.validatedObservable(settings.CodeBase);
        this.VersionString = ko.validatedObservable(settings.VersionString);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Scripts = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AssemblyName != undefined) {
                loaded.AssemblyName(responseData.AssemblyName);
            }
            if (responseData.FullAssemblyName != undefined) {
                loaded.FullAssemblyName(responseData.FullAssemblyName);
            }
            if (responseData.CodeBase != undefined) {
                loaded.CodeBase(responseData.CodeBase);
            }
            if (responseData.VersionString != undefined) {
                loaded.VersionString(responseData.VersionString);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Scripts != null && responseData.Scripts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Scripts.length; i++) {
                    items.push(new smapi.entities.AssemblyScriptModel().LoadFromResponse(responseData.Scripts[i]));
                }
                loaded.Scripts(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.AssemblyVersion', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AssemblyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FullAssemblyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.CodeBase.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.VersionString.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AssemblyScriptModel(options) {
        var defaults = {
            AssemblyName: '',
            ResourceName: '',
            SimpleResourceName: '',
            DDL: '',
            AssemblyVersionID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AssemblyName = ko.validatedObservable(settings.AssemblyName);
        this.ResourceName = ko.validatedObservable(settings.ResourceName);
        this.SimpleResourceName = ko.validatedObservable(settings.SimpleResourceName);
        this.DDL = ko.validatedObservable(settings.DDL);
        this.AssemblyVersionID = ko.validatedObservable(settings.AssemblyVersionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AssemblyName != undefined) {
                loaded.AssemblyName(responseData.AssemblyName);
            }
            if (responseData.ResourceName != undefined) {
                loaded.ResourceName(responseData.ResourceName);
            }
            if (responseData.SimpleResourceName != undefined) {
                loaded.SimpleResourceName(responseData.SimpleResourceName);
            }
            if (responseData.DDL != undefined) {
                loaded.DDL(responseData.DDL);
            }
            if (responseData.AssemblyVersionID != undefined) {
                loaded.AssemblyVersionID(responseData.AssemblyVersionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.AssemblyVersionModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.AssemblyScript', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AssemblyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ResourceName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.SimpleResourceName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DDL.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AssemblyVersionID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function UserModel(options) {
        var defaults = {
            UserID: null,
            ApplicationID: 0,
            Name: '',
            LoweredName: '',
            IsAnonymous: false,
            LastActivityDate: null,
            AssociatedTypeID: 0,
            DisplayName: '',
            SurName: '',
            GivenName: '',
            Email: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.UserID = ko.validatedObservable(settings.UserID);
        this.ApplicationID = ko.validatedObservable(settings.ApplicationID);
        this.Name = ko.validatedObservable(settings.Name);
        this.LoweredName = ko.validatedObservable(settings.LoweredName);
        this.IsAnonymous = ko.validatedObservable(settings.IsAnonymous);
        this.LastActivityDate = ko.validatedObservable(settings.LastActivityDate);
        this.AssociatedTypeID = ko.validatedObservable(settings.AssociatedTypeID);
        this.DisplayName = ko.validatedObservable(settings.DisplayName);
        this.SurName = ko.validatedObservable(settings.SurName);
        this.GivenName = ko.validatedObservable(settings.GivenName);
        this.Email = ko.validatedObservable(settings.Email);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.UserGroups = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.UserID != undefined) {
                loaded.UserID(responseData.UserID);
            }
            if (responseData.ApplicationID != undefined) {
                loaded.ApplicationID(responseData.ApplicationID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.LoweredName != undefined) {
                loaded.LoweredName(responseData.LoweredName);
            }
            if (responseData.IsAnonymous != undefined) {
                loaded.IsAnonymous(responseData.IsAnonymous);
            }
            if (responseData.LastActivityDate != undefined) {
                loaded.LastActivityDate(responseData.LastActivityDate);
            }
            if (responseData.AssociatedTypeID != undefined) {
                loaded.AssociatedTypeID(responseData.AssociatedTypeID);
            }
            if (responseData.DisplayName != undefined) {
                loaded.DisplayName(responseData.DisplayName);
            }
            if (responseData.SurName != undefined) {
                loaded.SurName(responseData.SurName);
            }
            if (responseData.GivenName != undefined) {
                loaded.GivenName(responseData.GivenName);
            }
            if (responseData.Email != undefined) {
                loaded.Email(responseData.Email);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.UserGroups != null && responseData.UserGroups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.UserGroups.length; i++) {
                    items.push(new smapi.entities.GroupModel().LoadFromResponse(responseData.UserGroups[i]));
                }
                loaded.UserGroups(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.User', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.UserID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ApplicationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LoweredName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LastActivityDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AssociatedTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DisplayName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SurName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GivenName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Email.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TRSIdentityModel(options) {
        var defaults = {
            UserID: null,
            ApplicationID: 0,
            Name: '',
            LoweredName: '',
            IsAnonymous: false,
            LastActivityDate: null,
            AssociatedTypeID: 0,
            DisplayName: '',
            SurName: '',
            GivenName: '',
            Email: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.UserID = ko.validatedObservable(settings.UserID);
        this.ApplicationID = ko.validatedObservable(settings.ApplicationID);
        this.Name = ko.validatedObservable(settings.Name);
        this.LoweredName = ko.validatedObservable(settings.LoweredName);
        this.IsAnonymous = ko.validatedObservable(settings.IsAnonymous);
        this.LastActivityDate = ko.validatedObservable(settings.LastActivityDate);
        this.AssociatedTypeID = ko.validatedObservable(settings.AssociatedTypeID);
        this.DisplayName = ko.validatedObservable(settings.DisplayName);
        this.SurName = ko.validatedObservable(settings.SurName);
        this.GivenName = ko.validatedObservable(settings.GivenName);
        this.Email = ko.validatedObservable(settings.Email);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Roles = ko.observableArray([]);
        this.UserGroups = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.UserID != undefined) {
                loaded.UserID(responseData.UserID);
            }
            if (responseData.ApplicationID != undefined) {
                loaded.ApplicationID(responseData.ApplicationID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.LoweredName != undefined) {
                loaded.LoweredName(responseData.LoweredName);
            }
            if (responseData.IsAnonymous != undefined) {
                loaded.IsAnonymous(responseData.IsAnonymous);
            }
            if (responseData.LastActivityDate != undefined) {
                loaded.LastActivityDate(responseData.LastActivityDate);
            }
            if (responseData.AssociatedTypeID != undefined) {
                loaded.AssociatedTypeID(responseData.AssociatedTypeID);
            }
            if (responseData.DisplayName != undefined) {
                loaded.DisplayName(responseData.DisplayName);
            }
            if (responseData.SurName != undefined) {
                loaded.SurName(responseData.SurName);
            }
            if (responseData.GivenName != undefined) {
                loaded.GivenName(responseData.GivenName);
            }
            if (responseData.Email != undefined) {
                loaded.Email(responseData.Email);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Roles != null && responseData.Roles.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Roles.length; i++) {
                    items.push(new smapi.entities.RoleModel().LoadFromResponse(responseData.Roles[i]));
                }
                loaded.Roles(items);
            }
            if (responseData.UserGroups != null && responseData.UserGroups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.UserGroups.length; i++) {
                    items.push(new smapi.entities.GroupModel().LoadFromResponse(responseData.UserGroups[i]));
                }
                loaded.UserGroups(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.TRSIdentity', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.UserID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ApplicationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LoweredName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LastActivityDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AssociatedTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DisplayName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SurName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GivenName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Email.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TRSGroupIdentityModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            GroupLevelID: null,
            ProviderID: null,
            ProviderKey: '',
            IsUnion: false,
            Abbreviation: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.GroupLevelID = ko.validatedObservable(settings.GroupLevelID);
        this.ProviderID = ko.validatedObservable(settings.ProviderID);
        this.ProviderKey = ko.validatedObservable(settings.ProviderKey);
        this.IsUnion = ko.validatedObservable(settings.IsUnion);
        this.Abbreviation = ko.validatedObservable(settings.Abbreviation);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Roles = ko.observableArray([]);
        this.GroupLevel = ko.observable();
        this.Groups = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.GroupLevelID != undefined) {
                loaded.GroupLevelID(responseData.GroupLevelID);
            }
            if (responseData.ProviderID != undefined) {
                loaded.ProviderID(responseData.ProviderID);
            }
            if (responseData.ProviderKey != undefined) {
                loaded.ProviderKey(responseData.ProviderKey);
            }
            if (responseData.IsUnion != undefined) {
                loaded.IsUnion(responseData.IsUnion);
            }
            if (responseData.Abbreviation != undefined) {
                loaded.Abbreviation(responseData.Abbreviation);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Roles != null && responseData.Roles.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Roles.length; i++) {
                    items.push(new smapi.entities.RoleModel().LoadFromResponse(responseData.Roles[i]));
                }
                loaded.Roles(items);
            }
            if (responseData.GroupLevel != null) {
                loaded.GroupLevel(new smapi.entities.GroupLevelModel().LoadFromResponse(responseData.GroupLevel));
            }
            if (responseData.Groups != null && responseData.Groups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Groups.length; i++) {
                    items.push(new smapi.entities.GroupModel().LoadFromResponse(responseData.Groups[i]));
                }
                loaded.Groups(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.TRSGroupIdentity', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProviderID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ProviderKey.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Abbreviation.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TRSMembershipUserModel(options) {
        var defaults = {
            ID: 0,
            GID: null,
            ApplicationID: 0,
            UserID: 0,
            ProviderName: '',
            UserName: '',
            EncryptedPassword: '',
            PasswordSalt: '',
            SourceProviderID: null,
            SourceProviderKey: '',
            Email: '',
            LoweredEmail: '',
            PasswordQuestion: '',
            EncryptedPasswordAnswer: '',
            Comment: '',
            IsApproved: false,
            IsLockedOut: false,
            CreationDate: null,
            LastLoginDate: null,
            LastActivityDate: null,
            LastPasswordChangedDate: null,
            LastLockoutDate: null,
            FailedPasswordAttemptCount: 0,
            FailedPasswordAttemptWindowStart: null,
            FailedPasswordAnswerAttemptCount: 0,
            FailedPasswordAnswerAttemptWindowStart: null,
            PasswordEncryptionType: 0,
            AnswerEncryptionType: 0,
            ForceChangePassword: false,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.ApplicationID = ko.validatedObservable(settings.ApplicationID);
        this.UserID = ko.validatedObservable(settings.UserID);
        this.ProviderName = ko.validatedObservable(settings.ProviderName);
        this.UserName = ko.validatedObservable(settings.UserName);
        this.EncryptedPassword = ko.validatedObservable(settings.EncryptedPassword);
        this.PasswordSalt = ko.validatedObservable(settings.PasswordSalt);
        this.SourceProviderID = ko.validatedObservable(settings.SourceProviderID);
        this.SourceProviderKey = ko.validatedObservable(settings.SourceProviderKey);
        this.Email = ko.validatedObservable(settings.Email);
        this.LoweredEmail = ko.validatedObservable(settings.LoweredEmail);
        this.PasswordQuestion = ko.validatedObservable(settings.PasswordQuestion);
        this.EncryptedPasswordAnswer = ko.validatedObservable(settings.EncryptedPasswordAnswer);
        this.Comment = ko.validatedObservable(settings.Comment);
        this.IsApproved = ko.validatedObservable(settings.IsApproved);
        this.IsLockedOut = ko.validatedObservable(settings.IsLockedOut);
        this.CreationDate = ko.validatedObservable(settings.CreationDate);
        this.LastLoginDate = ko.validatedObservable(settings.LastLoginDate);
        this.LastActivityDate = ko.validatedObservable(settings.LastActivityDate);
        this.LastPasswordChangedDate = ko.validatedObservable(settings.LastPasswordChangedDate);
        this.LastLockoutDate = ko.validatedObservable(settings.LastLockoutDate);
        this.FailedPasswordAttemptCount = ko.validatedObservable(settings.FailedPasswordAttemptCount);
        this.FailedPasswordAttemptWindowStart = ko.validatedObservable(settings.FailedPasswordAttemptWindowStart);
        this.FailedPasswordAnswerAttemptCount = ko.validatedObservable(settings.FailedPasswordAnswerAttemptCount);
        this.FailedPasswordAnswerAttemptWindowStart = ko.validatedObservable(settings.FailedPasswordAnswerAttemptWindowStart);
        this.PasswordEncryptionType = ko.validatedObservable(settings.PasswordEncryptionType);
        this.AnswerEncryptionType = ko.validatedObservable(settings.AnswerEncryptionType);
        this.ForceChangePassword = ko.validatedObservable(settings.ForceChangePassword);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.User = ko.observable();
        this.LoginCertificates = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.ApplicationID != undefined) {
                loaded.ApplicationID(responseData.ApplicationID);
            }
            if (responseData.UserID != undefined) {
                loaded.UserID(responseData.UserID);
            }
            if (responseData.ProviderName != undefined) {
                loaded.ProviderName(responseData.ProviderName);
            }
            if (responseData.UserName != undefined) {
                loaded.UserName(responseData.UserName);
            }
            if (responseData.EncryptedPassword != undefined) {
                loaded.EncryptedPassword(responseData.EncryptedPassword);
            }
            if (responseData.PasswordSalt != undefined) {
                loaded.PasswordSalt(responseData.PasswordSalt);
            }
            if (responseData.SourceProviderID != undefined) {
                loaded.SourceProviderID(responseData.SourceProviderID);
            }
            if (responseData.SourceProviderKey != undefined) {
                loaded.SourceProviderKey(responseData.SourceProviderKey);
            }
            if (responseData.Email != undefined) {
                loaded.Email(responseData.Email);
            }
            if (responseData.LoweredEmail != undefined) {
                loaded.LoweredEmail(responseData.LoweredEmail);
            }
            if (responseData.PasswordQuestion != undefined) {
                loaded.PasswordQuestion(responseData.PasswordQuestion);
            }
            if (responseData.EncryptedPasswordAnswer != undefined) {
                loaded.EncryptedPasswordAnswer(responseData.EncryptedPasswordAnswer);
            }
            if (responseData.Comment != undefined) {
                loaded.Comment(responseData.Comment);
            }
            if (responseData.IsApproved != undefined) {
                loaded.IsApproved(responseData.IsApproved);
            }
            if (responseData.IsLockedOut != undefined) {
                loaded.IsLockedOut(responseData.IsLockedOut);
            }
            if (responseData.CreationDate != undefined) {
                loaded.CreationDate(responseData.CreationDate);
            }
            if (responseData.LastLoginDate != undefined) {
                loaded.LastLoginDate(responseData.LastLoginDate);
            }
            if (responseData.LastActivityDate != undefined) {
                loaded.LastActivityDate(responseData.LastActivityDate);
            }
            if (responseData.LastPasswordChangedDate != undefined) {
                loaded.LastPasswordChangedDate(responseData.LastPasswordChangedDate);
            }
            if (responseData.LastLockoutDate != undefined) {
                loaded.LastLockoutDate(responseData.LastLockoutDate);
            }
            if (responseData.FailedPasswordAttemptCount != undefined) {
                loaded.FailedPasswordAttemptCount(responseData.FailedPasswordAttemptCount);
            }
            if (responseData.FailedPasswordAttemptWindowStart != undefined) {
                loaded.FailedPasswordAttemptWindowStart(responseData.FailedPasswordAttemptWindowStart);
            }
            if (responseData.FailedPasswordAnswerAttemptCount != undefined) {
                loaded.FailedPasswordAnswerAttemptCount(responseData.FailedPasswordAnswerAttemptCount);
            }
            if (responseData.FailedPasswordAnswerAttemptWindowStart != undefined) {
                loaded.FailedPasswordAnswerAttemptWindowStart(responseData.FailedPasswordAnswerAttemptWindowStart);
            }
            if (responseData.PasswordEncryptionType != undefined) {
                loaded.PasswordEncryptionType(responseData.PasswordEncryptionType);
            }
            if (responseData.AnswerEncryptionType != undefined) {
                loaded.AnswerEncryptionType(responseData.AnswerEncryptionType);
            }
            if (responseData.ForceChangePassword != undefined) {
                loaded.ForceChangePassword(responseData.ForceChangePassword);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.User != null) {
                loaded.User(new smapi.entities.TRSIdentityModel().LoadFromResponse(responseData.User));
            }
            if (responseData.LoginCertificates != null && responseData.LoginCertificates.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.LoginCertificates.length; i++) {
                    items.push(new smapi.entities.TRSMembershipUserCertificateModel().LoadFromResponse(responseData.LoginCertificates[i]));
                }
                loaded.LoginCertificates(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.TRSMembershipUser', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ApplicationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UserID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProviderName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.UserName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.EncryptedPassword.extend({
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.PasswordSalt.extend({
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.SourceProviderID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.SourceProviderKey.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.Email.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 256,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '256')
            }
        });
        this.LoweredEmail.extend({
            maxLength: {
                params: 256,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '256')
            }
        });
        this.PasswordQuestion.extend({
            maxLength: {
                params: 256,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '256')
            }
        });
        this.EncryptedPasswordAnswer.extend({
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.CreationDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.LastLoginDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.LastActivityDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.LastPasswordChangedDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.LastLockoutDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.FailedPasswordAttemptCount.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FailedPasswordAttemptWindowStart.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.FailedPasswordAnswerAttemptCount.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FailedPasswordAnswerAttemptWindowStart.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PasswordEncryptionType.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AnswerEncryptionType.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TRSMembershipUserCertificateModel(options) {
        var defaults = {
            TRSMembershipID: 0,
            UserHash: '',
            UserHashDisplay: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.TRSMembershipID = ko.validatedObservable(settings.TRSMembershipID);
        this.UserHash = ko.validatedObservable(settings.UserHash);
        this.UserHashDisplay = ko.validatedObservable(settings.UserHashDisplay);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.TRSMembership = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.TRSMembershipID != undefined) {
                loaded.TRSMembershipID(responseData.TRSMembershipID);
            }
            if (responseData.UserHash != undefined) {
                loaded.UserHash(responseData.UserHash);
            }
            if (responseData.UserHashDisplay != undefined) {
                loaded.UserHashDisplay(responseData.UserHashDisplay);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TRSMembership != null) {
                loaded.TRSMembership(new smapi.entities.TRSMembershipUserModel().LoadFromResponse(responseData.TRSMembership));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.TRSMembershipUserCertificate', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.TRSMembershipID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UserHash.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.UserHashDisplay.extend({
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LocaleModel(options) {
        var defaults = {
            Priority: 0,
            InvariantDescription: '',
            IsTB: false,
            Description: '',
            Code: '',
            SystemLocale: false,
            IsLTR: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Priority = ko.validatedObservable(settings.Priority);
        this.InvariantDescription = ko.validatedObservable(settings.InvariantDescription);
        this.IsTB = ko.validatedObservable(settings.IsTB);
        this.Description = ko.validatedObservable(settings.Description);
        this.Code = ko.validatedObservable(settings.Code);
        this.SystemLocale = ko.validatedObservable(settings.SystemLocale);
        this.IsLTR = ko.validatedObservable(settings.IsLTR);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Priority != undefined) {
                loaded.Priority(responseData.Priority);
            }
            if (responseData.InvariantDescription != undefined) {
                loaded.InvariantDescription(responseData.InvariantDescription);
            }
            if (responseData.IsTB != undefined) {
                loaded.IsTB(responseData.IsTB);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Code != undefined) {
                loaded.Code(responseData.Code);
            }
            if (responseData.SystemLocale != undefined) {
                loaded.SystemLocale(responseData.SystemLocale);
            }
            if (responseData.IsLTR != undefined) {
                loaded.IsLTR(responseData.IsLTR);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Locale', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Priority.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InvariantDescription.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Code.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 6,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '6')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function WebApplicationModel(options) {
        var defaults = {
            ApplicationName: '',
            LoweredApplicationName: '',
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ApplicationName = ko.validatedObservable(settings.ApplicationName);
        this.LoweredApplicationName = ko.validatedObservable(settings.LoweredApplicationName);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ApplicationName != undefined) {
                loaded.ApplicationName(responseData.ApplicationName);
            }
            if (responseData.LoweredApplicationName != undefined) {
                loaded.LoweredApplicationName(responseData.LoweredApplicationName);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.WebApplication', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ApplicationName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LoweredApplicationName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AuthenticationProviderDefModel(options) {
        var defaults = {
            ProviderID: null,
            ProviderName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ProviderID = ko.validatedObservable(settings.ProviderID);
        this.ProviderName = ko.validatedObservable(settings.ProviderName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ProviderID != undefined) {
                loaded.ProviderID(responseData.ProviderID);
            }
            if (responseData.ProviderName != undefined) {
                loaded.ProviderName(responseData.ProviderName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.AuthenticationProviderDef', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ProviderID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ProviderName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityBuilderModel(options) {
        var defaults = {
            NamespaceName: '',
            AssemblyNameStr: '',
            VersionString: '',
            IsUsingEncryption: false,
            IsChangeSession: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.NamespaceName = ko.validatedObservable(settings.NamespaceName);
        this.AssemblyNameStr = ko.validatedObservable(settings.AssemblyNameStr);
        this.VersionString = ko.validatedObservable(settings.VersionString);
        this.IsUsingEncryption = ko.validatedObservable(settings.IsUsingEncryption);
        this.IsChangeSession = ko.validatedObservable(settings.IsChangeSession);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Entities = ko.observableArray([]);
        this.Enumerations = ko.observableArray([]);
        this.Interfaces = ko.observableArray([]);
        this.Indexers = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.NamespaceName != undefined) {
                loaded.NamespaceName(responseData.NamespaceName);
            }
            if (responseData.AssemblyNameStr != undefined) {
                loaded.AssemblyNameStr(responseData.AssemblyNameStr);
            }
            if (responseData.VersionString != undefined) {
                loaded.VersionString(responseData.VersionString);
            }
            if (responseData.IsUsingEncryption != undefined) {
                loaded.IsUsingEncryption(responseData.IsUsingEncryption);
            }
            if (responseData.IsChangeSession != undefined) {
                loaded.IsChangeSession(responseData.IsChangeSession);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Entities != null && responseData.Entities.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Entities.length; i++) {
                    items.push(new smapi.entities.BuilderEntityModel().LoadFromResponse(responseData.Entities[i]));
                }
                loaded.Entities(items);
            }
            if (responseData.Enumerations != null && responseData.Enumerations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Enumerations.length; i++) {
                    items.push(new smapi.entities.BuilderEnumerationModel().LoadFromResponse(responseData.Enumerations[i]));
                }
                loaded.Enumerations(items);
            }
            if (responseData.Interfaces != null && responseData.Interfaces.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Interfaces.length; i++) {
                    items.push(new smapi.entities.BuilderInterfaceModel().LoadFromResponse(responseData.Interfaces[i]));
                }
                loaded.Interfaces(items);
            }
            if (responseData.Indexers != null && responseData.Indexers.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Indexers.length; i++) {
                    items.push(new smapi.entities.BuilderIndexerModel().LoadFromResponse(responseData.Indexers[i]));
                }
                loaded.Indexers(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityBuilder', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.NamespaceName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AssemblyNameStr.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.VersionString.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEnumerationModel(options) {
        var defaults = {
            ParentID: 0,
            Value: 0,
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.Value = ko.validatedObservable(settings.Value);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.EntityBuilderModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEnumeration', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderInterfaceModel(options) {
        var defaults = {
            ParentID: 0,
            TypeName: '',
            FullTypeName: '',
            ParentTypeName: '',
            IsObsolete: false,
            Cloneable: false,
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.TypeName = ko.validatedObservable(settings.TypeName);
        this.FullTypeName = ko.validatedObservable(settings.FullTypeName);
        this.ParentTypeName = ko.validatedObservable(settings.ParentTypeName);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.Cloneable = ko.validatedObservable(settings.Cloneable);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Properties = ko.observableArray([]);
        this.Relationships = ko.observableArray([]);
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.TypeName != undefined) {
                loaded.TypeName(responseData.TypeName);
            }
            if (responseData.FullTypeName != undefined) {
                loaded.FullTypeName(responseData.FullTypeName);
            }
            if (responseData.ParentTypeName != undefined) {
                loaded.ParentTypeName(responseData.ParentTypeName);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.Cloneable != undefined) {
                loaded.Cloneable(responseData.Cloneable);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Properties != null && responseData.Properties.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Properties.length; i++) {
                    items.push(new smapi.entities.BuilderInterfacePropertyModel().LoadFromResponse(responseData.Properties[i]));
                }
                loaded.Properties(items);
            }
            if (responseData.Relationships != null && responseData.Relationships.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Relationships.length; i++) {
                    items.push(new smapi.entities.BuilderInterfaceRelationshipModel().LoadFromResponse(responseData.Relationships[i]));
                }
                loaded.Relationships(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.EntityBuilderModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderInterface', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FullTypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ParentTypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderInterfacePropertyModel(options) {
        var defaults = {
            BuilderInterfaceID: 0,
            InheritedGID: null,
            AttributeName: '',
            DataType: '',
            Description: '',
            IsPK: false,
            IsBK: false,
            IsObsolete: false,
            HasSetter: false,
            HasGetter: false,
            IsNullable: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderInterfaceID = ko.validatedObservable(settings.BuilderInterfaceID);
        this.InheritedGID = ko.validatedObservable(settings.InheritedGID);
        this.AttributeName = ko.validatedObservable(settings.AttributeName);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.Description = ko.validatedObservable(settings.Description);
        this.IsPK = ko.validatedObservable(settings.IsPK);
        this.IsBK = ko.validatedObservable(settings.IsBK);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.HasSetter = ko.validatedObservable(settings.HasSetter);
        this.HasGetter = ko.validatedObservable(settings.HasGetter);
        this.IsNullable = ko.validatedObservable(settings.IsNullable);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderInterfaceID != undefined) {
                loaded.BuilderInterfaceID(responseData.BuilderInterfaceID);
            }
            if (responseData.InheritedGID != undefined) {
                loaded.InheritedGID(responseData.InheritedGID);
            }
            if (responseData.AttributeName != undefined) {
                loaded.AttributeName(responseData.AttributeName);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.IsPK != undefined) {
                loaded.IsPK(responseData.IsPK);
            }
            if (responseData.IsBK != undefined) {
                loaded.IsBK(responseData.IsBK);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.HasSetter != undefined) {
                loaded.HasSetter(responseData.HasSetter);
            }
            if (responseData.HasGetter != undefined) {
                loaded.HasGetter(responseData.HasGetter);
            }
            if (responseData.IsNullable != undefined) {
                loaded.IsNullable(responseData.IsNullable);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderInterfaceModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderInterfaceProperty', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderInterfaceID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InheritedGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.AttributeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderInterfaceRelationshipModel(options) {
        var defaults = {
            ParentID: 0,
            AttributeName: '',
            DataType: '',
            SimpleDataType: '',
            RelationShipType: '',
            HasGetter: false,
            HasSetter: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.AttributeName = ko.validatedObservable(settings.AttributeName);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.SimpleDataType = ko.validatedObservable(settings.SimpleDataType);
        this.RelationShipType = ko.validatedObservable(settings.RelationShipType);
        this.HasGetter = ko.validatedObservable(settings.HasGetter);
        this.HasSetter = ko.validatedObservable(settings.HasSetter);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.AttributeName != undefined) {
                loaded.AttributeName(responseData.AttributeName);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.SimpleDataType != undefined) {
                loaded.SimpleDataType(responseData.SimpleDataType);
            }
            if (responseData.RelationShipType != undefined) {
                loaded.RelationShipType(responseData.RelationShipType);
            }
            if (responseData.HasGetter != undefined) {
                loaded.HasGetter(responseData.HasGetter);
            }
            if (responseData.HasSetter != undefined) {
                loaded.HasSetter(responseData.HasSetter);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderInterfaceModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderInterfaceRelationship', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AttributeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SimpleDataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RelationShipType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderIndexerModel(options) {
        var defaults = {
            ParentID: 0,
            TypeName: '',
            FullTypeName: '',
            ParentDataTypeName: '',
            Singleton: false,
            IsObsolete: false,
            Cloneable: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.TypeName = ko.validatedObservable(settings.TypeName);
        this.FullTypeName = ko.validatedObservable(settings.FullTypeName);
        this.ParentDataTypeName = ko.validatedObservable(settings.ParentDataTypeName);
        this.Singleton = ko.validatedObservable(settings.Singleton);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.Cloneable = ko.validatedObservable(settings.Cloneable);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Indices = ko.observableArray([]);
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.TypeName != undefined) {
                loaded.TypeName(responseData.TypeName);
            }
            if (responseData.FullTypeName != undefined) {
                loaded.FullTypeName(responseData.FullTypeName);
            }
            if (responseData.ParentDataTypeName != undefined) {
                loaded.ParentDataTypeName(responseData.ParentDataTypeName);
            }
            if (responseData.Singleton != undefined) {
                loaded.Singleton(responseData.Singleton);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.Cloneable != undefined) {
                loaded.Cloneable(responseData.Cloneable);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Indices != null && responseData.Indices.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Indices.length; i++) {
                    items.push(new smapi.entities.BuilderIndexModel().LoadFromResponse(responseData.Indices[i]));
                }
                loaded.Indices(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.EntityBuilderModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderIndexer', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FullTypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ParentDataTypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderIndexModel(options) {
        var defaults = {
            ParentID: 0,
            TypeName: '',
            ReturnOrdinal: '',
            IsObsolete: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.TypeName = ko.validatedObservable(settings.TypeName);
        this.ReturnOrdinal = ko.validatedObservable(settings.ReturnOrdinal);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EqualProperties = ko.observableArray([]);
        this.RangeProperties = ko.observableArray([]);
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.TypeName != undefined) {
                loaded.TypeName(responseData.TypeName);
            }
            if (responseData.ReturnOrdinal != undefined) {
                loaded.ReturnOrdinal(responseData.ReturnOrdinal);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EqualProperties != null && responseData.EqualProperties.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EqualProperties.length; i++) {
                    items.push(new smapi.entities.BuilderIndexEqualPropertyModel().LoadFromResponse(responseData.EqualProperties[i]));
                }
                loaded.EqualProperties(items);
            }
            if (responseData.RangeProperties != null && responseData.RangeProperties.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RangeProperties.length; i++) {
                    items.push(new smapi.entities.BuilderIndexRangePropertyModel().LoadFromResponse(responseData.RangeProperties[i]));
                }
                loaded.RangeProperties(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderIndexerModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderIndex', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ReturnOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderIndexEqualPropertyModel(options) {
        var defaults = {
            BuilderIndexID: 0,
            BoundFieldName: '',
            IsNullable: false,
            CompareNull: false,
            DataType: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderIndexID = ko.validatedObservable(settings.BuilderIndexID);
        this.BoundFieldName = ko.validatedObservable(settings.BoundFieldName);
        this.IsNullable = ko.validatedObservable(settings.IsNullable);
        this.CompareNull = ko.validatedObservable(settings.CompareNull);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderIndexID != undefined) {
                loaded.BuilderIndexID(responseData.BuilderIndexID);
            }
            if (responseData.BoundFieldName != undefined) {
                loaded.BoundFieldName(responseData.BoundFieldName);
            }
            if (responseData.IsNullable != undefined) {
                loaded.IsNullable(responseData.IsNullable);
            }
            if (responseData.CompareNull != undefined) {
                loaded.CompareNull(responseData.CompareNull);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderIndexModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderIndexEqualProperty', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderIndexID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BoundFieldName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderIndexRangePropertyModel(options) {
        var defaults = {
            BuilderIndexID: 0,
            FieldName: '',
            BoundMin: '',
            BoundMax: '',
            DataType: '',
            IncludeMin: false,
            IncludeMax: false,
            HandleNullMax: false,
            HandleNullableField: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderIndexID = ko.validatedObservable(settings.BuilderIndexID);
        this.FieldName = ko.validatedObservable(settings.FieldName);
        this.BoundMin = ko.validatedObservable(settings.BoundMin);
        this.BoundMax = ko.validatedObservable(settings.BoundMax);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.IncludeMin = ko.validatedObservable(settings.IncludeMin);
        this.IncludeMax = ko.validatedObservable(settings.IncludeMax);
        this.HandleNullMax = ko.validatedObservable(settings.HandleNullMax);
        this.HandleNullableField = ko.validatedObservable(settings.HandleNullableField);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderIndexID != undefined) {
                loaded.BuilderIndexID(responseData.BuilderIndexID);
            }
            if (responseData.FieldName != undefined) {
                loaded.FieldName(responseData.FieldName);
            }
            if (responseData.BoundMin != undefined) {
                loaded.BoundMin(responseData.BoundMin);
            }
            if (responseData.BoundMax != undefined) {
                loaded.BoundMax(responseData.BoundMax);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.IncludeMin != undefined) {
                loaded.IncludeMin(responseData.IncludeMin);
            }
            if (responseData.IncludeMax != undefined) {
                loaded.IncludeMax(responseData.IncludeMax);
            }
            if (responseData.HandleNullMax != undefined) {
                loaded.HandleNullMax(responseData.HandleNullMax);
            }
            if (responseData.HandleNullableField != undefined) {
                loaded.HandleNullableField(responseData.HandleNullableField);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderIndexModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderIndexRangeProperty', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderIndexID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FieldName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BoundMin.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BoundMax.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityModel(options) {
        var defaults = {
            ParentID: 0,
            TypeName: '',
            FullTypeName: '',
            PartialClass: false,
            ParentTypeName: '',
            Implements: '',
            TableName: '',
            DBSchema: '',
            OwnedTable: false,
            CachedByPK: false,
            IsObsolete: false,
            Cloneable: false,
            InterfaceEntity: false,
            EntityCode: 0,
            EntityCodeName: '',
            IsParentEntity: false,
            TypeField: '',
            TypeValue: '',
            ToStringMethod: '',
            HasClusteredIndex: false,
            MainPage: '',
            Icon: '',
            IsDerivedBuilderEntity: false,
            Description: '',
            Title: '',
            CacheName: '',
            EntityCharacteristics: null,
            DisplayMode: null,
            ShowSuperstructure: false,
            ShowObsolete: false,
            ShowCreatedResults: false,
            ShowSimpleAudit: false,
            DetailsColumnCnt: 0,
            DetailsColumnDynamic: false,
            ParentInTOC: false,
            ExcludeFromApi: false,
            ManagementGrouping: '',
            MenuModule: '',
            MenuGrouping: '',
            MenuLocation: '',
            NoValidation: false,
            ExcludeFromMVC: false,
            IsUserDefined: false,
            PackageID: null,
            EmittOrder: 0,
            PathToContact: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.TypeName = ko.validatedObservable(settings.TypeName);
        this.FullTypeName = ko.validatedObservable(settings.FullTypeName);
        this.PartialClass = ko.validatedObservable(settings.PartialClass);
        this.ParentTypeName = ko.validatedObservable(settings.ParentTypeName);
        this.Implements = ko.validatedObservable(settings.Implements);
        this.TableName = ko.validatedObservable(settings.TableName);
        this.DBSchema = ko.validatedObservable(settings.DBSchema);
        this.OwnedTable = ko.validatedObservable(settings.OwnedTable);
        this.CachedByPK = ko.validatedObservable(settings.CachedByPK);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.Cloneable = ko.validatedObservable(settings.Cloneable);
        this.InterfaceEntity = ko.validatedObservable(settings.InterfaceEntity);
        this.EntityCode = ko.validatedObservable(settings.EntityCode);
        this.EntityCodeName = ko.validatedObservable(settings.EntityCodeName);
        this.IsParentEntity = ko.validatedObservable(settings.IsParentEntity);
        this.TypeField = ko.validatedObservable(settings.TypeField);
        this.TypeValue = ko.validatedObservable(settings.TypeValue);
        this.ToStringMethod = ko.validatedObservable(settings.ToStringMethod);
        this.HasClusteredIndex = ko.validatedObservable(settings.HasClusteredIndex);
        this.MainPage = ko.validatedObservable(settings.MainPage);
        this.Icon = ko.validatedObservable(settings.Icon);
        this.IsDerivedBuilderEntity = ko.validatedObservable(settings.IsDerivedBuilderEntity);
        this.Description = ko.validatedObservable(settings.Description);
        this.Title = ko.validatedObservable(settings.Title);
        this.CacheName = ko.validatedObservable(settings.CacheName);
        this.EntityCharacteristics = ko.validatedObservable(settings.EntityCharacteristics);
        this.DisplayMode = ko.validatedObservable(settings.DisplayMode);
        this.ShowSuperstructure = ko.validatedObservable(settings.ShowSuperstructure);
        this.ShowObsolete = ko.validatedObservable(settings.ShowObsolete);
        this.ShowCreatedResults = ko.validatedObservable(settings.ShowCreatedResults);
        this.ShowSimpleAudit = ko.validatedObservable(settings.ShowSimpleAudit);
        this.DetailsColumnCnt = ko.validatedObservable(settings.DetailsColumnCnt);
        this.DetailsColumnDynamic = ko.validatedObservable(settings.DetailsColumnDynamic);
        this.ParentInTOC = ko.validatedObservable(settings.ParentInTOC);
        this.ExcludeFromApi = ko.validatedObservable(settings.ExcludeFromApi);
        this.ManagementGrouping = ko.validatedObservable(settings.ManagementGrouping);
        this.MenuModule = ko.validatedObservable(settings.MenuModule);
        this.MenuGrouping = ko.validatedObservable(settings.MenuGrouping);
        this.MenuLocation = ko.validatedObservable(settings.MenuLocation);
        this.NoValidation = ko.validatedObservable(settings.NoValidation);
        this.ExcludeFromMVC = ko.validatedObservable(settings.ExcludeFromMVC);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.EmittOrder = ko.validatedObservable(settings.EmittOrder);
        this.PathToContact = ko.validatedObservable(settings.PathToContact);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Fields = ko.observableArray([]);
        this.Relationships = ko.observableArray([]);
        this.Queries = ko.observableArray([]);
        this.DBIndices = ko.observableArray([]);
        this.Entities = ko.observableArray([]);
        this.Parent = ko.observable();
        this.Package = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.TypeName != undefined) {
                loaded.TypeName(responseData.TypeName);
            }
            if (responseData.FullTypeName != undefined) {
                loaded.FullTypeName(responseData.FullTypeName);
            }
            if (responseData.PartialClass != undefined) {
                loaded.PartialClass(responseData.PartialClass);
            }
            if (responseData.ParentTypeName != undefined) {
                loaded.ParentTypeName(responseData.ParentTypeName);
            }
            if (responseData.Implements != undefined) {
                loaded.Implements(responseData.Implements);
            }
            if (responseData.TableName != undefined) {
                loaded.TableName(responseData.TableName);
            }
            if (responseData.DBSchema != undefined) {
                loaded.DBSchema(responseData.DBSchema);
            }
            if (responseData.OwnedTable != undefined) {
                loaded.OwnedTable(responseData.OwnedTable);
            }
            if (responseData.CachedByPK != undefined) {
                loaded.CachedByPK(responseData.CachedByPK);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.Cloneable != undefined) {
                loaded.Cloneable(responseData.Cloneable);
            }
            if (responseData.InterfaceEntity != undefined) {
                loaded.InterfaceEntity(responseData.InterfaceEntity);
            }
            if (responseData.EntityCode != undefined) {
                loaded.EntityCode(responseData.EntityCode);
            }
            if (responseData.EntityCodeName != undefined) {
                loaded.EntityCodeName(responseData.EntityCodeName);
            }
            if (responseData.IsParentEntity != undefined) {
                loaded.IsParentEntity(responseData.IsParentEntity);
            }
            if (responseData.TypeField != undefined) {
                loaded.TypeField(responseData.TypeField);
            }
            if (responseData.TypeValue != undefined) {
                loaded.TypeValue(responseData.TypeValue);
            }
            if (responseData.ToStringMethod != undefined) {
                loaded.ToStringMethod(responseData.ToStringMethod);
            }
            if (responseData.HasClusteredIndex != undefined) {
                loaded.HasClusteredIndex(responseData.HasClusteredIndex);
            }
            if (responseData.MainPage != undefined) {
                loaded.MainPage(responseData.MainPage);
            }
            if (responseData.Icon != undefined) {
                loaded.Icon(responseData.Icon);
            }
            if (responseData.IsDerivedBuilderEntity != undefined) {
                loaded.IsDerivedBuilderEntity(responseData.IsDerivedBuilderEntity);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Title != undefined) {
                loaded.Title(responseData.Title);
            }
            if (responseData.CacheName != undefined) {
                loaded.CacheName(responseData.CacheName);
            }
            if (responseData.EntityCharacteristics != undefined) {
                loaded.EntityCharacteristics(responseData.EntityCharacteristics);
            }
            if (responseData.DisplayMode != undefined) {
                loaded.DisplayMode(responseData.DisplayMode);
            }
            if (responseData.ShowSuperstructure != undefined) {
                loaded.ShowSuperstructure(responseData.ShowSuperstructure);
            }
            if (responseData.ShowObsolete != undefined) {
                loaded.ShowObsolete(responseData.ShowObsolete);
            }
            if (responseData.ShowCreatedResults != undefined) {
                loaded.ShowCreatedResults(responseData.ShowCreatedResults);
            }
            if (responseData.ShowSimpleAudit != undefined) {
                loaded.ShowSimpleAudit(responseData.ShowSimpleAudit);
            }
            if (responseData.DetailsColumnCnt != undefined) {
                loaded.DetailsColumnCnt(responseData.DetailsColumnCnt);
            }
            if (responseData.DetailsColumnDynamic != undefined) {
                loaded.DetailsColumnDynamic(responseData.DetailsColumnDynamic);
            }
            if (responseData.ParentInTOC != undefined) {
                loaded.ParentInTOC(responseData.ParentInTOC);
            }
            if (responseData.ExcludeFromApi != undefined) {
                loaded.ExcludeFromApi(responseData.ExcludeFromApi);
            }
            if (responseData.ManagementGrouping != undefined) {
                loaded.ManagementGrouping(responseData.ManagementGrouping);
            }
            if (responseData.MenuModule != undefined) {
                loaded.MenuModule(responseData.MenuModule);
            }
            if (responseData.MenuGrouping != undefined) {
                loaded.MenuGrouping(responseData.MenuGrouping);
            }
            if (responseData.MenuLocation != undefined) {
                loaded.MenuLocation(responseData.MenuLocation);
            }
            if (responseData.NoValidation != undefined) {
                loaded.NoValidation(responseData.NoValidation);
            }
            if (responseData.ExcludeFromMVC != undefined) {
                loaded.ExcludeFromMVC(responseData.ExcludeFromMVC);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.EmittOrder != undefined) {
                loaded.EmittOrder(responseData.EmittOrder);
            }
            if (responseData.PathToContact != undefined) {
                loaded.PathToContact(responseData.PathToContact);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Fields != null && responseData.Fields.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Fields.length; i++) {
                    items.push(new smapi.entities.BuilderEntityFieldModel().LoadFromResponse(responseData.Fields[i]));
                }
                loaded.Fields(items);
            }
            if (responseData.Relationships != null && responseData.Relationships.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Relationships.length; i++) {
                    items.push(new smapi.entities.BuilderEntityRelationshipModel().LoadFromResponse(responseData.Relationships[i]));
                }
                loaded.Relationships(items);
            }
            if (responseData.Queries != null && responseData.Queries.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Queries.length; i++) {
                    items.push(new smapi.entities.BuilderEntityQueryModel().LoadFromResponse(responseData.Queries[i]));
                }
                loaded.Queries(items);
            }
            if (responseData.DBIndices != null && responseData.DBIndices.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DBIndices.length; i++) {
                    items.push(new smapi.entities.BuilderEntityDBIndexModel().LoadFromResponse(responseData.DBIndices[i]));
                }
                loaded.DBIndices(items);
            }
            if (responseData.Entities != null && responseData.Entities.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Entities.length; i++) {
                    items.push(new smapi.entities.EntityModel().LoadFromResponse(responseData.Entities[i]));
                }
                loaded.Entities(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.EntityBuilderModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntity', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.FullTypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ParentTypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Implements.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.TableName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DBSchema.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.EntityCode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EntityCodeName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.TypeField.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.TypeValue.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ToStringMethod.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.MainPage.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Icon.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.Title.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 200,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '200')
            }
        });
        this.CacheName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.EntityCharacteristics.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DisplayMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DetailsColumnCnt.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ManagementGrouping.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MenuModule.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.MenuGrouping.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MenuLocation.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EmittOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PathToContact.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityFieldModel(options) {
        var defaults = {
            BuilderEntityID: 0,
            FieldOrdinal: 0,
            AttributeName: '',
            DisplayName: '',
            FieldName: '',
            DataType: '',
            DefaultValue: '',
            DataLength: 0,
            Precision: 0,
            Scale: 0,
            IsPK: false,
            IsBK: false,
            IsAvailableForWrapper: false,
            IsIdentity: false,
            IsNullable: false,
            Required: false,
            IsObsolete: false,
            IsInherited: false,
            HasSetter: false,
            HasGetter: false,
            IsFixedLength: false,
            IsInline: false,
            MinimumDataLength: 0,
            HintMask: '',
            DisplayMask: '',
            IsDBHashed: false,
            IsDBEncrypted: false,
            ProviderID: null,
            ZoneName: '',
            IsMasked: false,
            IsLocalizable: false,
            Transient: false,
            InheritedID: null,
            MigrationDefaultValue: '',
            AttributeForRelationship: '',
            AggregateRelationship: '',
            Label: '',
            ShortLabel: '',
            Tooltip: '',
            Prompt: '',
            MinimumValue: '',
            MaximumValue: '',
            ValidationRegExStr: '',
            InvalidMessage: '',
            SourceType: '',
            SourceDisplay: '',
            SourceValue: '',
            SourceFilter: '',
            SortOrdinal: 0,
            SortDirection: '',
            FieldCharacteristics: null,
            RelatedField: '',
            NaturalKey: false,
            SearchField: false,
            SearchResultField: false,
            PopupSearchField: false,
            PopupSearchResultField: false,
            LiveSearchResult: false,
            PopupJsonResult: false,
            SVDisplayField: false,
            TOCTableField: false,
            TOCListField: false,
            Hidden: false,
            Calculated: false,
            TitledDisplayGroup: '',
            DisplayGroup: '',
            IsHtml: false,
            HeaderField: false,
            ShortForm: false,
            LongForm: false,
            TitledResultsGroup: '',
            ResultsGroup: '',
            ResultsOrder: 0,
            InStaticPrimary: false,
            IsPercentage: false,
            IsDateSequence: false,
            DateSeqDownstreamOperator: '',
            DateSeqUpstreamOperator: '',
            DateSeqPathToDownstreamDate: '',
            DateSeqPathToUpstreamDate: '',
            PathToCurrency: '',
            ApiSummaryField: false,
            ApiDetailedField: false,
            IsUserDefined: false,
            PackageID: null,
            IsTimeSequence: false,
            StaticSectionView: '',
            PopupEditorView: '',
            ListTableHeaderView: '',
            ListTableRowView: '',
            StandardTableHeaderView: '',
            StandardTableRowView: '',
            StandardListView: '',
            StandardTableM2MView: '',
            SearchEditorView: '',
            SearchHeaderView: '',
            SearchRowView: '',
            SearchListView: '',
            DisplayReadOnly: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderEntityID = ko.validatedObservable(settings.BuilderEntityID);
        this.FieldOrdinal = ko.validatedObservable(settings.FieldOrdinal);
        this.AttributeName = ko.validatedObservable(settings.AttributeName);
        this.DisplayName = ko.validatedObservable(settings.DisplayName);
        this.FieldName = ko.validatedObservable(settings.FieldName);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.DefaultValue = ko.validatedObservable(settings.DefaultValue);
        this.DataLength = ko.validatedObservable(settings.DataLength);
        this.Precision = ko.validatedObservable(settings.Precision);
        this.Scale = ko.validatedObservable(settings.Scale);
        this.IsPK = ko.validatedObservable(settings.IsPK);
        this.IsBK = ko.validatedObservable(settings.IsBK);
        this.IsAvailableForWrapper = ko.validatedObservable(settings.IsAvailableForWrapper);
        this.IsIdentity = ko.validatedObservable(settings.IsIdentity);
        this.IsNullable = ko.validatedObservable(settings.IsNullable);
        this.Required = ko.validatedObservable(settings.Required);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.IsInherited = ko.validatedObservable(settings.IsInherited);
        this.HasSetter = ko.validatedObservable(settings.HasSetter);
        this.HasGetter = ko.validatedObservable(settings.HasGetter);
        this.IsFixedLength = ko.validatedObservable(settings.IsFixedLength);
        this.IsInline = ko.validatedObservable(settings.IsInline);
        this.MinimumDataLength = ko.validatedObservable(settings.MinimumDataLength);
        this.HintMask = ko.validatedObservable(settings.HintMask);
        this.DisplayMask = ko.validatedObservable(settings.DisplayMask);
        this.IsDBHashed = ko.validatedObservable(settings.IsDBHashed);
        this.IsDBEncrypted = ko.validatedObservable(settings.IsDBEncrypted);
        this.ProviderID = ko.validatedObservable(settings.ProviderID);
        this.ZoneName = ko.validatedObservable(settings.ZoneName);
        this.IsMasked = ko.validatedObservable(settings.IsMasked);
        this.IsLocalizable = ko.validatedObservable(settings.IsLocalizable);
        this.Transient = ko.validatedObservable(settings.Transient);
        this.InheritedID = ko.validatedObservable(settings.InheritedID);
        this.MigrationDefaultValue = ko.validatedObservable(settings.MigrationDefaultValue);
        this.AttributeForRelationship = ko.validatedObservable(settings.AttributeForRelationship);
        this.AggregateRelationship = ko.validatedObservable(settings.AggregateRelationship);
        this.Label = ko.validatedObservable(settings.Label);
        this.ShortLabel = ko.validatedObservable(settings.ShortLabel);
        this.Tooltip = ko.validatedObservable(settings.Tooltip);
        this.Prompt = ko.validatedObservable(settings.Prompt);
        this.MinimumValue = ko.validatedObservable(settings.MinimumValue);
        this.MaximumValue = ko.validatedObservable(settings.MaximumValue);
        this.ValidationRegExStr = ko.validatedObservable(settings.ValidationRegExStr);
        this.InvalidMessage = ko.validatedObservable(settings.InvalidMessage);
        this.SourceType = ko.validatedObservable(settings.SourceType);
        this.SourceDisplay = ko.validatedObservable(settings.SourceDisplay);
        this.SourceValue = ko.validatedObservable(settings.SourceValue);
        this.SourceFilter = ko.validatedObservable(settings.SourceFilter);
        this.SortOrdinal = ko.validatedObservable(settings.SortOrdinal);
        this.SortDirection = ko.validatedObservable(settings.SortDirection);
        this.FieldCharacteristics = ko.validatedObservable(settings.FieldCharacteristics);
        this.RelatedField = ko.validatedObservable(settings.RelatedField);
        this.NaturalKey = ko.validatedObservable(settings.NaturalKey);
        this.SearchField = ko.validatedObservable(settings.SearchField);
        this.SearchResultField = ko.validatedObservable(settings.SearchResultField);
        this.PopupSearchField = ko.validatedObservable(settings.PopupSearchField);
        this.PopupSearchResultField = ko.validatedObservable(settings.PopupSearchResultField);
        this.LiveSearchResult = ko.validatedObservable(settings.LiveSearchResult);
        this.PopupJsonResult = ko.validatedObservable(settings.PopupJsonResult);
        this.SVDisplayField = ko.validatedObservable(settings.SVDisplayField);
        this.TOCTableField = ko.validatedObservable(settings.TOCTableField);
        this.TOCListField = ko.validatedObservable(settings.TOCListField);
        this.Hidden = ko.validatedObservable(settings.Hidden);
        this.Calculated = ko.validatedObservable(settings.Calculated);
        this.TitledDisplayGroup = ko.validatedObservable(settings.TitledDisplayGroup);
        this.DisplayGroup = ko.validatedObservable(settings.DisplayGroup);
        this.IsHtml = ko.validatedObservable(settings.IsHtml);
        this.HeaderField = ko.validatedObservable(settings.HeaderField);
        this.ShortForm = ko.validatedObservable(settings.ShortForm);
        this.LongForm = ko.validatedObservable(settings.LongForm);
        this.TitledResultsGroup = ko.validatedObservable(settings.TitledResultsGroup);
        this.ResultsGroup = ko.validatedObservable(settings.ResultsGroup);
        this.ResultsOrder = ko.validatedObservable(settings.ResultsOrder);
        this.InStaticPrimary = ko.validatedObservable(settings.InStaticPrimary);
        this.IsPercentage = ko.validatedObservable(settings.IsPercentage);
        this.IsDateSequence = ko.validatedObservable(settings.IsDateSequence);
        this.DateSeqDownstreamOperator = ko.validatedObservable(settings.DateSeqDownstreamOperator);
        this.DateSeqUpstreamOperator = ko.validatedObservable(settings.DateSeqUpstreamOperator);
        this.DateSeqPathToDownstreamDate = ko.validatedObservable(settings.DateSeqPathToDownstreamDate);
        this.DateSeqPathToUpstreamDate = ko.validatedObservable(settings.DateSeqPathToUpstreamDate);
        this.PathToCurrency = ko.validatedObservable(settings.PathToCurrency);
        this.ApiSummaryField = ko.validatedObservable(settings.ApiSummaryField);
        this.ApiDetailedField = ko.validatedObservable(settings.ApiDetailedField);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.IsTimeSequence = ko.validatedObservable(settings.IsTimeSequence);
        this.StaticSectionView = ko.validatedObservable(settings.StaticSectionView);
        this.PopupEditorView = ko.validatedObservable(settings.PopupEditorView);
        this.ListTableHeaderView = ko.validatedObservable(settings.ListTableHeaderView);
        this.ListTableRowView = ko.validatedObservable(settings.ListTableRowView);
        this.StandardTableHeaderView = ko.validatedObservable(settings.StandardTableHeaderView);
        this.StandardTableRowView = ko.validatedObservable(settings.StandardTableRowView);
        this.StandardListView = ko.validatedObservable(settings.StandardListView);
        this.StandardTableM2MView = ko.validatedObservable(settings.StandardTableM2MView);
        this.SearchEditorView = ko.validatedObservable(settings.SearchEditorView);
        this.SearchHeaderView = ko.validatedObservable(settings.SearchHeaderView);
        this.SearchRowView = ko.validatedObservable(settings.SearchRowView);
        this.SearchListView = ko.validatedObservable(settings.SearchListView);
        this.DisplayReadOnly = ko.validatedObservable(settings.DisplayReadOnly);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.Package = ko.observable();
        this.MVCAttributes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderEntityID != undefined) {
                loaded.BuilderEntityID(responseData.BuilderEntityID);
            }
            if (responseData.FieldOrdinal != undefined) {
                loaded.FieldOrdinal(responseData.FieldOrdinal);
            }
            if (responseData.AttributeName != undefined) {
                loaded.AttributeName(responseData.AttributeName);
            }
            if (responseData.DisplayName != undefined) {
                loaded.DisplayName(responseData.DisplayName);
            }
            if (responseData.FieldName != undefined) {
                loaded.FieldName(responseData.FieldName);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.DefaultValue != undefined) {
                loaded.DefaultValue(responseData.DefaultValue);
            }
            if (responseData.DataLength != undefined) {
                loaded.DataLength(responseData.DataLength);
            }
            if (responseData.Precision != undefined) {
                loaded.Precision(responseData.Precision);
            }
            if (responseData.Scale != undefined) {
                loaded.Scale(responseData.Scale);
            }
            if (responseData.IsPK != undefined) {
                loaded.IsPK(responseData.IsPK);
            }
            if (responseData.IsBK != undefined) {
                loaded.IsBK(responseData.IsBK);
            }
            if (responseData.IsAvailableForWrapper != undefined) {
                loaded.IsAvailableForWrapper(responseData.IsAvailableForWrapper);
            }
            if (responseData.IsIdentity != undefined) {
                loaded.IsIdentity(responseData.IsIdentity);
            }
            if (responseData.IsNullable != undefined) {
                loaded.IsNullable(responseData.IsNullable);
            }
            if (responseData.Required != undefined) {
                loaded.Required(responseData.Required);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.IsInherited != undefined) {
                loaded.IsInherited(responseData.IsInherited);
            }
            if (responseData.HasSetter != undefined) {
                loaded.HasSetter(responseData.HasSetter);
            }
            if (responseData.HasGetter != undefined) {
                loaded.HasGetter(responseData.HasGetter);
            }
            if (responseData.IsFixedLength != undefined) {
                loaded.IsFixedLength(responseData.IsFixedLength);
            }
            if (responseData.IsInline != undefined) {
                loaded.IsInline(responseData.IsInline);
            }
            if (responseData.MinimumDataLength != undefined) {
                loaded.MinimumDataLength(responseData.MinimumDataLength);
            }
            if (responseData.HintMask != undefined) {
                loaded.HintMask(responseData.HintMask);
            }
            if (responseData.DisplayMask != undefined) {
                loaded.DisplayMask(responseData.DisplayMask);
            }
            if (responseData.IsDBHashed != undefined) {
                loaded.IsDBHashed(responseData.IsDBHashed);
            }
            if (responseData.IsDBEncrypted != undefined) {
                loaded.IsDBEncrypted(responseData.IsDBEncrypted);
            }
            if (responseData.ProviderID != undefined) {
                loaded.ProviderID(responseData.ProviderID);
            }
            if (responseData.ZoneName != undefined) {
                loaded.ZoneName(responseData.ZoneName);
            }
            if (responseData.IsMasked != undefined) {
                loaded.IsMasked(responseData.IsMasked);
            }
            if (responseData.IsLocalizable != undefined) {
                loaded.IsLocalizable(responseData.IsLocalizable);
            }
            if (responseData.Transient != undefined) {
                loaded.Transient(responseData.Transient);
            }
            if (responseData.InheritedID != undefined) {
                loaded.InheritedID(responseData.InheritedID);
            }
            if (responseData.MigrationDefaultValue != undefined) {
                loaded.MigrationDefaultValue(responseData.MigrationDefaultValue);
            }
            if (responseData.AttributeForRelationship != undefined) {
                loaded.AttributeForRelationship(responseData.AttributeForRelationship);
            }
            if (responseData.AggregateRelationship != undefined) {
                loaded.AggregateRelationship(responseData.AggregateRelationship);
            }
            if (responseData.Label != undefined) {
                loaded.Label(responseData.Label);
            }
            if (responseData.ShortLabel != undefined) {
                loaded.ShortLabel(responseData.ShortLabel);
            }
            if (responseData.Tooltip != undefined) {
                loaded.Tooltip(responseData.Tooltip);
            }
            if (responseData.Prompt != undefined) {
                loaded.Prompt(responseData.Prompt);
            }
            if (responseData.MinimumValue != undefined) {
                loaded.MinimumValue(responseData.MinimumValue);
            }
            if (responseData.MaximumValue != undefined) {
                loaded.MaximumValue(responseData.MaximumValue);
            }
            if (responseData.ValidationRegExStr != undefined) {
                loaded.ValidationRegExStr(responseData.ValidationRegExStr);
            }
            if (responseData.InvalidMessage != undefined) {
                loaded.InvalidMessage(responseData.InvalidMessage);
            }
            if (responseData.SourceType != undefined) {
                loaded.SourceType(responseData.SourceType);
            }
            if (responseData.SourceDisplay != undefined) {
                loaded.SourceDisplay(responseData.SourceDisplay);
            }
            if (responseData.SourceValue != undefined) {
                loaded.SourceValue(responseData.SourceValue);
            }
            if (responseData.SourceFilter != undefined) {
                loaded.SourceFilter(responseData.SourceFilter);
            }
            if (responseData.SortOrdinal != undefined) {
                loaded.SortOrdinal(responseData.SortOrdinal);
            }
            if (responseData.SortDirection != undefined) {
                loaded.SortDirection(responseData.SortDirection);
            }
            if (responseData.FieldCharacteristics != undefined) {
                loaded.FieldCharacteristics(responseData.FieldCharacteristics);
            }
            if (responseData.RelatedField != undefined) {
                loaded.RelatedField(responseData.RelatedField);
            }
            if (responseData.NaturalKey != undefined) {
                loaded.NaturalKey(responseData.NaturalKey);
            }
            if (responseData.SearchField != undefined) {
                loaded.SearchField(responseData.SearchField);
            }
            if (responseData.SearchResultField != undefined) {
                loaded.SearchResultField(responseData.SearchResultField);
            }
            if (responseData.PopupSearchField != undefined) {
                loaded.PopupSearchField(responseData.PopupSearchField);
            }
            if (responseData.PopupSearchResultField != undefined) {
                loaded.PopupSearchResultField(responseData.PopupSearchResultField);
            }
            if (responseData.LiveSearchResult != undefined) {
                loaded.LiveSearchResult(responseData.LiveSearchResult);
            }
            if (responseData.PopupJsonResult != undefined) {
                loaded.PopupJsonResult(responseData.PopupJsonResult);
            }
            if (responseData.SVDisplayField != undefined) {
                loaded.SVDisplayField(responseData.SVDisplayField);
            }
            if (responseData.TOCTableField != undefined) {
                loaded.TOCTableField(responseData.TOCTableField);
            }
            if (responseData.TOCListField != undefined) {
                loaded.TOCListField(responseData.TOCListField);
            }
            if (responseData.Hidden != undefined) {
                loaded.Hidden(responseData.Hidden);
            }
            if (responseData.Calculated != undefined) {
                loaded.Calculated(responseData.Calculated);
            }
            if (responseData.TitledDisplayGroup != undefined) {
                loaded.TitledDisplayGroup(responseData.TitledDisplayGroup);
            }
            if (responseData.DisplayGroup != undefined) {
                loaded.DisplayGroup(responseData.DisplayGroup);
            }
            if (responseData.IsHtml != undefined) {
                loaded.IsHtml(responseData.IsHtml);
            }
            if (responseData.HeaderField != undefined) {
                loaded.HeaderField(responseData.HeaderField);
            }
            if (responseData.ShortForm != undefined) {
                loaded.ShortForm(responseData.ShortForm);
            }
            if (responseData.LongForm != undefined) {
                loaded.LongForm(responseData.LongForm);
            }
            if (responseData.TitledResultsGroup != undefined) {
                loaded.TitledResultsGroup(responseData.TitledResultsGroup);
            }
            if (responseData.ResultsGroup != undefined) {
                loaded.ResultsGroup(responseData.ResultsGroup);
            }
            if (responseData.ResultsOrder != undefined) {
                loaded.ResultsOrder(responseData.ResultsOrder);
            }
            if (responseData.InStaticPrimary != undefined) {
                loaded.InStaticPrimary(responseData.InStaticPrimary);
            }
            if (responseData.IsPercentage != undefined) {
                loaded.IsPercentage(responseData.IsPercentage);
            }
            if (responseData.IsDateSequence != undefined) {
                loaded.IsDateSequence(responseData.IsDateSequence);
            }
            if (responseData.DateSeqDownstreamOperator != undefined) {
                loaded.DateSeqDownstreamOperator(responseData.DateSeqDownstreamOperator);
            }
            if (responseData.DateSeqUpstreamOperator != undefined) {
                loaded.DateSeqUpstreamOperator(responseData.DateSeqUpstreamOperator);
            }
            if (responseData.DateSeqPathToDownstreamDate != undefined) {
                loaded.DateSeqPathToDownstreamDate(responseData.DateSeqPathToDownstreamDate);
            }
            if (responseData.DateSeqPathToUpstreamDate != undefined) {
                loaded.DateSeqPathToUpstreamDate(responseData.DateSeqPathToUpstreamDate);
            }
            if (responseData.PathToCurrency != undefined) {
                loaded.PathToCurrency(responseData.PathToCurrency);
            }
            if (responseData.ApiSummaryField != undefined) {
                loaded.ApiSummaryField(responseData.ApiSummaryField);
            }
            if (responseData.ApiDetailedField != undefined) {
                loaded.ApiDetailedField(responseData.ApiDetailedField);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.IsTimeSequence != undefined) {
                loaded.IsTimeSequence(responseData.IsTimeSequence);
            }
            if (responseData.StaticSectionView != undefined) {
                loaded.StaticSectionView(responseData.StaticSectionView);
            }
            if (responseData.PopupEditorView != undefined) {
                loaded.PopupEditorView(responseData.PopupEditorView);
            }
            if (responseData.ListTableHeaderView != undefined) {
                loaded.ListTableHeaderView(responseData.ListTableHeaderView);
            }
            if (responseData.ListTableRowView != undefined) {
                loaded.ListTableRowView(responseData.ListTableRowView);
            }
            if (responseData.StandardTableHeaderView != undefined) {
                loaded.StandardTableHeaderView(responseData.StandardTableHeaderView);
            }
            if (responseData.StandardTableRowView != undefined) {
                loaded.StandardTableRowView(responseData.StandardTableRowView);
            }
            if (responseData.StandardListView != undefined) {
                loaded.StandardListView(responseData.StandardListView);
            }
            if (responseData.StandardTableM2MView != undefined) {
                loaded.StandardTableM2MView(responseData.StandardTableM2MView);
            }
            if (responseData.SearchEditorView != undefined) {
                loaded.SearchEditorView(responseData.SearchEditorView);
            }
            if (responseData.SearchHeaderView != undefined) {
                loaded.SearchHeaderView(responseData.SearchHeaderView);
            }
            if (responseData.SearchRowView != undefined) {
                loaded.SearchRowView(responseData.SearchRowView);
            }
            if (responseData.SearchListView != undefined) {
                loaded.SearchListView(responseData.SearchListView);
            }
            if (responseData.DisplayReadOnly != undefined) {
                loaded.DisplayReadOnly(responseData.DisplayReadOnly);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            if (responseData.MVCAttributes != null && responseData.MVCAttributes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MVCAttributes.length; i++) {
                    items.push(new smapi.entities.BuilderEntityFieldMVCAttributeModel().LoadFromResponse(responseData.MVCAttributes[i]));
                }
                loaded.MVCAttributes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntityField', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FieldOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AttributeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DisplayName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FieldName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DefaultValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DataLength.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Precision.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Scale.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MinimumDataLength.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HintMask.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DisplayMask.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ProviderID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ZoneName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.InheritedID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.MigrationDefaultValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AttributeForRelationship.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.AggregateRelationship.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Label.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ShortLabel.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Tooltip.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.Prompt.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MinimumValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MaximumValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ValidationRegExStr.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 500,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '500')
            }
        });
        this.InvalidMessage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourceType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourceDisplay.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourceValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourceFilter.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortDirection.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.FieldCharacteristics.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.RelatedField.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.TitledDisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.DisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.TitledResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateSeqDownstreamOperator.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DateSeqUpstreamOperator.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DateSeqPathToDownstreamDate.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DateSeqPathToUpstreamDate.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PathToCurrency.extend({
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StaticSectionView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PopupEditorView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ListTableHeaderView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ListTableRowView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StandardTableHeaderView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StandardTableRowView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StandardListView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StandardTableM2MView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SearchEditorView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SearchHeaderView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SearchRowView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SearchListView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityRelationshipModel(options) {
        var defaults = {
            BuilderEntityID: 0,
            ClassType: 0,
            AttributeName: '',
            FieldOrdinal: 0,
            DataType: '',
            SimpleDataType: '',
            RelationShipType: '',
            DefaultValue: '',
            Label: '',
            Description: '',
            ShortLabel: '',
            Prompt: '',
            HasGetter: false,
            HasSetter: false,
            IsFK: false,
            IsRequired: false,
            IsInherited: false,
            IsAnchor: false,
            InPartial: false,
            Aggregated: false,
            InheritedID: null,
            CascadeAction: '',
            CsvDictionaryKeys: '',
            Transient: false,
            AggregateRelationship: '',
            ParentAttribute: '',
            BackpointedAttribute: '',
            TableName: '',
            IndexerType: '',
            IsObsolete: false,
            ForeignKeyName: '',
            HierarchyPart: null,
            InitializerPart: null,
            Characteristics: null,
            SearchField: false,
            SearchResultField: false,
            PopupSearchField: false,
            PopupSearchResultField: false,
            LiveSearchResult: false,
            PopupJsonResult: false,
            SVDisplayField: false,
            TOCTableField: false,
            TOCListField: false,
            Hidden: false,
            IsParent: false,
            Context: false,
            SearchFieldDepth: 0,
            TitledDisplayGroup: '',
            DisplayGroup: '',
            EditorMode: null,
            SearchMode: null,
            TOCItemMode: null,
            HeaderField: false,
            ShortForm: false,
            LongForm: false,
            TitledResultsGroup: '',
            ResultsGroup: '',
            ResultsOrder: 0,
            InStaticPrimary: false,
            SortOrdinal: 0,
            ApiSummaryRelationship: false,
            ApiDetailedRelationship: false,
            IsUserDefined: false,
            LockParentOnChildEdit: false,
            PackageID: null,
            TOCOrdinal: 0,
            SaveOrdinal: 0,
            NoRecursionForATO: false,
            NoRecursionForDTO: false,
            DisplayReadOnly: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderEntityID = ko.validatedObservable(settings.BuilderEntityID);
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.AttributeName = ko.validatedObservable(settings.AttributeName);
        this.FieldOrdinal = ko.validatedObservable(settings.FieldOrdinal);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.SimpleDataType = ko.validatedObservable(settings.SimpleDataType);
        this.RelationShipType = ko.validatedObservable(settings.RelationShipType);
        this.DefaultValue = ko.validatedObservable(settings.DefaultValue);
        this.Label = ko.validatedObservable(settings.Label);
        this.Description = ko.validatedObservable(settings.Description);
        this.ShortLabel = ko.validatedObservable(settings.ShortLabel);
        this.Prompt = ko.validatedObservable(settings.Prompt);
        this.HasGetter = ko.validatedObservable(settings.HasGetter);
        this.HasSetter = ko.validatedObservable(settings.HasSetter);
        this.IsFK = ko.validatedObservable(settings.IsFK);
        this.IsRequired = ko.validatedObservable(settings.IsRequired);
        this.IsInherited = ko.validatedObservable(settings.IsInherited);
        this.IsAnchor = ko.validatedObservable(settings.IsAnchor);
        this.InPartial = ko.validatedObservable(settings.InPartial);
        this.Aggregated = ko.validatedObservable(settings.Aggregated);
        this.InheritedID = ko.validatedObservable(settings.InheritedID);
        this.CascadeAction = ko.validatedObservable(settings.CascadeAction);
        this.CsvDictionaryKeys = ko.validatedObservable(settings.CsvDictionaryKeys);
        this.Transient = ko.validatedObservable(settings.Transient);
        this.AggregateRelationship = ko.validatedObservable(settings.AggregateRelationship);
        this.ParentAttribute = ko.validatedObservable(settings.ParentAttribute);
        this.BackpointedAttribute = ko.validatedObservable(settings.BackpointedAttribute);
        this.TableName = ko.validatedObservable(settings.TableName);
        this.IndexerType = ko.validatedObservable(settings.IndexerType);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.ForeignKeyName = ko.validatedObservable(settings.ForeignKeyName);
        this.HierarchyPart = ko.validatedObservable(settings.HierarchyPart);
        this.InitializerPart = ko.validatedObservable(settings.InitializerPart);
        this.Characteristics = ko.validatedObservable(settings.Characteristics);
        this.SearchField = ko.validatedObservable(settings.SearchField);
        this.SearchResultField = ko.validatedObservable(settings.SearchResultField);
        this.PopupSearchField = ko.validatedObservable(settings.PopupSearchField);
        this.PopupSearchResultField = ko.validatedObservable(settings.PopupSearchResultField);
        this.LiveSearchResult = ko.validatedObservable(settings.LiveSearchResult);
        this.PopupJsonResult = ko.validatedObservable(settings.PopupJsonResult);
        this.SVDisplayField = ko.validatedObservable(settings.SVDisplayField);
        this.TOCTableField = ko.validatedObservable(settings.TOCTableField);
        this.TOCListField = ko.validatedObservable(settings.TOCListField);
        this.Hidden = ko.validatedObservable(settings.Hidden);
        this.IsParent = ko.validatedObservable(settings.IsParent);
        this.Context = ko.validatedObservable(settings.Context);
        this.SearchFieldDepth = ko.validatedObservable(settings.SearchFieldDepth);
        this.TitledDisplayGroup = ko.validatedObservable(settings.TitledDisplayGroup);
        this.DisplayGroup = ko.validatedObservable(settings.DisplayGroup);
        this.EditorMode = ko.validatedObservable(settings.EditorMode);
        this.SearchMode = ko.validatedObservable(settings.SearchMode);
        this.TOCItemMode = ko.validatedObservable(settings.TOCItemMode);
        this.HeaderField = ko.validatedObservable(settings.HeaderField);
        this.ShortForm = ko.validatedObservable(settings.ShortForm);
        this.LongForm = ko.validatedObservable(settings.LongForm);
        this.TitledResultsGroup = ko.validatedObservable(settings.TitledResultsGroup);
        this.ResultsGroup = ko.validatedObservable(settings.ResultsGroup);
        this.ResultsOrder = ko.validatedObservable(settings.ResultsOrder);
        this.InStaticPrimary = ko.validatedObservable(settings.InStaticPrimary);
        this.SortOrdinal = ko.validatedObservable(settings.SortOrdinal);
        this.ApiSummaryRelationship = ko.validatedObservable(settings.ApiSummaryRelationship);
        this.ApiDetailedRelationship = ko.validatedObservable(settings.ApiDetailedRelationship);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.LockParentOnChildEdit = ko.validatedObservable(settings.LockParentOnChildEdit);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.TOCOrdinal = ko.validatedObservable(settings.TOCOrdinal);
        this.SaveOrdinal = ko.validatedObservable(settings.SaveOrdinal);
        this.NoRecursionForATO = ko.validatedObservable(settings.NoRecursionForATO);
        this.NoRecursionForDTO = ko.validatedObservable(settings.NoRecursionForDTO);
        this.DisplayReadOnly = ko.validatedObservable(settings.DisplayReadOnly);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.RelationshipLinks = ko.observableArray([]);
        this.Package = ko.observable();
        this.MVCAttributes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderEntityID != undefined) {
                loaded.BuilderEntityID(responseData.BuilderEntityID);
            }
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.AttributeName != undefined) {
                loaded.AttributeName(responseData.AttributeName);
            }
            if (responseData.FieldOrdinal != undefined) {
                loaded.FieldOrdinal(responseData.FieldOrdinal);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.SimpleDataType != undefined) {
                loaded.SimpleDataType(responseData.SimpleDataType);
            }
            if (responseData.RelationShipType != undefined) {
                loaded.RelationShipType(responseData.RelationShipType);
            }
            if (responseData.DefaultValue != undefined) {
                loaded.DefaultValue(responseData.DefaultValue);
            }
            if (responseData.Label != undefined) {
                loaded.Label(responseData.Label);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ShortLabel != undefined) {
                loaded.ShortLabel(responseData.ShortLabel);
            }
            if (responseData.Prompt != undefined) {
                loaded.Prompt(responseData.Prompt);
            }
            if (responseData.HasGetter != undefined) {
                loaded.HasGetter(responseData.HasGetter);
            }
            if (responseData.HasSetter != undefined) {
                loaded.HasSetter(responseData.HasSetter);
            }
            if (responseData.IsFK != undefined) {
                loaded.IsFK(responseData.IsFK);
            }
            if (responseData.IsRequired != undefined) {
                loaded.IsRequired(responseData.IsRequired);
            }
            if (responseData.IsInherited != undefined) {
                loaded.IsInherited(responseData.IsInherited);
            }
            if (responseData.IsAnchor != undefined) {
                loaded.IsAnchor(responseData.IsAnchor);
            }
            if (responseData.InPartial != undefined) {
                loaded.InPartial(responseData.InPartial);
            }
            if (responseData.Aggregated != undefined) {
                loaded.Aggregated(responseData.Aggregated);
            }
            if (responseData.InheritedID != undefined) {
                loaded.InheritedID(responseData.InheritedID);
            }
            if (responseData.CascadeAction != undefined) {
                loaded.CascadeAction(responseData.CascadeAction);
            }
            if (responseData.CsvDictionaryKeys != undefined) {
                loaded.CsvDictionaryKeys(responseData.CsvDictionaryKeys);
            }
            if (responseData.Transient != undefined) {
                loaded.Transient(responseData.Transient);
            }
            if (responseData.AggregateRelationship != undefined) {
                loaded.AggregateRelationship(responseData.AggregateRelationship);
            }
            if (responseData.ParentAttribute != undefined) {
                loaded.ParentAttribute(responseData.ParentAttribute);
            }
            if (responseData.BackpointedAttribute != undefined) {
                loaded.BackpointedAttribute(responseData.BackpointedAttribute);
            }
            if (responseData.TableName != undefined) {
                loaded.TableName(responseData.TableName);
            }
            if (responseData.IndexerType != undefined) {
                loaded.IndexerType(responseData.IndexerType);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.ForeignKeyName != undefined) {
                loaded.ForeignKeyName(responseData.ForeignKeyName);
            }
            if (responseData.HierarchyPart != undefined) {
                loaded.HierarchyPart(responseData.HierarchyPart);
            }
            if (responseData.InitializerPart != undefined) {
                loaded.InitializerPart(responseData.InitializerPart);
            }
            if (responseData.Characteristics != undefined) {
                loaded.Characteristics(responseData.Characteristics);
            }
            if (responseData.SearchField != undefined) {
                loaded.SearchField(responseData.SearchField);
            }
            if (responseData.SearchResultField != undefined) {
                loaded.SearchResultField(responseData.SearchResultField);
            }
            if (responseData.PopupSearchField != undefined) {
                loaded.PopupSearchField(responseData.PopupSearchField);
            }
            if (responseData.PopupSearchResultField != undefined) {
                loaded.PopupSearchResultField(responseData.PopupSearchResultField);
            }
            if (responseData.LiveSearchResult != undefined) {
                loaded.LiveSearchResult(responseData.LiveSearchResult);
            }
            if (responseData.PopupJsonResult != undefined) {
                loaded.PopupJsonResult(responseData.PopupJsonResult);
            }
            if (responseData.SVDisplayField != undefined) {
                loaded.SVDisplayField(responseData.SVDisplayField);
            }
            if (responseData.TOCTableField != undefined) {
                loaded.TOCTableField(responseData.TOCTableField);
            }
            if (responseData.TOCListField != undefined) {
                loaded.TOCListField(responseData.TOCListField);
            }
            if (responseData.Hidden != undefined) {
                loaded.Hidden(responseData.Hidden);
            }
            if (responseData.IsParent != undefined) {
                loaded.IsParent(responseData.IsParent);
            }
            if (responseData.Context != undefined) {
                loaded.Context(responseData.Context);
            }
            if (responseData.SearchFieldDepth != undefined) {
                loaded.SearchFieldDepth(responseData.SearchFieldDepth);
            }
            if (responseData.TitledDisplayGroup != undefined) {
                loaded.TitledDisplayGroup(responseData.TitledDisplayGroup);
            }
            if (responseData.DisplayGroup != undefined) {
                loaded.DisplayGroup(responseData.DisplayGroup);
            }
            if (responseData.EditorMode != undefined) {
                loaded.EditorMode(responseData.EditorMode);
            }
            if (responseData.SearchMode != undefined) {
                loaded.SearchMode(responseData.SearchMode);
            }
            if (responseData.TOCItemMode != undefined) {
                loaded.TOCItemMode(responseData.TOCItemMode);
            }
            if (responseData.HeaderField != undefined) {
                loaded.HeaderField(responseData.HeaderField);
            }
            if (responseData.ShortForm != undefined) {
                loaded.ShortForm(responseData.ShortForm);
            }
            if (responseData.LongForm != undefined) {
                loaded.LongForm(responseData.LongForm);
            }
            if (responseData.TitledResultsGroup != undefined) {
                loaded.TitledResultsGroup(responseData.TitledResultsGroup);
            }
            if (responseData.ResultsGroup != undefined) {
                loaded.ResultsGroup(responseData.ResultsGroup);
            }
            if (responseData.ResultsOrder != undefined) {
                loaded.ResultsOrder(responseData.ResultsOrder);
            }
            if (responseData.InStaticPrimary != undefined) {
                loaded.InStaticPrimary(responseData.InStaticPrimary);
            }
            if (responseData.SortOrdinal != undefined) {
                loaded.SortOrdinal(responseData.SortOrdinal);
            }
            if (responseData.ApiSummaryRelationship != undefined) {
                loaded.ApiSummaryRelationship(responseData.ApiSummaryRelationship);
            }
            if (responseData.ApiDetailedRelationship != undefined) {
                loaded.ApiDetailedRelationship(responseData.ApiDetailedRelationship);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.LockParentOnChildEdit != undefined) {
                loaded.LockParentOnChildEdit(responseData.LockParentOnChildEdit);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.TOCOrdinal != undefined) {
                loaded.TOCOrdinal(responseData.TOCOrdinal);
            }
            if (responseData.SaveOrdinal != undefined) {
                loaded.SaveOrdinal(responseData.SaveOrdinal);
            }
            if (responseData.NoRecursionForATO != undefined) {
                loaded.NoRecursionForATO(responseData.NoRecursionForATO);
            }
            if (responseData.NoRecursionForDTO != undefined) {
                loaded.NoRecursionForDTO(responseData.NoRecursionForDTO);
            }
            if (responseData.DisplayReadOnly != undefined) {
                loaded.DisplayReadOnly(responseData.DisplayReadOnly);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.RelationshipLinks != null && responseData.RelationshipLinks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RelationshipLinks.length; i++) {
                    items.push(new smapi.entities.BuilderEntityRelationshipLinkModel().LoadFromResponse(responseData.RelationshipLinks[i]));
                }
                loaded.RelationshipLinks(items);
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            if (responseData.MVCAttributes != null && responseData.MVCAttributes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MVCAttributes.length; i++) {
                    items.push(new smapi.entities.BuilderEntityRelationshipMVCAttributeModel().LoadFromResponse(responseData.MVCAttributes[i]));
                }
                loaded.MVCAttributes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntityRelationship', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AttributeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.FieldOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SimpleDataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RelationShipType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DefaultValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Label.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.ShortLabel.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Prompt.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InheritedID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.CascadeAction.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.CsvDictionaryKeys.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.AggregateRelationship.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ParentAttribute.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.BackpointedAttribute.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.TableName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.IndexerType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ForeignKeyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.HierarchyPart.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.InitializerPart.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.Characteristics.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SearchFieldDepth.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TitledDisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.DisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.EditorMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SearchMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TOCItemMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TitledResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TOCOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SaveOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityLookupRelationshipModel(options) {
        var defaults = {
            GroupIdentifierField: '',
            GroupIdentifierValue: '',
            GroupParentLookup: '',
            GroupBinding: '',
            QueryToParentLookup: '',
            BuilderEntityID: 0,
            ClassType: 0,
            AttributeName: '',
            FieldOrdinal: 0,
            DataType: '',
            SimpleDataType: '',
            RelationShipType: '',
            DefaultValue: '',
            Label: '',
            Description: '',
            ShortLabel: '',
            Prompt: '',
            HasGetter: false,
            HasSetter: false,
            IsFK: false,
            IsRequired: false,
            IsInherited: false,
            IsAnchor: false,
            InPartial: false,
            Aggregated: false,
            InheritedID: null,
            CascadeAction: '',
            CsvDictionaryKeys: '',
            Transient: false,
            AggregateRelationship: '',
            ParentAttribute: '',
            BackpointedAttribute: '',
            TableName: '',
            IndexerType: '',
            IsObsolete: false,
            ForeignKeyName: '',
            HierarchyPart: null,
            InitializerPart: null,
            Characteristics: null,
            SearchField: false,
            SearchResultField: false,
            PopupSearchField: false,
            PopupSearchResultField: false,
            LiveSearchResult: false,
            PopupJsonResult: false,
            SVDisplayField: false,
            TOCTableField: false,
            TOCListField: false,
            Hidden: false,
            IsParent: false,
            Context: false,
            SearchFieldDepth: 0,
            TitledDisplayGroup: '',
            DisplayGroup: '',
            EditorMode: null,
            SearchMode: null,
            TOCItemMode: null,
            HeaderField: false,
            ShortForm: false,
            LongForm: false,
            TitledResultsGroup: '',
            ResultsGroup: '',
            ResultsOrder: 0,
            InStaticPrimary: false,
            SortOrdinal: 0,
            ApiSummaryRelationship: false,
            ApiDetailedRelationship: false,
            IsUserDefined: false,
            LockParentOnChildEdit: false,
            PackageID: null,
            TOCOrdinal: 0,
            SaveOrdinal: 0,
            NoRecursionForATO: false,
            NoRecursionForDTO: false,
            DisplayReadOnly: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.GroupIdentifierField = ko.validatedObservable(settings.GroupIdentifierField);
        this.GroupIdentifierValue = ko.validatedObservable(settings.GroupIdentifierValue);
        this.GroupParentLookup = ko.validatedObservable(settings.GroupParentLookup);
        this.GroupBinding = ko.validatedObservable(settings.GroupBinding);
        this.QueryToParentLookup = ko.validatedObservable(settings.QueryToParentLookup);
        this.BuilderEntityID = ko.validatedObservable(settings.BuilderEntityID);
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.AttributeName = ko.validatedObservable(settings.AttributeName);
        this.FieldOrdinal = ko.validatedObservable(settings.FieldOrdinal);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.SimpleDataType = ko.validatedObservable(settings.SimpleDataType);
        this.RelationShipType = ko.validatedObservable(settings.RelationShipType);
        this.DefaultValue = ko.validatedObservable(settings.DefaultValue);
        this.Label = ko.validatedObservable(settings.Label);
        this.Description = ko.validatedObservable(settings.Description);
        this.ShortLabel = ko.validatedObservable(settings.ShortLabel);
        this.Prompt = ko.validatedObservable(settings.Prompt);
        this.HasGetter = ko.validatedObservable(settings.HasGetter);
        this.HasSetter = ko.validatedObservable(settings.HasSetter);
        this.IsFK = ko.validatedObservable(settings.IsFK);
        this.IsRequired = ko.validatedObservable(settings.IsRequired);
        this.IsInherited = ko.validatedObservable(settings.IsInherited);
        this.IsAnchor = ko.validatedObservable(settings.IsAnchor);
        this.InPartial = ko.validatedObservable(settings.InPartial);
        this.Aggregated = ko.validatedObservable(settings.Aggregated);
        this.InheritedID = ko.validatedObservable(settings.InheritedID);
        this.CascadeAction = ko.validatedObservable(settings.CascadeAction);
        this.CsvDictionaryKeys = ko.validatedObservable(settings.CsvDictionaryKeys);
        this.Transient = ko.validatedObservable(settings.Transient);
        this.AggregateRelationship = ko.validatedObservable(settings.AggregateRelationship);
        this.ParentAttribute = ko.validatedObservable(settings.ParentAttribute);
        this.BackpointedAttribute = ko.validatedObservable(settings.BackpointedAttribute);
        this.TableName = ko.validatedObservable(settings.TableName);
        this.IndexerType = ko.validatedObservable(settings.IndexerType);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.ForeignKeyName = ko.validatedObservable(settings.ForeignKeyName);
        this.HierarchyPart = ko.validatedObservable(settings.HierarchyPart);
        this.InitializerPart = ko.validatedObservable(settings.InitializerPart);
        this.Characteristics = ko.validatedObservable(settings.Characteristics);
        this.SearchField = ko.validatedObservable(settings.SearchField);
        this.SearchResultField = ko.validatedObservable(settings.SearchResultField);
        this.PopupSearchField = ko.validatedObservable(settings.PopupSearchField);
        this.PopupSearchResultField = ko.validatedObservable(settings.PopupSearchResultField);
        this.LiveSearchResult = ko.validatedObservable(settings.LiveSearchResult);
        this.PopupJsonResult = ko.validatedObservable(settings.PopupJsonResult);
        this.SVDisplayField = ko.validatedObservable(settings.SVDisplayField);
        this.TOCTableField = ko.validatedObservable(settings.TOCTableField);
        this.TOCListField = ko.validatedObservable(settings.TOCListField);
        this.Hidden = ko.validatedObservable(settings.Hidden);
        this.IsParent = ko.validatedObservable(settings.IsParent);
        this.Context = ko.validatedObservable(settings.Context);
        this.SearchFieldDepth = ko.validatedObservable(settings.SearchFieldDepth);
        this.TitledDisplayGroup = ko.validatedObservable(settings.TitledDisplayGroup);
        this.DisplayGroup = ko.validatedObservable(settings.DisplayGroup);
        this.EditorMode = ko.validatedObservable(settings.EditorMode);
        this.SearchMode = ko.validatedObservable(settings.SearchMode);
        this.TOCItemMode = ko.validatedObservable(settings.TOCItemMode);
        this.HeaderField = ko.validatedObservable(settings.HeaderField);
        this.ShortForm = ko.validatedObservable(settings.ShortForm);
        this.LongForm = ko.validatedObservable(settings.LongForm);
        this.TitledResultsGroup = ko.validatedObservable(settings.TitledResultsGroup);
        this.ResultsGroup = ko.validatedObservable(settings.ResultsGroup);
        this.ResultsOrder = ko.validatedObservable(settings.ResultsOrder);
        this.InStaticPrimary = ko.validatedObservable(settings.InStaticPrimary);
        this.SortOrdinal = ko.validatedObservable(settings.SortOrdinal);
        this.ApiSummaryRelationship = ko.validatedObservable(settings.ApiSummaryRelationship);
        this.ApiDetailedRelationship = ko.validatedObservable(settings.ApiDetailedRelationship);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.LockParentOnChildEdit = ko.validatedObservable(settings.LockParentOnChildEdit);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.TOCOrdinal = ko.validatedObservable(settings.TOCOrdinal);
        this.SaveOrdinal = ko.validatedObservable(settings.SaveOrdinal);
        this.NoRecursionForATO = ko.validatedObservable(settings.NoRecursionForATO);
        this.NoRecursionForDTO = ko.validatedObservable(settings.NoRecursionForDTO);
        this.DisplayReadOnly = ko.validatedObservable(settings.DisplayReadOnly);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.RelationshipLinks = ko.observableArray([]);
        this.Package = ko.observable();
        this.MVCAttributes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.GroupIdentifierField != undefined) {
                loaded.GroupIdentifierField(responseData.GroupIdentifierField);
            }
            if (responseData.GroupIdentifierValue != undefined) {
                loaded.GroupIdentifierValue(responseData.GroupIdentifierValue);
            }
            if (responseData.GroupParentLookup != undefined) {
                loaded.GroupParentLookup(responseData.GroupParentLookup);
            }
            if (responseData.GroupBinding != undefined) {
                loaded.GroupBinding(responseData.GroupBinding);
            }
            if (responseData.QueryToParentLookup != undefined) {
                loaded.QueryToParentLookup(responseData.QueryToParentLookup);
            }
            if (responseData.BuilderEntityID != undefined) {
                loaded.BuilderEntityID(responseData.BuilderEntityID);
            }
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.AttributeName != undefined) {
                loaded.AttributeName(responseData.AttributeName);
            }
            if (responseData.FieldOrdinal != undefined) {
                loaded.FieldOrdinal(responseData.FieldOrdinal);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.SimpleDataType != undefined) {
                loaded.SimpleDataType(responseData.SimpleDataType);
            }
            if (responseData.RelationShipType != undefined) {
                loaded.RelationShipType(responseData.RelationShipType);
            }
            if (responseData.DefaultValue != undefined) {
                loaded.DefaultValue(responseData.DefaultValue);
            }
            if (responseData.Label != undefined) {
                loaded.Label(responseData.Label);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ShortLabel != undefined) {
                loaded.ShortLabel(responseData.ShortLabel);
            }
            if (responseData.Prompt != undefined) {
                loaded.Prompt(responseData.Prompt);
            }
            if (responseData.HasGetter != undefined) {
                loaded.HasGetter(responseData.HasGetter);
            }
            if (responseData.HasSetter != undefined) {
                loaded.HasSetter(responseData.HasSetter);
            }
            if (responseData.IsFK != undefined) {
                loaded.IsFK(responseData.IsFK);
            }
            if (responseData.IsRequired != undefined) {
                loaded.IsRequired(responseData.IsRequired);
            }
            if (responseData.IsInherited != undefined) {
                loaded.IsInherited(responseData.IsInherited);
            }
            if (responseData.IsAnchor != undefined) {
                loaded.IsAnchor(responseData.IsAnchor);
            }
            if (responseData.InPartial != undefined) {
                loaded.InPartial(responseData.InPartial);
            }
            if (responseData.Aggregated != undefined) {
                loaded.Aggregated(responseData.Aggregated);
            }
            if (responseData.InheritedID != undefined) {
                loaded.InheritedID(responseData.InheritedID);
            }
            if (responseData.CascadeAction != undefined) {
                loaded.CascadeAction(responseData.CascadeAction);
            }
            if (responseData.CsvDictionaryKeys != undefined) {
                loaded.CsvDictionaryKeys(responseData.CsvDictionaryKeys);
            }
            if (responseData.Transient != undefined) {
                loaded.Transient(responseData.Transient);
            }
            if (responseData.AggregateRelationship != undefined) {
                loaded.AggregateRelationship(responseData.AggregateRelationship);
            }
            if (responseData.ParentAttribute != undefined) {
                loaded.ParentAttribute(responseData.ParentAttribute);
            }
            if (responseData.BackpointedAttribute != undefined) {
                loaded.BackpointedAttribute(responseData.BackpointedAttribute);
            }
            if (responseData.TableName != undefined) {
                loaded.TableName(responseData.TableName);
            }
            if (responseData.IndexerType != undefined) {
                loaded.IndexerType(responseData.IndexerType);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.ForeignKeyName != undefined) {
                loaded.ForeignKeyName(responseData.ForeignKeyName);
            }
            if (responseData.HierarchyPart != undefined) {
                loaded.HierarchyPart(responseData.HierarchyPart);
            }
            if (responseData.InitializerPart != undefined) {
                loaded.InitializerPart(responseData.InitializerPart);
            }
            if (responseData.Characteristics != undefined) {
                loaded.Characteristics(responseData.Characteristics);
            }
            if (responseData.SearchField != undefined) {
                loaded.SearchField(responseData.SearchField);
            }
            if (responseData.SearchResultField != undefined) {
                loaded.SearchResultField(responseData.SearchResultField);
            }
            if (responseData.PopupSearchField != undefined) {
                loaded.PopupSearchField(responseData.PopupSearchField);
            }
            if (responseData.PopupSearchResultField != undefined) {
                loaded.PopupSearchResultField(responseData.PopupSearchResultField);
            }
            if (responseData.LiveSearchResult != undefined) {
                loaded.LiveSearchResult(responseData.LiveSearchResult);
            }
            if (responseData.PopupJsonResult != undefined) {
                loaded.PopupJsonResult(responseData.PopupJsonResult);
            }
            if (responseData.SVDisplayField != undefined) {
                loaded.SVDisplayField(responseData.SVDisplayField);
            }
            if (responseData.TOCTableField != undefined) {
                loaded.TOCTableField(responseData.TOCTableField);
            }
            if (responseData.TOCListField != undefined) {
                loaded.TOCListField(responseData.TOCListField);
            }
            if (responseData.Hidden != undefined) {
                loaded.Hidden(responseData.Hidden);
            }
            if (responseData.IsParent != undefined) {
                loaded.IsParent(responseData.IsParent);
            }
            if (responseData.Context != undefined) {
                loaded.Context(responseData.Context);
            }
            if (responseData.SearchFieldDepth != undefined) {
                loaded.SearchFieldDepth(responseData.SearchFieldDepth);
            }
            if (responseData.TitledDisplayGroup != undefined) {
                loaded.TitledDisplayGroup(responseData.TitledDisplayGroup);
            }
            if (responseData.DisplayGroup != undefined) {
                loaded.DisplayGroup(responseData.DisplayGroup);
            }
            if (responseData.EditorMode != undefined) {
                loaded.EditorMode(responseData.EditorMode);
            }
            if (responseData.SearchMode != undefined) {
                loaded.SearchMode(responseData.SearchMode);
            }
            if (responseData.TOCItemMode != undefined) {
                loaded.TOCItemMode(responseData.TOCItemMode);
            }
            if (responseData.HeaderField != undefined) {
                loaded.HeaderField(responseData.HeaderField);
            }
            if (responseData.ShortForm != undefined) {
                loaded.ShortForm(responseData.ShortForm);
            }
            if (responseData.LongForm != undefined) {
                loaded.LongForm(responseData.LongForm);
            }
            if (responseData.TitledResultsGroup != undefined) {
                loaded.TitledResultsGroup(responseData.TitledResultsGroup);
            }
            if (responseData.ResultsGroup != undefined) {
                loaded.ResultsGroup(responseData.ResultsGroup);
            }
            if (responseData.ResultsOrder != undefined) {
                loaded.ResultsOrder(responseData.ResultsOrder);
            }
            if (responseData.InStaticPrimary != undefined) {
                loaded.InStaticPrimary(responseData.InStaticPrimary);
            }
            if (responseData.SortOrdinal != undefined) {
                loaded.SortOrdinal(responseData.SortOrdinal);
            }
            if (responseData.ApiSummaryRelationship != undefined) {
                loaded.ApiSummaryRelationship(responseData.ApiSummaryRelationship);
            }
            if (responseData.ApiDetailedRelationship != undefined) {
                loaded.ApiDetailedRelationship(responseData.ApiDetailedRelationship);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.LockParentOnChildEdit != undefined) {
                loaded.LockParentOnChildEdit(responseData.LockParentOnChildEdit);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.TOCOrdinal != undefined) {
                loaded.TOCOrdinal(responseData.TOCOrdinal);
            }
            if (responseData.SaveOrdinal != undefined) {
                loaded.SaveOrdinal(responseData.SaveOrdinal);
            }
            if (responseData.NoRecursionForATO != undefined) {
                loaded.NoRecursionForATO(responseData.NoRecursionForATO);
            }
            if (responseData.NoRecursionForDTO != undefined) {
                loaded.NoRecursionForDTO(responseData.NoRecursionForDTO);
            }
            if (responseData.DisplayReadOnly != undefined) {
                loaded.DisplayReadOnly(responseData.DisplayReadOnly);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.RelationshipLinks != null && responseData.RelationshipLinks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RelationshipLinks.length; i++) {
                    items.push(new smapi.entities.BuilderEntityRelationshipLinkModel().LoadFromResponse(responseData.RelationshipLinks[i]));
                }
                loaded.RelationshipLinks(items);
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            if (responseData.MVCAttributes != null && responseData.MVCAttributes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MVCAttributes.length; i++) {
                    items.push(new smapi.entities.BuilderEntityRelationshipMVCAttributeModel().LoadFromResponse(responseData.MVCAttributes[i]));
                }
                loaded.MVCAttributes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntityLookupRelationship', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.GroupIdentifierField.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupIdentifierValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupParentLookup.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupBinding.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.QueryToParentLookup.extend({
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.BuilderEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AttributeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.FieldOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SimpleDataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RelationShipType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DefaultValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Label.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.ShortLabel.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Prompt.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InheritedID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.CascadeAction.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.CsvDictionaryKeys.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.AggregateRelationship.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ParentAttribute.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.BackpointedAttribute.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.TableName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.IndexerType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ForeignKeyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.HierarchyPart.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.InitializerPart.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.Characteristics.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SearchFieldDepth.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TitledDisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.DisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.EditorMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SearchMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TOCItemMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TitledResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TOCOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SaveOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BulderEntityBusinessMeaningRelationshipModel(options) {
        var defaults = {
            BuilderEntityID: 0,
            ClassType: 0,
            AttributeName: '',
            FieldOrdinal: 0,
            DataType: '',
            SimpleDataType: '',
            RelationShipType: '',
            DefaultValue: '',
            Label: '',
            Description: '',
            ShortLabel: '',
            Prompt: '',
            HasGetter: false,
            HasSetter: false,
            IsFK: false,
            IsRequired: false,
            IsInherited: false,
            IsAnchor: false,
            InPartial: false,
            Aggregated: false,
            InheritedID: null,
            CascadeAction: '',
            CsvDictionaryKeys: '',
            Transient: false,
            AggregateRelationship: '',
            ParentAttribute: '',
            BackpointedAttribute: '',
            TableName: '',
            IndexerType: '',
            IsObsolete: false,
            ForeignKeyName: '',
            HierarchyPart: null,
            InitializerPart: null,
            Characteristics: null,
            SearchField: false,
            SearchResultField: false,
            PopupSearchField: false,
            PopupSearchResultField: false,
            LiveSearchResult: false,
            PopupJsonResult: false,
            SVDisplayField: false,
            TOCTableField: false,
            TOCListField: false,
            Hidden: false,
            IsParent: false,
            Context: false,
            SearchFieldDepth: 0,
            TitledDisplayGroup: '',
            DisplayGroup: '',
            EditorMode: null,
            SearchMode: null,
            TOCItemMode: null,
            HeaderField: false,
            ShortForm: false,
            LongForm: false,
            TitledResultsGroup: '',
            ResultsGroup: '',
            ResultsOrder: 0,
            InStaticPrimary: false,
            SortOrdinal: 0,
            ApiSummaryRelationship: false,
            ApiDetailedRelationship: false,
            IsUserDefined: false,
            LockParentOnChildEdit: false,
            PackageID: null,
            TOCOrdinal: 0,
            SaveOrdinal: 0,
            NoRecursionForATO: false,
            NoRecursionForDTO: false,
            DisplayReadOnly: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderEntityID = ko.validatedObservable(settings.BuilderEntityID);
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.AttributeName = ko.validatedObservable(settings.AttributeName);
        this.FieldOrdinal = ko.validatedObservable(settings.FieldOrdinal);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.SimpleDataType = ko.validatedObservable(settings.SimpleDataType);
        this.RelationShipType = ko.validatedObservable(settings.RelationShipType);
        this.DefaultValue = ko.validatedObservable(settings.DefaultValue);
        this.Label = ko.validatedObservable(settings.Label);
        this.Description = ko.validatedObservable(settings.Description);
        this.ShortLabel = ko.validatedObservable(settings.ShortLabel);
        this.Prompt = ko.validatedObservable(settings.Prompt);
        this.HasGetter = ko.validatedObservable(settings.HasGetter);
        this.HasSetter = ko.validatedObservable(settings.HasSetter);
        this.IsFK = ko.validatedObservable(settings.IsFK);
        this.IsRequired = ko.validatedObservable(settings.IsRequired);
        this.IsInherited = ko.validatedObservable(settings.IsInherited);
        this.IsAnchor = ko.validatedObservable(settings.IsAnchor);
        this.InPartial = ko.validatedObservable(settings.InPartial);
        this.Aggregated = ko.validatedObservable(settings.Aggregated);
        this.InheritedID = ko.validatedObservable(settings.InheritedID);
        this.CascadeAction = ko.validatedObservable(settings.CascadeAction);
        this.CsvDictionaryKeys = ko.validatedObservable(settings.CsvDictionaryKeys);
        this.Transient = ko.validatedObservable(settings.Transient);
        this.AggregateRelationship = ko.validatedObservable(settings.AggregateRelationship);
        this.ParentAttribute = ko.validatedObservable(settings.ParentAttribute);
        this.BackpointedAttribute = ko.validatedObservable(settings.BackpointedAttribute);
        this.TableName = ko.validatedObservable(settings.TableName);
        this.IndexerType = ko.validatedObservable(settings.IndexerType);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.ForeignKeyName = ko.validatedObservable(settings.ForeignKeyName);
        this.HierarchyPart = ko.validatedObservable(settings.HierarchyPart);
        this.InitializerPart = ko.validatedObservable(settings.InitializerPart);
        this.Characteristics = ko.validatedObservable(settings.Characteristics);
        this.SearchField = ko.validatedObservable(settings.SearchField);
        this.SearchResultField = ko.validatedObservable(settings.SearchResultField);
        this.PopupSearchField = ko.validatedObservable(settings.PopupSearchField);
        this.PopupSearchResultField = ko.validatedObservable(settings.PopupSearchResultField);
        this.LiveSearchResult = ko.validatedObservable(settings.LiveSearchResult);
        this.PopupJsonResult = ko.validatedObservable(settings.PopupJsonResult);
        this.SVDisplayField = ko.validatedObservable(settings.SVDisplayField);
        this.TOCTableField = ko.validatedObservable(settings.TOCTableField);
        this.TOCListField = ko.validatedObservable(settings.TOCListField);
        this.Hidden = ko.validatedObservable(settings.Hidden);
        this.IsParent = ko.validatedObservable(settings.IsParent);
        this.Context = ko.validatedObservable(settings.Context);
        this.SearchFieldDepth = ko.validatedObservable(settings.SearchFieldDepth);
        this.TitledDisplayGroup = ko.validatedObservable(settings.TitledDisplayGroup);
        this.DisplayGroup = ko.validatedObservable(settings.DisplayGroup);
        this.EditorMode = ko.validatedObservable(settings.EditorMode);
        this.SearchMode = ko.validatedObservable(settings.SearchMode);
        this.TOCItemMode = ko.validatedObservable(settings.TOCItemMode);
        this.HeaderField = ko.validatedObservable(settings.HeaderField);
        this.ShortForm = ko.validatedObservable(settings.ShortForm);
        this.LongForm = ko.validatedObservable(settings.LongForm);
        this.TitledResultsGroup = ko.validatedObservable(settings.TitledResultsGroup);
        this.ResultsGroup = ko.validatedObservable(settings.ResultsGroup);
        this.ResultsOrder = ko.validatedObservable(settings.ResultsOrder);
        this.InStaticPrimary = ko.validatedObservable(settings.InStaticPrimary);
        this.SortOrdinal = ko.validatedObservable(settings.SortOrdinal);
        this.ApiSummaryRelationship = ko.validatedObservable(settings.ApiSummaryRelationship);
        this.ApiDetailedRelationship = ko.validatedObservable(settings.ApiDetailedRelationship);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.LockParentOnChildEdit = ko.validatedObservable(settings.LockParentOnChildEdit);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.TOCOrdinal = ko.validatedObservable(settings.TOCOrdinal);
        this.SaveOrdinal = ko.validatedObservable(settings.SaveOrdinal);
        this.NoRecursionForATO = ko.validatedObservable(settings.NoRecursionForATO);
        this.NoRecursionForDTO = ko.validatedObservable(settings.NoRecursionForDTO);
        this.DisplayReadOnly = ko.validatedObservable(settings.DisplayReadOnly);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.RelationshipLinks = ko.observableArray([]);
        this.Package = ko.observable();
        this.MVCAttributes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderEntityID != undefined) {
                loaded.BuilderEntityID(responseData.BuilderEntityID);
            }
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.AttributeName != undefined) {
                loaded.AttributeName(responseData.AttributeName);
            }
            if (responseData.FieldOrdinal != undefined) {
                loaded.FieldOrdinal(responseData.FieldOrdinal);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.SimpleDataType != undefined) {
                loaded.SimpleDataType(responseData.SimpleDataType);
            }
            if (responseData.RelationShipType != undefined) {
                loaded.RelationShipType(responseData.RelationShipType);
            }
            if (responseData.DefaultValue != undefined) {
                loaded.DefaultValue(responseData.DefaultValue);
            }
            if (responseData.Label != undefined) {
                loaded.Label(responseData.Label);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ShortLabel != undefined) {
                loaded.ShortLabel(responseData.ShortLabel);
            }
            if (responseData.Prompt != undefined) {
                loaded.Prompt(responseData.Prompt);
            }
            if (responseData.HasGetter != undefined) {
                loaded.HasGetter(responseData.HasGetter);
            }
            if (responseData.HasSetter != undefined) {
                loaded.HasSetter(responseData.HasSetter);
            }
            if (responseData.IsFK != undefined) {
                loaded.IsFK(responseData.IsFK);
            }
            if (responseData.IsRequired != undefined) {
                loaded.IsRequired(responseData.IsRequired);
            }
            if (responseData.IsInherited != undefined) {
                loaded.IsInherited(responseData.IsInherited);
            }
            if (responseData.IsAnchor != undefined) {
                loaded.IsAnchor(responseData.IsAnchor);
            }
            if (responseData.InPartial != undefined) {
                loaded.InPartial(responseData.InPartial);
            }
            if (responseData.Aggregated != undefined) {
                loaded.Aggregated(responseData.Aggregated);
            }
            if (responseData.InheritedID != undefined) {
                loaded.InheritedID(responseData.InheritedID);
            }
            if (responseData.CascadeAction != undefined) {
                loaded.CascadeAction(responseData.CascadeAction);
            }
            if (responseData.CsvDictionaryKeys != undefined) {
                loaded.CsvDictionaryKeys(responseData.CsvDictionaryKeys);
            }
            if (responseData.Transient != undefined) {
                loaded.Transient(responseData.Transient);
            }
            if (responseData.AggregateRelationship != undefined) {
                loaded.AggregateRelationship(responseData.AggregateRelationship);
            }
            if (responseData.ParentAttribute != undefined) {
                loaded.ParentAttribute(responseData.ParentAttribute);
            }
            if (responseData.BackpointedAttribute != undefined) {
                loaded.BackpointedAttribute(responseData.BackpointedAttribute);
            }
            if (responseData.TableName != undefined) {
                loaded.TableName(responseData.TableName);
            }
            if (responseData.IndexerType != undefined) {
                loaded.IndexerType(responseData.IndexerType);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.ForeignKeyName != undefined) {
                loaded.ForeignKeyName(responseData.ForeignKeyName);
            }
            if (responseData.HierarchyPart != undefined) {
                loaded.HierarchyPart(responseData.HierarchyPart);
            }
            if (responseData.InitializerPart != undefined) {
                loaded.InitializerPart(responseData.InitializerPart);
            }
            if (responseData.Characteristics != undefined) {
                loaded.Characteristics(responseData.Characteristics);
            }
            if (responseData.SearchField != undefined) {
                loaded.SearchField(responseData.SearchField);
            }
            if (responseData.SearchResultField != undefined) {
                loaded.SearchResultField(responseData.SearchResultField);
            }
            if (responseData.PopupSearchField != undefined) {
                loaded.PopupSearchField(responseData.PopupSearchField);
            }
            if (responseData.PopupSearchResultField != undefined) {
                loaded.PopupSearchResultField(responseData.PopupSearchResultField);
            }
            if (responseData.LiveSearchResult != undefined) {
                loaded.LiveSearchResult(responseData.LiveSearchResult);
            }
            if (responseData.PopupJsonResult != undefined) {
                loaded.PopupJsonResult(responseData.PopupJsonResult);
            }
            if (responseData.SVDisplayField != undefined) {
                loaded.SVDisplayField(responseData.SVDisplayField);
            }
            if (responseData.TOCTableField != undefined) {
                loaded.TOCTableField(responseData.TOCTableField);
            }
            if (responseData.TOCListField != undefined) {
                loaded.TOCListField(responseData.TOCListField);
            }
            if (responseData.Hidden != undefined) {
                loaded.Hidden(responseData.Hidden);
            }
            if (responseData.IsParent != undefined) {
                loaded.IsParent(responseData.IsParent);
            }
            if (responseData.Context != undefined) {
                loaded.Context(responseData.Context);
            }
            if (responseData.SearchFieldDepth != undefined) {
                loaded.SearchFieldDepth(responseData.SearchFieldDepth);
            }
            if (responseData.TitledDisplayGroup != undefined) {
                loaded.TitledDisplayGroup(responseData.TitledDisplayGroup);
            }
            if (responseData.DisplayGroup != undefined) {
                loaded.DisplayGroup(responseData.DisplayGroup);
            }
            if (responseData.EditorMode != undefined) {
                loaded.EditorMode(responseData.EditorMode);
            }
            if (responseData.SearchMode != undefined) {
                loaded.SearchMode(responseData.SearchMode);
            }
            if (responseData.TOCItemMode != undefined) {
                loaded.TOCItemMode(responseData.TOCItemMode);
            }
            if (responseData.HeaderField != undefined) {
                loaded.HeaderField(responseData.HeaderField);
            }
            if (responseData.ShortForm != undefined) {
                loaded.ShortForm(responseData.ShortForm);
            }
            if (responseData.LongForm != undefined) {
                loaded.LongForm(responseData.LongForm);
            }
            if (responseData.TitledResultsGroup != undefined) {
                loaded.TitledResultsGroup(responseData.TitledResultsGroup);
            }
            if (responseData.ResultsGroup != undefined) {
                loaded.ResultsGroup(responseData.ResultsGroup);
            }
            if (responseData.ResultsOrder != undefined) {
                loaded.ResultsOrder(responseData.ResultsOrder);
            }
            if (responseData.InStaticPrimary != undefined) {
                loaded.InStaticPrimary(responseData.InStaticPrimary);
            }
            if (responseData.SortOrdinal != undefined) {
                loaded.SortOrdinal(responseData.SortOrdinal);
            }
            if (responseData.ApiSummaryRelationship != undefined) {
                loaded.ApiSummaryRelationship(responseData.ApiSummaryRelationship);
            }
            if (responseData.ApiDetailedRelationship != undefined) {
                loaded.ApiDetailedRelationship(responseData.ApiDetailedRelationship);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.LockParentOnChildEdit != undefined) {
                loaded.LockParentOnChildEdit(responseData.LockParentOnChildEdit);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.TOCOrdinal != undefined) {
                loaded.TOCOrdinal(responseData.TOCOrdinal);
            }
            if (responseData.SaveOrdinal != undefined) {
                loaded.SaveOrdinal(responseData.SaveOrdinal);
            }
            if (responseData.NoRecursionForATO != undefined) {
                loaded.NoRecursionForATO(responseData.NoRecursionForATO);
            }
            if (responseData.NoRecursionForDTO != undefined) {
                loaded.NoRecursionForDTO(responseData.NoRecursionForDTO);
            }
            if (responseData.DisplayReadOnly != undefined) {
                loaded.DisplayReadOnly(responseData.DisplayReadOnly);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.RelationshipLinks != null && responseData.RelationshipLinks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RelationshipLinks.length; i++) {
                    items.push(new smapi.entities.BuilderEntityRelationshipLinkModel().LoadFromResponse(responseData.RelationshipLinks[i]));
                }
                loaded.RelationshipLinks(items);
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            if (responseData.MVCAttributes != null && responseData.MVCAttributes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MVCAttributes.length; i++) {
                    items.push(new smapi.entities.BuilderEntityRelationshipMVCAttributeModel().LoadFromResponse(responseData.MVCAttributes[i]));
                }
                loaded.MVCAttributes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BulderEntityBusinessMeaningRelationship', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AttributeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.FieldOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SimpleDataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RelationShipType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DefaultValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Label.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.ShortLabel.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Prompt.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InheritedID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.CascadeAction.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.CsvDictionaryKeys.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.AggregateRelationship.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ParentAttribute.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.BackpointedAttribute.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.TableName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.IndexerType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ForeignKeyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.HierarchyPart.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.InitializerPart.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.Characteristics.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SearchFieldDepth.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TitledDisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.DisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.EditorMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SearchMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TOCItemMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TitledResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TOCOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SaveOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityRelationshipLinkModel(options) {
        var defaults = {
            ParentID: 0,
            RelationshipLinkType: '',
            MyLink: '',
            OtherLink: '',
            MyLinkProperty: '',
            OtherProperty: '',
            DefaultValue: '',
            LiteralValue: '',
            LinkOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.RelationshipLinkType = ko.validatedObservable(settings.RelationshipLinkType);
        this.MyLink = ko.validatedObservable(settings.MyLink);
        this.OtherLink = ko.validatedObservable(settings.OtherLink);
        this.MyLinkProperty = ko.validatedObservable(settings.MyLinkProperty);
        this.OtherProperty = ko.validatedObservable(settings.OtherProperty);
        this.DefaultValue = ko.validatedObservable(settings.DefaultValue);
        this.LiteralValue = ko.validatedObservable(settings.LiteralValue);
        this.LinkOrder = ko.validatedObservable(settings.LinkOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.RelationshipLinkType != undefined) {
                loaded.RelationshipLinkType(responseData.RelationshipLinkType);
            }
            if (responseData.MyLink != undefined) {
                loaded.MyLink(responseData.MyLink);
            }
            if (responseData.OtherLink != undefined) {
                loaded.OtherLink(responseData.OtherLink);
            }
            if (responseData.MyLinkProperty != undefined) {
                loaded.MyLinkProperty(responseData.MyLinkProperty);
            }
            if (responseData.OtherProperty != undefined) {
                loaded.OtherProperty(responseData.OtherProperty);
            }
            if (responseData.DefaultValue != undefined) {
                loaded.DefaultValue(responseData.DefaultValue);
            }
            if (responseData.LiteralValue != undefined) {
                loaded.LiteralValue(responseData.LiteralValue);
            }
            if (responseData.LinkOrder != undefined) {
                loaded.LinkOrder(responseData.LinkOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityRelationshipModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntityRelationshipLink', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RelationshipLinkType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.MyLink.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.OtherLink.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.MyLinkProperty.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.OtherProperty.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DefaultValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LiteralValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LinkOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityQueryModel(options) {
        var defaults = {
            BuilderEntityID: 0,
            QueryName: '',
            ReturnOrdinal: '',
            Logical: '',
            IsUserDefined: false,
            PackageID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderEntityID = ko.validatedObservable(settings.BuilderEntityID);
        this.QueryName = ko.validatedObservable(settings.QueryName);
        this.ReturnOrdinal = ko.validatedObservable(settings.ReturnOrdinal);
        this.Logical = ko.validatedObservable(settings.Logical);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.QueryParts = ko.observableArray([]);
        this.Package = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderEntityID != undefined) {
                loaded.BuilderEntityID(responseData.BuilderEntityID);
            }
            if (responseData.QueryName != undefined) {
                loaded.QueryName(responseData.QueryName);
            }
            if (responseData.ReturnOrdinal != undefined) {
                loaded.ReturnOrdinal(responseData.ReturnOrdinal);
            }
            if (responseData.Logical != undefined) {
                loaded.Logical(responseData.Logical);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.QueryParts != null && responseData.QueryParts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.QueryParts.length; i++) {
                    items.push(new smapi.entities.QueryPartModel().LoadFromResponse(responseData.QueryParts[i]));
                }
                loaded.QueryParts(items);
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntityQuery', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.QueryName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ReturnOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Logical.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 6,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '6')
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function QueryPartModel(options) {
        var defaults = {
            BuilderEntityQueryID: null,
            QueryPartType: '',
            ObjectState: null,
            ParentID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderEntityQueryID = ko.validatedObservable(settings.BuilderEntityQueryID);
        this.QueryPartType = ko.validatedObservable(settings.QueryPartType);
        this.ObjectState = ko.validatedObservable(settings.ObjectState);
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.QueryParts = ko.observableArray([]);
        this.BuilderEntityQuery = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderEntityQueryID != undefined) {
                loaded.BuilderEntityQueryID(responseData.BuilderEntityQueryID);
            }
            if (responseData.QueryPartType != undefined) {
                loaded.QueryPartType(responseData.QueryPartType);
            }
            if (responseData.ObjectState != undefined) {
                loaded.ObjectState(responseData.ObjectState);
            }
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.QueryPartModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.QueryParts != null && responseData.QueryParts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.QueryParts.length; i++) {
                    items.push(new smapi.entities.QueryPartModel().LoadFromResponse(responseData.QueryParts[i]));
                }
                loaded.QueryParts(items);
            }
            if (responseData.BuilderEntityQuery != null) {
                loaded.BuilderEntityQuery(new smapi.entities.BuilderEntityQueryModel().LoadFromResponse(responseData.BuilderEntityQuery));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.QueryPart', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderEntityQueryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.QueryPartType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.ObjectState.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ParentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function QueryPartGroupModel(options) {
        var defaults = {
            Logical: '',
            BuilderEntityQueryID: null,
            QueryPartType: '',
            ObjectState: null,
            ParentID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Logical = ko.validatedObservable(settings.Logical);
        this.BuilderEntityQueryID = ko.validatedObservable(settings.BuilderEntityQueryID);
        this.QueryPartType = ko.validatedObservable(settings.QueryPartType);
        this.ObjectState = ko.validatedObservable(settings.ObjectState);
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.QueryParts = ko.observableArray([]);
        this.BuilderEntityQuery = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Logical != undefined) {
                loaded.Logical(responseData.Logical);
            }
            if (responseData.BuilderEntityQueryID != undefined) {
                loaded.BuilderEntityQueryID(responseData.BuilderEntityQueryID);
            }
            if (responseData.QueryPartType != undefined) {
                loaded.QueryPartType(responseData.QueryPartType);
            }
            if (responseData.ObjectState != undefined) {
                loaded.ObjectState(responseData.ObjectState);
            }
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.QueryPartModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.QueryParts != null && responseData.QueryParts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.QueryParts.length; i++) {
                    items.push(new smapi.entities.QueryPartModel().LoadFromResponse(responseData.QueryParts[i]));
                }
                loaded.QueryParts(items);
            }
            if (responseData.BuilderEntityQuery != null) {
                loaded.BuilderEntityQuery(new smapi.entities.BuilderEntityQueryModel().LoadFromResponse(responseData.BuilderEntityQuery));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.QueryPartGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Logical.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 6,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '6')
            }
        });
        this.BuilderEntityQueryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.QueryPartType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.ObjectState.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ParentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function QueryPartBindingModel(options) {
        var defaults = {
            AttributeName: '',
            StaticValue: '',
            BuilderEntityQueryID: null,
            QueryPartType: '',
            ObjectState: null,
            ParentID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AttributeName = ko.validatedObservable(settings.AttributeName);
        this.StaticValue = ko.validatedObservable(settings.StaticValue);
        this.BuilderEntityQueryID = ko.validatedObservable(settings.BuilderEntityQueryID);
        this.QueryPartType = ko.validatedObservable(settings.QueryPartType);
        this.ObjectState = ko.validatedObservable(settings.ObjectState);
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.QueryParts = ko.observableArray([]);
        this.BuilderEntityQuery = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AttributeName != undefined) {
                loaded.AttributeName(responseData.AttributeName);
            }
            if (responseData.StaticValue != undefined) {
                loaded.StaticValue(responseData.StaticValue);
            }
            if (responseData.BuilderEntityQueryID != undefined) {
                loaded.BuilderEntityQueryID(responseData.BuilderEntityQueryID);
            }
            if (responseData.QueryPartType != undefined) {
                loaded.QueryPartType(responseData.QueryPartType);
            }
            if (responseData.ObjectState != undefined) {
                loaded.ObjectState(responseData.ObjectState);
            }
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.QueryPartModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.QueryParts != null && responseData.QueryParts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.QueryParts.length; i++) {
                    items.push(new smapi.entities.QueryPartModel().LoadFromResponse(responseData.QueryParts[i]));
                }
                loaded.QueryParts(items);
            }
            if (responseData.BuilderEntityQuery != null) {
                loaded.BuilderEntityQuery(new smapi.entities.BuilderEntityQueryModel().LoadFromResponse(responseData.BuilderEntityQuery));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.QueryPartBinding', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AttributeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StaticValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BuilderEntityQueryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.QueryPartType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.ObjectState.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ParentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function QueryPartLiteralModel(options) {
        var defaults = {
            LiteralString: '',
            BuilderEntityQueryID: null,
            QueryPartType: '',
            ObjectState: null,
            ParentID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.LiteralString = ko.validatedObservable(settings.LiteralString);
        this.BuilderEntityQueryID = ko.validatedObservable(settings.BuilderEntityQueryID);
        this.QueryPartType = ko.validatedObservable(settings.QueryPartType);
        this.ObjectState = ko.validatedObservable(settings.ObjectState);
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.QueryParts = ko.observableArray([]);
        this.BuilderEntityQuery = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.LiteralString != undefined) {
                loaded.LiteralString(responseData.LiteralString);
            }
            if (responseData.BuilderEntityQueryID != undefined) {
                loaded.BuilderEntityQueryID(responseData.BuilderEntityQueryID);
            }
            if (responseData.QueryPartType != undefined) {
                loaded.QueryPartType(responseData.QueryPartType);
            }
            if (responseData.ObjectState != undefined) {
                loaded.ObjectState(responseData.ObjectState);
            }
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.QueryPartModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.QueryParts != null && responseData.QueryParts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.QueryParts.length; i++) {
                    items.push(new smapi.entities.QueryPartModel().LoadFromResponse(responseData.QueryParts[i]));
                }
                loaded.QueryParts(items);
            }
            if (responseData.BuilderEntityQuery != null) {
                loaded.BuilderEntityQuery(new smapi.entities.BuilderEntityQueryModel().LoadFromResponse(responseData.BuilderEntityQuery));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.QueryPartLiteral', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.LiteralString.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BuilderEntityQueryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.QueryPartType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.ObjectState.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ParentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityDBIndexModel(options) {
        var defaults = {
            Name: '',
            DBClustered: false,
            DBUnique: false,
            BuilderEntityID: 0,
            IsUserDefined: false,
            PackageID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.DBClustered = ko.validatedObservable(settings.DBClustered);
        this.DBUnique = ko.validatedObservable(settings.DBUnique);
        this.BuilderEntityID = ko.validatedObservable(settings.BuilderEntityID);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.Fields = ko.observableArray([]);
        this.Package = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.DBClustered != undefined) {
                loaded.DBClustered(responseData.DBClustered);
            }
            if (responseData.DBUnique != undefined) {
                loaded.DBUnique(responseData.DBUnique);
            }
            if (responseData.BuilderEntityID != undefined) {
                loaded.BuilderEntityID(responseData.BuilderEntityID);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.Fields != null && responseData.Fields.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Fields.length; i++) {
                    items.push(new smapi.entities.BuilderEntityDBIndexFieldModel().LoadFromResponse(responseData.Fields[i]));
                }
                loaded.Fields(items);
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntityDBIndex', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BuilderEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityDBIndexFieldModel(options) {
        var defaults = {
            Name: '',
            SortOrder: '',
            BuilderEntityDBIndexID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BuilderEntityDBIndexID = ko.validatedObservable(settings.BuilderEntityDBIndexID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BuilderEntityDBIndexID != undefined) {
                loaded.BuilderEntityDBIndexID(responseData.BuilderEntityDBIndexID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityDBIndexModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntityDBIndexField', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BuilderEntityDBIndexID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityFieldMVCAttributeModel(options) {
        var defaults = {
            ParentID: 0,
            Name: '',
            Value: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Value = ko.validatedObservable(settings.Value);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityFieldModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntityFieldMVCAttribute', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuilderEntityRelationshipMVCAttributeModel(options) {
        var defaults = {
            ParentID: 0,
            Name: '',
            Value: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Value = ko.validatedObservable(settings.Value);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.BuilderEntityRelationshipModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuilderEntityRelationshipMVCAttribute', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LookupGroupModel(options) {
        var defaults = {
            Name: '',
            LinkedEntityType: '',
            UseGroupIdentifier: false,
            GroupIdentifier: '',
            GroupIdentifierField: '',
            GroupParentLookup: '',
            GroupBinding: '',
            QueryToParentLookup: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.LinkedEntityType = ko.validatedObservable(settings.LinkedEntityType);
        this.UseGroupIdentifier = ko.validatedObservable(settings.UseGroupIdentifier);
        this.GroupIdentifier = ko.validatedObservable(settings.GroupIdentifier);
        this.GroupIdentifierField = ko.validatedObservable(settings.GroupIdentifierField);
        this.GroupParentLookup = ko.validatedObservable(settings.GroupParentLookup);
        this.GroupBinding = ko.validatedObservable(settings.GroupBinding);
        this.QueryToParentLookup = ko.validatedObservable(settings.QueryToParentLookup);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.LinkedEntityType != undefined) {
                loaded.LinkedEntityType(responseData.LinkedEntityType);
            }
            if (responseData.UseGroupIdentifier != undefined) {
                loaded.UseGroupIdentifier(responseData.UseGroupIdentifier);
            }
            if (responseData.GroupIdentifier != undefined) {
                loaded.GroupIdentifier(responseData.GroupIdentifier);
            }
            if (responseData.GroupIdentifierField != undefined) {
                loaded.GroupIdentifierField(responseData.GroupIdentifierField);
            }
            if (responseData.GroupParentLookup != undefined) {
                loaded.GroupParentLookup(responseData.GroupParentLookup);
            }
            if (responseData.GroupBinding != undefined) {
                loaded.GroupBinding(responseData.GroupBinding);
            }
            if (responseData.QueryToParentLookup != undefined) {
                loaded.QueryToParentLookup(responseData.QueryToParentLookup);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.LookupGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LinkedEntityType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupIdentifier.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupIdentifierField.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupParentLookup.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupBinding.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.QueryToParentLookup.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GlossaryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            ParentID: null,
            IconID: null,
            BusinessMeaningName: '',
            CategoryBusinessMeaningName: '',
            MenuModule: '',
            MenuGrouping: '',
            MenuLocation: '',
            SystemProtected: false,
            RequireCodeField: false,
            Code: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.IconID = ko.validatedObservable(settings.IconID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.CategoryBusinessMeaningName = ko.validatedObservable(settings.CategoryBusinessMeaningName);
        this.MenuModule = ko.validatedObservable(settings.MenuModule);
        this.MenuGrouping = ko.validatedObservable(settings.MenuGrouping);
        this.MenuLocation = ko.validatedObservable(settings.MenuLocation);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.RequireCodeField = ko.validatedObservable(settings.RequireCodeField);
        this.Code = ko.validatedObservable(settings.Code);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        this.Children = ko.observableArray([]);
        this.Icon = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.IconID != undefined) {
                loaded.IconID(responseData.IconID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.CategoryBusinessMeaningName != undefined) {
                loaded.CategoryBusinessMeaningName(responseData.CategoryBusinessMeaningName);
            }
            if (responseData.MenuModule != undefined) {
                loaded.MenuModule(responseData.MenuModule);
            }
            if (responseData.MenuGrouping != undefined) {
                loaded.MenuGrouping(responseData.MenuGrouping);
            }
            if (responseData.MenuLocation != undefined) {
                loaded.MenuLocation(responseData.MenuLocation);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.RequireCodeField != undefined) {
                loaded.RequireCodeField(responseData.RequireCodeField);
            }
            if (responseData.Code != undefined) {
                loaded.Code(responseData.Code);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.Children != null && responseData.Children.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Children.length; i++) {
                    items.push(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Children[i]));
                }
                loaded.Children(items);
            }
            if (responseData.Icon != null) {
                loaded.Icon(new smapi.entities.IconModel().LoadFromResponse(responseData.Icon));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Glossary', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IconID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.CategoryBusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.MenuModule.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.MenuGrouping.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MenuLocation.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Code.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ModuleAssemblyModel(options) {
        var defaults = {
            AssemblyName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AssemblyName = ko.validatedObservable(settings.AssemblyName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AssemblyName != undefined) {
                loaded.AssemblyName(responseData.AssemblyName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ModuleAssembly', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AssemblyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SiteModel(options) {
        var defaults = {
            Name: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Modules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Modules != null && responseData.Modules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Modules.length; i++) {
                    items.push(new smapi.entities.ModuleModel().LoadFromResponse(responseData.Modules[i]));
                }
                loaded.Modules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Site', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ModuleModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            EntityAssembly: '',
            HasScripts: false,
            ParentModuleID: null,
            Searchable: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.EntityAssembly = ko.validatedObservable(settings.EntityAssembly);
        this.HasScripts = ko.validatedObservable(settings.HasScripts);
        this.ParentModuleID = ko.validatedObservable(settings.ParentModuleID);
        this.Searchable = ko.validatedObservable(settings.Searchable);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DataAssemblyList = ko.observableArray([]);
        this.UtilityAssemblyList = ko.observableArray([]);
        this.UnitTestAssemblyList = ko.observableArray([]);
        this.ParentModule = ko.observable();
        this.ChildModules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.EntityAssembly != undefined) {
                loaded.EntityAssembly(responseData.EntityAssembly);
            }
            if (responseData.HasScripts != undefined) {
                loaded.HasScripts(responseData.HasScripts);
            }
            if (responseData.ParentModuleID != undefined) {
                loaded.ParentModuleID(responseData.ParentModuleID);
            }
            if (responseData.Searchable != undefined) {
                loaded.Searchable(responseData.Searchable);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DataAssemblyList != null && responseData.DataAssemblyList.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DataAssemblyList.length; i++) {
                    items.push(new smapi.entities.ModuleAssemblyModel().LoadFromResponse(responseData.DataAssemblyList[i]));
                }
                loaded.DataAssemblyList(items);
            }
            if (responseData.UtilityAssemblyList != null && responseData.UtilityAssemblyList.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.UtilityAssemblyList.length; i++) {
                    items.push(new smapi.entities.ModuleAssemblyModel().LoadFromResponse(responseData.UtilityAssemblyList[i]));
                }
                loaded.UtilityAssemblyList(items);
            }
            if (responseData.UnitTestAssemblyList != null && responseData.UnitTestAssemblyList.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.UnitTestAssemblyList.length; i++) {
                    items.push(new smapi.entities.ModuleAssemblyModel().LoadFromResponse(responseData.UnitTestAssemblyList[i]));
                }
                loaded.UnitTestAssemblyList(items);
            }
            if (responseData.ParentModule != null) {
                loaded.ParentModule(new smapi.entities.ModuleModel().LoadFromResponse(responseData.ParentModule));
            }
            if (responseData.ChildModules != null && responseData.ChildModules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildModules.length; i++) {
                    items.push(new smapi.entities.ModuleModel().LoadFromResponse(responseData.ChildModules[i]));
                }
                loaded.ChildModules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Module', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EntityAssembly.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ParentModuleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LookupGroupingModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            AnchorEntityID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.AnchorEntityID = ko.validatedObservable(settings.AnchorEntityID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AnchorEntity = ko.observable();
        this.LookupGroupings = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.AnchorEntityID != undefined) {
                loaded.AnchorEntityID(responseData.AnchorEntityID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AnchorEntity != null) {
                loaded.AnchorEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.AnchorEntity));
            }
            if (responseData.LookupGroupings != null && responseData.LookupGroupings.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.LookupGroupings.length; i++) {
                    items.push(new smapi.entities.LookupGroupingAssociationModel().LoadFromResponse(responseData.LookupGroupings[i]));
                }
                loaded.LookupGroupings(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.LookupGrouping', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AnchorEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LookupGroupingAssociationModel(options) {
        var defaults = {
            Binding: '',
            LookupGroupingID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Binding = ko.validatedObservable(settings.Binding);
        this.LookupGroupingID = ko.validatedObservable(settings.LookupGroupingID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.LookupGrouping = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Binding != undefined) {
                loaded.Binding(responseData.Binding);
            }
            if (responseData.LookupGroupingID != undefined) {
                loaded.LookupGroupingID(responseData.LookupGroupingID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.LookupGrouping != null) {
                loaded.LookupGrouping(new smapi.entities.LookupGroupingModel().LoadFromResponse(responseData.LookupGrouping));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.LookupGroupingAssociation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Binding.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LookupGroupingID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityModel(options) {
        var defaults = {
            BuilderEntityGID: null,
            EntityType: null,
            TypeName: '',
            FullTypeName: '',
            ParentsNames: '',
            IsPartialClass: false,
            CachedByPK: false,
            IsObsolete: false,
            TableName: '',
            EntityCode: 0,
            MainPage: '',
            Icon: '',
            Title: '',
            Description: '',
            Version: '',
            ToStringMethod: '',
            DBSchema: '',
            VersionAdded: '',
            VersionRemoved: '',
            CacheName: '',
            EntityCharacteristics: null,
            DisplayMode: null,
            ShowSuperstructure: false,
            SuperstructureEnabled: false,
            ShowObsolete: false,
            ShowCreatedResults: false,
            ShowSimpleAudit: false,
            DetailsColumnCnt: 0,
            DetailsColumnDynamic: false,
            ParentInTOC: false,
            ExcludeFromApi: false,
            ManagementGrouping: '',
            MenuModule: '',
            MenuGrouping: '',
            MenuLocation: '',
            NoValidation: false,
            ExcludeFromMVC: false,
            IsUserDefined: false,
            PackageID: null,
            EmittOrder: 0,
            PathToContact: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderEntityGID = ko.validatedObservable(settings.BuilderEntityGID);
        this.EntityType = ko.validatedObservable(settings.EntityType);
        this.TypeName = ko.validatedObservable(settings.TypeName);
        this.FullTypeName = ko.validatedObservable(settings.FullTypeName);
        this.ParentsNames = ko.validatedObservable(settings.ParentsNames);
        this.IsPartialClass = ko.validatedObservable(settings.IsPartialClass);
        this.CachedByPK = ko.validatedObservable(settings.CachedByPK);
        this.IsObsolete = ko.validatedObservable(settings.IsObsolete);
        this.TableName = ko.validatedObservable(settings.TableName);
        this.EntityCode = ko.validatedObservable(settings.EntityCode);
        this.MainPage = ko.validatedObservable(settings.MainPage);
        this.Icon = ko.validatedObservable(settings.Icon);
        this.Title = ko.validatedObservable(settings.Title);
        this.Description = ko.validatedObservable(settings.Description);
        this.Version = ko.validatedObservable(settings.Version);
        this.ToStringMethod = ko.validatedObservable(settings.ToStringMethod);
        this.DBSchema = ko.validatedObservable(settings.DBSchema);
        this.VersionAdded = ko.validatedObservable(settings.VersionAdded);
        this.VersionRemoved = ko.validatedObservable(settings.VersionRemoved);
        this.CacheName = ko.validatedObservable(settings.CacheName);
        this.EntityCharacteristics = ko.validatedObservable(settings.EntityCharacteristics);
        this.DisplayMode = ko.validatedObservable(settings.DisplayMode);
        this.ShowSuperstructure = ko.validatedObservable(settings.ShowSuperstructure);
        this.SuperstructureEnabled = ko.validatedObservable(settings.SuperstructureEnabled);
        this.ShowObsolete = ko.validatedObservable(settings.ShowObsolete);
        this.ShowCreatedResults = ko.validatedObservable(settings.ShowCreatedResults);
        this.ShowSimpleAudit = ko.validatedObservable(settings.ShowSimpleAudit);
        this.DetailsColumnCnt = ko.validatedObservable(settings.DetailsColumnCnt);
        this.DetailsColumnDynamic = ko.validatedObservable(settings.DetailsColumnDynamic);
        this.ParentInTOC = ko.validatedObservable(settings.ParentInTOC);
        this.ExcludeFromApi = ko.validatedObservable(settings.ExcludeFromApi);
        this.ManagementGrouping = ko.validatedObservable(settings.ManagementGrouping);
        this.MenuModule = ko.validatedObservable(settings.MenuModule);
        this.MenuGrouping = ko.validatedObservable(settings.MenuGrouping);
        this.MenuLocation = ko.validatedObservable(settings.MenuLocation);
        this.NoValidation = ko.validatedObservable(settings.NoValidation);
        this.ExcludeFromMVC = ko.validatedObservable(settings.ExcludeFromMVC);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.EmittOrder = ko.validatedObservable(settings.EmittOrder);
        this.PathToContact = ko.validatedObservable(settings.PathToContact);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Fields = ko.observableArray([]);
        this.Relationships = ko.observableArray([]);
        this.Indices = ko.observableArray([]);
        this.Package = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderEntityGID != undefined) {
                loaded.BuilderEntityGID(responseData.BuilderEntityGID);
            }
            if (responseData.EntityType != undefined) {
                loaded.EntityType(responseData.EntityType);
            }
            if (responseData.TypeName != undefined) {
                loaded.TypeName(responseData.TypeName);
            }
            if (responseData.FullTypeName != undefined) {
                loaded.FullTypeName(responseData.FullTypeName);
            }
            if (responseData.ParentsNames != undefined) {
                loaded.ParentsNames(responseData.ParentsNames);
            }
            if (responseData.IsPartialClass != undefined) {
                loaded.IsPartialClass(responseData.IsPartialClass);
            }
            if (responseData.CachedByPK != undefined) {
                loaded.CachedByPK(responseData.CachedByPK);
            }
            if (responseData.IsObsolete != undefined) {
                loaded.IsObsolete(responseData.IsObsolete);
            }
            if (responseData.TableName != undefined) {
                loaded.TableName(responseData.TableName);
            }
            if (responseData.EntityCode != undefined) {
                loaded.EntityCode(responseData.EntityCode);
            }
            if (responseData.MainPage != undefined) {
                loaded.MainPage(responseData.MainPage);
            }
            if (responseData.Icon != undefined) {
                loaded.Icon(responseData.Icon);
            }
            if (responseData.Title != undefined) {
                loaded.Title(responseData.Title);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Version != undefined) {
                loaded.Version(responseData.Version);
            }
            if (responseData.ToStringMethod != undefined) {
                loaded.ToStringMethod(responseData.ToStringMethod);
            }
            if (responseData.DBSchema != undefined) {
                loaded.DBSchema(responseData.DBSchema);
            }
            if (responseData.VersionAdded != undefined) {
                loaded.VersionAdded(responseData.VersionAdded);
            }
            if (responseData.VersionRemoved != undefined) {
                loaded.VersionRemoved(responseData.VersionRemoved);
            }
            if (responseData.CacheName != undefined) {
                loaded.CacheName(responseData.CacheName);
            }
            if (responseData.EntityCharacteristics != undefined) {
                loaded.EntityCharacteristics(responseData.EntityCharacteristics);
            }
            if (responseData.DisplayMode != undefined) {
                loaded.DisplayMode(responseData.DisplayMode);
            }
            if (responseData.ShowSuperstructure != undefined) {
                loaded.ShowSuperstructure(responseData.ShowSuperstructure);
            }
            if (responseData.SuperstructureEnabled != undefined) {
                loaded.SuperstructureEnabled(responseData.SuperstructureEnabled);
            }
            if (responseData.ShowObsolete != undefined) {
                loaded.ShowObsolete(responseData.ShowObsolete);
            }
            if (responseData.ShowCreatedResults != undefined) {
                loaded.ShowCreatedResults(responseData.ShowCreatedResults);
            }
            if (responseData.ShowSimpleAudit != undefined) {
                loaded.ShowSimpleAudit(responseData.ShowSimpleAudit);
            }
            if (responseData.DetailsColumnCnt != undefined) {
                loaded.DetailsColumnCnt(responseData.DetailsColumnCnt);
            }
            if (responseData.DetailsColumnDynamic != undefined) {
                loaded.DetailsColumnDynamic(responseData.DetailsColumnDynamic);
            }
            if (responseData.ParentInTOC != undefined) {
                loaded.ParentInTOC(responseData.ParentInTOC);
            }
            if (responseData.ExcludeFromApi != undefined) {
                loaded.ExcludeFromApi(responseData.ExcludeFromApi);
            }
            if (responseData.ManagementGrouping != undefined) {
                loaded.ManagementGrouping(responseData.ManagementGrouping);
            }
            if (responseData.MenuModule != undefined) {
                loaded.MenuModule(responseData.MenuModule);
            }
            if (responseData.MenuGrouping != undefined) {
                loaded.MenuGrouping(responseData.MenuGrouping);
            }
            if (responseData.MenuLocation != undefined) {
                loaded.MenuLocation(responseData.MenuLocation);
            }
            if (responseData.NoValidation != undefined) {
                loaded.NoValidation(responseData.NoValidation);
            }
            if (responseData.ExcludeFromMVC != undefined) {
                loaded.ExcludeFromMVC(responseData.ExcludeFromMVC);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.EmittOrder != undefined) {
                loaded.EmittOrder(responseData.EmittOrder);
            }
            if (responseData.PathToContact != undefined) {
                loaded.PathToContact(responseData.PathToContact);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Fields != null && responseData.Fields.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Fields.length; i++) {
                    items.push(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.Fields[i]));
                }
                loaded.Fields(items);
            }
            if (responseData.Relationships != null && responseData.Relationships.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Relationships.length; i++) {
                    items.push(new smapi.entities.EntityRelationshipModel().LoadFromResponse(responseData.Relationships[i]));
                }
                loaded.Relationships(items);
            }
            if (responseData.Indices != null && responseData.Indices.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Indices.length; i++) {
                    items.push(new smapi.entities.EntityDBIndexModel().LoadFromResponse(responseData.Indices[i]));
                }
                loaded.Indices(items);
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Entity', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderEntityGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.EntityType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FullTypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ParentsNames.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.TableName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EntityCode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MainPage.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Icon.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Title.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.Version.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.ToStringMethod.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.DBSchema.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.VersionAdded.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.VersionRemoved.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.CacheName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.EntityCharacteristics.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DisplayMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DetailsColumnCnt.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ManagementGrouping.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MenuModule.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.MenuGrouping.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MenuLocation.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EmittOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PathToContact.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityFieldModel(options) {
        var defaults = {
            BuilderEntityFieldGID: null,
            EntityID: 0,
            InheritedID: null,
            AttributeName: '',
            FieldName: '',
            DBFieldName: '',
            DefaultValue: '',
            Transient: false,
            IsPK: false,
            IsBK: false,
            IsAvailableForWrapper: false,
            IsInherited: false,
            IsIdentity: false,
            HasGetter: false,
            HasSetter: false,
            FieldOrdinal: 0,
            DataLength: 0,
            Precision: 0,
            Scale: 0,
            Label: '',
            ShortLabel: '',
            Tooltip: '',
            Prompt: '',
            DataType: '',
            MinimumValue: '',
            MaximumValue: '',
            IsNullable: false,
            Required: false,
            IsFixedLength: false,
            IsInline: false,
            ValidationExpression: '',
            InvalidMessage: '',
            SourceType: '',
            SourceDisplay: '',
            SourceValue: '',
            Filter: '',
            Used: false,
            MinimumDataLength: 0,
            HintMask: '',
            DisplayMask: '',
            IsLocalizable: false,
            IsDBHashed: false,
            HashName: '',
            IsDBEncrypted: false,
            ProviderID: null,
            ZoneName: '',
            EncryptionName: '',
            IsMasked: false,
            MigrationDefaultValue: '',
            AttributeForRelationship: '',
            Value: '',
            AggregateRelationship: '',
            SortOrdinal: 0,
            SortDirection: '',
            VersionAdded: '',
            VersionRemoved: '',
            FieldCharacteristics: null,
            RelatedField: '',
            NaturalKey: false,
            SearchField: false,
            SearchResultField: false,
            PopupSearchField: false,
            PopupSearchResultField: false,
            LiveSearchResult: false,
            PopupJsonResult: false,
            SVDisplayField: false,
            TOCTableField: false,
            TOCListField: false,
            Hidden: false,
            Calculated: false,
            TitledDisplayGroup: '',
            DisplayGroup: '',
            IsHtml: false,
            HeaderField: false,
            ShortForm: false,
            LongForm: false,
            TitledResultsGroup: '',
            ResultsGroup: '',
            ResultsOrder: 0,
            InStaticPrimary: false,
            IsPercentage: false,
            IsDateSequence: false,
            DateSeqDownstreamOperator: '',
            DateSeqUpstreamOperator: '',
            DateSeqPathToDownstreamDate: '',
            DateSeqPathToUpstreamDate: '',
            PathToCurrency: '',
            ApiSummaryField: false,
            ApiDetailedField: false,
            IsUserDefined: false,
            PackageID: null,
            IsTimeSequence: false,
            StaticSectionView: '',
            PopupEditorView: '',
            ListTableHeaderView: '',
            ListTableRowView: '',
            StandardTableHeaderView: '',
            StandardTableRowView: '',
            StandardListView: '',
            StandardTableM2MView: '',
            SearchEditorView: '',
            SearchHeaderView: '',
            SearchRowView: '',
            SearchListView: '',
            DisplayReadOnly: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderEntityFieldGID = ko.validatedObservable(settings.BuilderEntityFieldGID);
        this.EntityID = ko.validatedObservable(settings.EntityID);
        this.InheritedID = ko.validatedObservable(settings.InheritedID);
        this.AttributeName = ko.validatedObservable(settings.AttributeName);
        this.FieldName = ko.validatedObservable(settings.FieldName);
        this.DBFieldName = ko.validatedObservable(settings.DBFieldName);
        this.DefaultValue = ko.validatedObservable(settings.DefaultValue);
        this.Transient = ko.validatedObservable(settings.Transient);
        this.IsPK = ko.validatedObservable(settings.IsPK);
        this.IsBK = ko.validatedObservable(settings.IsBK);
        this.IsAvailableForWrapper = ko.validatedObservable(settings.IsAvailableForWrapper);
        this.IsInherited = ko.validatedObservable(settings.IsInherited);
        this.IsIdentity = ko.validatedObservable(settings.IsIdentity);
        this.HasGetter = ko.validatedObservable(settings.HasGetter);
        this.HasSetter = ko.validatedObservable(settings.HasSetter);
        this.FieldOrdinal = ko.validatedObservable(settings.FieldOrdinal);
        this.DataLength = ko.validatedObservable(settings.DataLength);
        this.Precision = ko.validatedObservable(settings.Precision);
        this.Scale = ko.validatedObservable(settings.Scale);
        this.Label = ko.validatedObservable(settings.Label);
        this.ShortLabel = ko.validatedObservable(settings.ShortLabel);
        this.Tooltip = ko.validatedObservable(settings.Tooltip);
        this.Prompt = ko.validatedObservable(settings.Prompt);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.MinimumValue = ko.validatedObservable(settings.MinimumValue);
        this.MaximumValue = ko.validatedObservable(settings.MaximumValue);
        this.IsNullable = ko.validatedObservable(settings.IsNullable);
        this.Required = ko.validatedObservable(settings.Required);
        this.IsFixedLength = ko.validatedObservable(settings.IsFixedLength);
        this.IsInline = ko.validatedObservable(settings.IsInline);
        this.ValidationExpression = ko.validatedObservable(settings.ValidationExpression);
        this.InvalidMessage = ko.validatedObservable(settings.InvalidMessage);
        this.SourceType = ko.validatedObservable(settings.SourceType);
        this.SourceDisplay = ko.validatedObservable(settings.SourceDisplay);
        this.SourceValue = ko.validatedObservable(settings.SourceValue);
        this.Filter = ko.validatedObservable(settings.Filter);
        this.Used = ko.validatedObservable(settings.Used);
        this.MinimumDataLength = ko.validatedObservable(settings.MinimumDataLength);
        this.HintMask = ko.validatedObservable(settings.HintMask);
        this.DisplayMask = ko.validatedObservable(settings.DisplayMask);
        this.IsLocalizable = ko.validatedObservable(settings.IsLocalizable);
        this.IsDBHashed = ko.validatedObservable(settings.IsDBHashed);
        this.HashName = ko.validatedObservable(settings.HashName);
        this.IsDBEncrypted = ko.validatedObservable(settings.IsDBEncrypted);
        this.ProviderID = ko.validatedObservable(settings.ProviderID);
        this.ZoneName = ko.validatedObservable(settings.ZoneName);
        this.EncryptionName = ko.validatedObservable(settings.EncryptionName);
        this.IsMasked = ko.validatedObservable(settings.IsMasked);
        this.MigrationDefaultValue = ko.validatedObservable(settings.MigrationDefaultValue);
        this.AttributeForRelationship = ko.validatedObservable(settings.AttributeForRelationship);
        this.Value = ko.validatedObservable(settings.Value);
        this.AggregateRelationship = ko.validatedObservable(settings.AggregateRelationship);
        this.SortOrdinal = ko.validatedObservable(settings.SortOrdinal);
        this.SortDirection = ko.validatedObservable(settings.SortDirection);
        this.VersionAdded = ko.validatedObservable(settings.VersionAdded);
        this.VersionRemoved = ko.validatedObservable(settings.VersionRemoved);
        this.FieldCharacteristics = ko.validatedObservable(settings.FieldCharacteristics);
        this.RelatedField = ko.validatedObservable(settings.RelatedField);
        this.NaturalKey = ko.validatedObservable(settings.NaturalKey);
        this.SearchField = ko.validatedObservable(settings.SearchField);
        this.SearchResultField = ko.validatedObservable(settings.SearchResultField);
        this.PopupSearchField = ko.validatedObservable(settings.PopupSearchField);
        this.PopupSearchResultField = ko.validatedObservable(settings.PopupSearchResultField);
        this.LiveSearchResult = ko.validatedObservable(settings.LiveSearchResult);
        this.PopupJsonResult = ko.validatedObservable(settings.PopupJsonResult);
        this.SVDisplayField = ko.validatedObservable(settings.SVDisplayField);
        this.TOCTableField = ko.validatedObservable(settings.TOCTableField);
        this.TOCListField = ko.validatedObservable(settings.TOCListField);
        this.Hidden = ko.validatedObservable(settings.Hidden);
        this.Calculated = ko.validatedObservable(settings.Calculated);
        this.TitledDisplayGroup = ko.validatedObservable(settings.TitledDisplayGroup);
        this.DisplayGroup = ko.validatedObservable(settings.DisplayGroup);
        this.IsHtml = ko.validatedObservable(settings.IsHtml);
        this.HeaderField = ko.validatedObservable(settings.HeaderField);
        this.ShortForm = ko.validatedObservable(settings.ShortForm);
        this.LongForm = ko.validatedObservable(settings.LongForm);
        this.TitledResultsGroup = ko.validatedObservable(settings.TitledResultsGroup);
        this.ResultsGroup = ko.validatedObservable(settings.ResultsGroup);
        this.ResultsOrder = ko.validatedObservable(settings.ResultsOrder);
        this.InStaticPrimary = ko.validatedObservable(settings.InStaticPrimary);
        this.IsPercentage = ko.validatedObservable(settings.IsPercentage);
        this.IsDateSequence = ko.validatedObservable(settings.IsDateSequence);
        this.DateSeqDownstreamOperator = ko.validatedObservable(settings.DateSeqDownstreamOperator);
        this.DateSeqUpstreamOperator = ko.validatedObservable(settings.DateSeqUpstreamOperator);
        this.DateSeqPathToDownstreamDate = ko.validatedObservable(settings.DateSeqPathToDownstreamDate);
        this.DateSeqPathToUpstreamDate = ko.validatedObservable(settings.DateSeqPathToUpstreamDate);
        this.PathToCurrency = ko.validatedObservable(settings.PathToCurrency);
        this.ApiSummaryField = ko.validatedObservable(settings.ApiSummaryField);
        this.ApiDetailedField = ko.validatedObservable(settings.ApiDetailedField);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.IsTimeSequence = ko.validatedObservable(settings.IsTimeSequence);
        this.StaticSectionView = ko.validatedObservable(settings.StaticSectionView);
        this.PopupEditorView = ko.validatedObservable(settings.PopupEditorView);
        this.ListTableHeaderView = ko.validatedObservable(settings.ListTableHeaderView);
        this.ListTableRowView = ko.validatedObservable(settings.ListTableRowView);
        this.StandardTableHeaderView = ko.validatedObservable(settings.StandardTableHeaderView);
        this.StandardTableRowView = ko.validatedObservable(settings.StandardTableRowView);
        this.StandardListView = ko.validatedObservable(settings.StandardListView);
        this.StandardTableM2MView = ko.validatedObservable(settings.StandardTableM2MView);
        this.SearchEditorView = ko.validatedObservable(settings.SearchEditorView);
        this.SearchHeaderView = ko.validatedObservable(settings.SearchHeaderView);
        this.SearchRowView = ko.validatedObservable(settings.SearchRowView);
        this.SearchListView = ko.validatedObservable(settings.SearchListView);
        this.DisplayReadOnly = ko.validatedObservable(settings.DisplayReadOnly);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Entity = ko.observable();
        this.Package = ko.observable();
        this.MVCAttributes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderEntityFieldGID != undefined) {
                loaded.BuilderEntityFieldGID(responseData.BuilderEntityFieldGID);
            }
            if (responseData.EntityID != undefined) {
                loaded.EntityID(responseData.EntityID);
            }
            if (responseData.InheritedID != undefined) {
                loaded.InheritedID(responseData.InheritedID);
            }
            if (responseData.AttributeName != undefined) {
                loaded.AttributeName(responseData.AttributeName);
            }
            if (responseData.FieldName != undefined) {
                loaded.FieldName(responseData.FieldName);
            }
            if (responseData.DBFieldName != undefined) {
                loaded.DBFieldName(responseData.DBFieldName);
            }
            if (responseData.DefaultValue != undefined) {
                loaded.DefaultValue(responseData.DefaultValue);
            }
            if (responseData.Transient != undefined) {
                loaded.Transient(responseData.Transient);
            }
            if (responseData.IsPK != undefined) {
                loaded.IsPK(responseData.IsPK);
            }
            if (responseData.IsBK != undefined) {
                loaded.IsBK(responseData.IsBK);
            }
            if (responseData.IsAvailableForWrapper != undefined) {
                loaded.IsAvailableForWrapper(responseData.IsAvailableForWrapper);
            }
            if (responseData.IsInherited != undefined) {
                loaded.IsInherited(responseData.IsInherited);
            }
            if (responseData.IsIdentity != undefined) {
                loaded.IsIdentity(responseData.IsIdentity);
            }
            if (responseData.HasGetter != undefined) {
                loaded.HasGetter(responseData.HasGetter);
            }
            if (responseData.HasSetter != undefined) {
                loaded.HasSetter(responseData.HasSetter);
            }
            if (responseData.FieldOrdinal != undefined) {
                loaded.FieldOrdinal(responseData.FieldOrdinal);
            }
            if (responseData.DataLength != undefined) {
                loaded.DataLength(responseData.DataLength);
            }
            if (responseData.Precision != undefined) {
                loaded.Precision(responseData.Precision);
            }
            if (responseData.Scale != undefined) {
                loaded.Scale(responseData.Scale);
            }
            if (responseData.Label != undefined) {
                loaded.Label(responseData.Label);
            }
            if (responseData.ShortLabel != undefined) {
                loaded.ShortLabel(responseData.ShortLabel);
            }
            if (responseData.Tooltip != undefined) {
                loaded.Tooltip(responseData.Tooltip);
            }
            if (responseData.Prompt != undefined) {
                loaded.Prompt(responseData.Prompt);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.MinimumValue != undefined) {
                loaded.MinimumValue(responseData.MinimumValue);
            }
            if (responseData.MaximumValue != undefined) {
                loaded.MaximumValue(responseData.MaximumValue);
            }
            if (responseData.IsNullable != undefined) {
                loaded.IsNullable(responseData.IsNullable);
            }
            if (responseData.Required != undefined) {
                loaded.Required(responseData.Required);
            }
            if (responseData.IsFixedLength != undefined) {
                loaded.IsFixedLength(responseData.IsFixedLength);
            }
            if (responseData.IsInline != undefined) {
                loaded.IsInline(responseData.IsInline);
            }
            if (responseData.ValidationExpression != undefined) {
                loaded.ValidationExpression(responseData.ValidationExpression);
            }
            if (responseData.InvalidMessage != undefined) {
                loaded.InvalidMessage(responseData.InvalidMessage);
            }
            if (responseData.SourceType != undefined) {
                loaded.SourceType(responseData.SourceType);
            }
            if (responseData.SourceDisplay != undefined) {
                loaded.SourceDisplay(responseData.SourceDisplay);
            }
            if (responseData.SourceValue != undefined) {
                loaded.SourceValue(responseData.SourceValue);
            }
            if (responseData.Filter != undefined) {
                loaded.Filter(responseData.Filter);
            }
            if (responseData.Used != undefined) {
                loaded.Used(responseData.Used);
            }
            if (responseData.MinimumDataLength != undefined) {
                loaded.MinimumDataLength(responseData.MinimumDataLength);
            }
            if (responseData.HintMask != undefined) {
                loaded.HintMask(responseData.HintMask);
            }
            if (responseData.DisplayMask != undefined) {
                loaded.DisplayMask(responseData.DisplayMask);
            }
            if (responseData.IsLocalizable != undefined) {
                loaded.IsLocalizable(responseData.IsLocalizable);
            }
            if (responseData.IsDBHashed != undefined) {
                loaded.IsDBHashed(responseData.IsDBHashed);
            }
            if (responseData.HashName != undefined) {
                loaded.HashName(responseData.HashName);
            }
            if (responseData.IsDBEncrypted != undefined) {
                loaded.IsDBEncrypted(responseData.IsDBEncrypted);
            }
            if (responseData.ProviderID != undefined) {
                loaded.ProviderID(responseData.ProviderID);
            }
            if (responseData.ZoneName != undefined) {
                loaded.ZoneName(responseData.ZoneName);
            }
            if (responseData.EncryptionName != undefined) {
                loaded.EncryptionName(responseData.EncryptionName);
            }
            if (responseData.IsMasked != undefined) {
                loaded.IsMasked(responseData.IsMasked);
            }
            if (responseData.MigrationDefaultValue != undefined) {
                loaded.MigrationDefaultValue(responseData.MigrationDefaultValue);
            }
            if (responseData.AttributeForRelationship != undefined) {
                loaded.AttributeForRelationship(responseData.AttributeForRelationship);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.AggregateRelationship != undefined) {
                loaded.AggregateRelationship(responseData.AggregateRelationship);
            }
            if (responseData.SortOrdinal != undefined) {
                loaded.SortOrdinal(responseData.SortOrdinal);
            }
            if (responseData.SortDirection != undefined) {
                loaded.SortDirection(responseData.SortDirection);
            }
            if (responseData.VersionAdded != undefined) {
                loaded.VersionAdded(responseData.VersionAdded);
            }
            if (responseData.VersionRemoved != undefined) {
                loaded.VersionRemoved(responseData.VersionRemoved);
            }
            if (responseData.FieldCharacteristics != undefined) {
                loaded.FieldCharacteristics(responseData.FieldCharacteristics);
            }
            if (responseData.RelatedField != undefined) {
                loaded.RelatedField(responseData.RelatedField);
            }
            if (responseData.NaturalKey != undefined) {
                loaded.NaturalKey(responseData.NaturalKey);
            }
            if (responseData.SearchField != undefined) {
                loaded.SearchField(responseData.SearchField);
            }
            if (responseData.SearchResultField != undefined) {
                loaded.SearchResultField(responseData.SearchResultField);
            }
            if (responseData.PopupSearchField != undefined) {
                loaded.PopupSearchField(responseData.PopupSearchField);
            }
            if (responseData.PopupSearchResultField != undefined) {
                loaded.PopupSearchResultField(responseData.PopupSearchResultField);
            }
            if (responseData.LiveSearchResult != undefined) {
                loaded.LiveSearchResult(responseData.LiveSearchResult);
            }
            if (responseData.PopupJsonResult != undefined) {
                loaded.PopupJsonResult(responseData.PopupJsonResult);
            }
            if (responseData.SVDisplayField != undefined) {
                loaded.SVDisplayField(responseData.SVDisplayField);
            }
            if (responseData.TOCTableField != undefined) {
                loaded.TOCTableField(responseData.TOCTableField);
            }
            if (responseData.TOCListField != undefined) {
                loaded.TOCListField(responseData.TOCListField);
            }
            if (responseData.Hidden != undefined) {
                loaded.Hidden(responseData.Hidden);
            }
            if (responseData.Calculated != undefined) {
                loaded.Calculated(responseData.Calculated);
            }
            if (responseData.TitledDisplayGroup != undefined) {
                loaded.TitledDisplayGroup(responseData.TitledDisplayGroup);
            }
            if (responseData.DisplayGroup != undefined) {
                loaded.DisplayGroup(responseData.DisplayGroup);
            }
            if (responseData.IsHtml != undefined) {
                loaded.IsHtml(responseData.IsHtml);
            }
            if (responseData.HeaderField != undefined) {
                loaded.HeaderField(responseData.HeaderField);
            }
            if (responseData.ShortForm != undefined) {
                loaded.ShortForm(responseData.ShortForm);
            }
            if (responseData.LongForm != undefined) {
                loaded.LongForm(responseData.LongForm);
            }
            if (responseData.TitledResultsGroup != undefined) {
                loaded.TitledResultsGroup(responseData.TitledResultsGroup);
            }
            if (responseData.ResultsGroup != undefined) {
                loaded.ResultsGroup(responseData.ResultsGroup);
            }
            if (responseData.ResultsOrder != undefined) {
                loaded.ResultsOrder(responseData.ResultsOrder);
            }
            if (responseData.InStaticPrimary != undefined) {
                loaded.InStaticPrimary(responseData.InStaticPrimary);
            }
            if (responseData.IsPercentage != undefined) {
                loaded.IsPercentage(responseData.IsPercentage);
            }
            if (responseData.IsDateSequence != undefined) {
                loaded.IsDateSequence(responseData.IsDateSequence);
            }
            if (responseData.DateSeqDownstreamOperator != undefined) {
                loaded.DateSeqDownstreamOperator(responseData.DateSeqDownstreamOperator);
            }
            if (responseData.DateSeqUpstreamOperator != undefined) {
                loaded.DateSeqUpstreamOperator(responseData.DateSeqUpstreamOperator);
            }
            if (responseData.DateSeqPathToDownstreamDate != undefined) {
                loaded.DateSeqPathToDownstreamDate(responseData.DateSeqPathToDownstreamDate);
            }
            if (responseData.DateSeqPathToUpstreamDate != undefined) {
                loaded.DateSeqPathToUpstreamDate(responseData.DateSeqPathToUpstreamDate);
            }
            if (responseData.PathToCurrency != undefined) {
                loaded.PathToCurrency(responseData.PathToCurrency);
            }
            if (responseData.ApiSummaryField != undefined) {
                loaded.ApiSummaryField(responseData.ApiSummaryField);
            }
            if (responseData.ApiDetailedField != undefined) {
                loaded.ApiDetailedField(responseData.ApiDetailedField);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.IsTimeSequence != undefined) {
                loaded.IsTimeSequence(responseData.IsTimeSequence);
            }
            if (responseData.StaticSectionView != undefined) {
                loaded.StaticSectionView(responseData.StaticSectionView);
            }
            if (responseData.PopupEditorView != undefined) {
                loaded.PopupEditorView(responseData.PopupEditorView);
            }
            if (responseData.ListTableHeaderView != undefined) {
                loaded.ListTableHeaderView(responseData.ListTableHeaderView);
            }
            if (responseData.ListTableRowView != undefined) {
                loaded.ListTableRowView(responseData.ListTableRowView);
            }
            if (responseData.StandardTableHeaderView != undefined) {
                loaded.StandardTableHeaderView(responseData.StandardTableHeaderView);
            }
            if (responseData.StandardTableRowView != undefined) {
                loaded.StandardTableRowView(responseData.StandardTableRowView);
            }
            if (responseData.StandardListView != undefined) {
                loaded.StandardListView(responseData.StandardListView);
            }
            if (responseData.StandardTableM2MView != undefined) {
                loaded.StandardTableM2MView(responseData.StandardTableM2MView);
            }
            if (responseData.SearchEditorView != undefined) {
                loaded.SearchEditorView(responseData.SearchEditorView);
            }
            if (responseData.SearchHeaderView != undefined) {
                loaded.SearchHeaderView(responseData.SearchHeaderView);
            }
            if (responseData.SearchRowView != undefined) {
                loaded.SearchRowView(responseData.SearchRowView);
            }
            if (responseData.SearchListView != undefined) {
                loaded.SearchListView(responseData.SearchListView);
            }
            if (responseData.DisplayReadOnly != undefined) {
                loaded.DisplayReadOnly(responseData.DisplayReadOnly);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Entity != null) {
                loaded.Entity(new smapi.entities.EntityModel().LoadFromResponse(responseData.Entity));
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            if (responseData.MVCAttributes != null && responseData.MVCAttributes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MVCAttributes.length; i++) {
                    items.push(new smapi.entities.EntityFieldMVCAttributeModel().LoadFromResponse(responseData.MVCAttributes[i]));
                }
                loaded.MVCAttributes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityField', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderEntityFieldGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.EntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InheritedID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.AttributeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FieldName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DBFieldName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DefaultValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FieldOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataLength.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Precision.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Scale.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Label.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ShortLabel.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Tooltip.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.Prompt.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MinimumValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MaximumValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ValidationExpression.extend({
            maxLength: {
                params: 500,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '500')
            }
        });
        this.InvalidMessage.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourceType.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourceDisplay.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourceValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Filter.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MinimumDataLength.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HintMask.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DisplayMask.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.HashName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ProviderID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ZoneName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.EncryptionName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.MigrationDefaultValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AttributeForRelationship.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.AggregateRelationship.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortDirection.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.VersionAdded.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.VersionRemoved.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.FieldCharacteristics.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.RelatedField.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.TitledDisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.DisplayGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.TitledResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateSeqDownstreamOperator.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DateSeqUpstreamOperator.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DateSeqPathToDownstreamDate.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DateSeqPathToUpstreamDate.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PathToCurrency.extend({
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StaticSectionView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PopupEditorView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ListTableHeaderView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ListTableRowView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StandardTableHeaderView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StandardTableRowView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StandardListView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StandardTableM2MView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SearchEditorView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SearchHeaderView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SearchRowView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SearchListView.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityRelationshipModel(options) {
        var defaults = {
            BuilderEntityRelationshipGID: null,
            InheritedID: null,
            AttributeName: '',
            FieldOrdinal: 0,
            SimpleDataType: '',
            DataType: '',
            HasGetter: false,
            HasSetter: false,
            BackpointedAttribute: '',
            ParentAttribute: '',
            TableName: '',
            EntityID: 0,
            ToEntityID: null,
            Tooltip: '',
            RelationshipType: '',
            Transient: false,
            IsInherited: false,
            IsFK: false,
            IsRequired: false,
            BeginDate: null,
            EndDate: null,
            ClassType: null,
            Label: '',
            ShortLabel: '',
            Prompt: '',
            DefaultValue: '',
            CascadeAction: '',
            CsvDictionaryKeys: '',
            LookupGroupID: null,
            BusinessMeaningName: '',
            Value: '',
            HierarchyType: null,
            InitializerType: null,
            Aggregated: false,
            AggregateRelationship: '',
            VersionAdded: '',
            VersionRemoved: '',
            ForeignKeyName: '',
            IsAnchor: false,
            Characteristics: null,
            SearchField: false,
            SearchResultField: false,
            PopupSearchField: false,
            PopupSearchResultField: false,
            LiveSearchResult: false,
            PopupJsonResult: false,
            SVDisplayField: false,
            TOCTableField: false,
            TOCListField: false,
            Hidden: false,
            IsParent: false,
            Context: false,
            SearchFieldDepth: 0,
            TitledDisplayGroup: '',
            DisplayGroup: '',
            EditorMode: null,
            SearchMode: null,
            TOCItemMode: null,
            HeaderField: false,
            ShortForm: false,
            LongForm: false,
            TitledResultsGroup: '',
            ResultsGroup: '',
            ResultsOrder: 0,
            InStaticPrimary: false,
            SortOrdinal: 0,
            ApiSummaryRelationship: false,
            ApiDetailedRelationship: false,
            IsUserDefined: false,
            LockParentOnChildEdit: false,
            PackageID: null,
            TOCOrdinal: 0,
            SaveOrdinal: 0,
            NoRecursionForATO: false,
            NoRecursionForDTO: false,
            DisplayReadOnly: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderEntityRelationshipGID = ko.validatedObservable(settings.BuilderEntityRelationshipGID);
        this.InheritedID = ko.validatedObservable(settings.InheritedID);
        this.AttributeName = ko.validatedObservable(settings.AttributeName);
        this.FieldOrdinal = ko.validatedObservable(settings.FieldOrdinal);
        this.SimpleDataType = ko.validatedObservable(settings.SimpleDataType);
        this.DataType = ko.validatedObservable(settings.DataType);
        this.HasGetter = ko.validatedObservable(settings.HasGetter);
        this.HasSetter = ko.validatedObservable(settings.HasSetter);
        this.BackpointedAttribute = ko.validatedObservable(settings.BackpointedAttribute);
        this.ParentAttribute = ko.validatedObservable(settings.ParentAttribute);
        this.TableName = ko.validatedObservable(settings.TableName);
        this.EntityID = ko.validatedObservable(settings.EntityID);
        this.ToEntityID = ko.validatedObservable(settings.ToEntityID);
        this.Tooltip = ko.validatedObservable(settings.Tooltip);
        this.RelationshipType = ko.validatedObservable(settings.RelationshipType);
        this.Transient = ko.validatedObservable(settings.Transient);
        this.IsInherited = ko.validatedObservable(settings.IsInherited);
        this.IsFK = ko.validatedObservable(settings.IsFK);
        this.IsRequired = ko.validatedObservable(settings.IsRequired);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Label = ko.validatedObservable(settings.Label);
        this.ShortLabel = ko.validatedObservable(settings.ShortLabel);
        this.Prompt = ko.validatedObservable(settings.Prompt);
        this.DefaultValue = ko.validatedObservable(settings.DefaultValue);
        this.CascadeAction = ko.validatedObservable(settings.CascadeAction);
        this.CsvDictionaryKeys = ko.validatedObservable(settings.CsvDictionaryKeys);
        this.LookupGroupID = ko.validatedObservable(settings.LookupGroupID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.Value = ko.validatedObservable(settings.Value);
        this.HierarchyType = ko.validatedObservable(settings.HierarchyType);
        this.InitializerType = ko.validatedObservable(settings.InitializerType);
        this.Aggregated = ko.validatedObservable(settings.Aggregated);
        this.AggregateRelationship = ko.validatedObservable(settings.AggregateRelationship);
        this.VersionAdded = ko.validatedObservable(settings.VersionAdded);
        this.VersionRemoved = ko.validatedObservable(settings.VersionRemoved);
        this.ForeignKeyName = ko.validatedObservable(settings.ForeignKeyName);
        this.IsAnchor = ko.validatedObservable(settings.IsAnchor);
        this.Characteristics = ko.validatedObservable(settings.Characteristics);
        this.SearchField = ko.validatedObservable(settings.SearchField);
        this.SearchResultField = ko.validatedObservable(settings.SearchResultField);
        this.PopupSearchField = ko.validatedObservable(settings.PopupSearchField);
        this.PopupSearchResultField = ko.validatedObservable(settings.PopupSearchResultField);
        this.LiveSearchResult = ko.validatedObservable(settings.LiveSearchResult);
        this.PopupJsonResult = ko.validatedObservable(settings.PopupJsonResult);
        this.SVDisplayField = ko.validatedObservable(settings.SVDisplayField);
        this.TOCTableField = ko.validatedObservable(settings.TOCTableField);
        this.TOCListField = ko.validatedObservable(settings.TOCListField);
        this.Hidden = ko.validatedObservable(settings.Hidden);
        this.IsParent = ko.validatedObservable(settings.IsParent);
        this.Context = ko.validatedObservable(settings.Context);
        this.SearchFieldDepth = ko.validatedObservable(settings.SearchFieldDepth);
        this.TitledDisplayGroup = ko.validatedObservable(settings.TitledDisplayGroup);
        this.DisplayGroup = ko.validatedObservable(settings.DisplayGroup);
        this.EditorMode = ko.validatedObservable(settings.EditorMode);
        this.SearchMode = ko.validatedObservable(settings.SearchMode);
        this.TOCItemMode = ko.validatedObservable(settings.TOCItemMode);
        this.HeaderField = ko.validatedObservable(settings.HeaderField);
        this.ShortForm = ko.validatedObservable(settings.ShortForm);
        this.LongForm = ko.validatedObservable(settings.LongForm);
        this.TitledResultsGroup = ko.validatedObservable(settings.TitledResultsGroup);
        this.ResultsGroup = ko.validatedObservable(settings.ResultsGroup);
        this.ResultsOrder = ko.validatedObservable(settings.ResultsOrder);
        this.InStaticPrimary = ko.validatedObservable(settings.InStaticPrimary);
        this.SortOrdinal = ko.validatedObservable(settings.SortOrdinal);
        this.ApiSummaryRelationship = ko.validatedObservable(settings.ApiSummaryRelationship);
        this.ApiDetailedRelationship = ko.validatedObservable(settings.ApiDetailedRelationship);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.LockParentOnChildEdit = ko.validatedObservable(settings.LockParentOnChildEdit);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.TOCOrdinal = ko.validatedObservable(settings.TOCOrdinal);
        this.SaveOrdinal = ko.validatedObservable(settings.SaveOrdinal);
        this.NoRecursionForATO = ko.validatedObservable(settings.NoRecursionForATO);
        this.NoRecursionForDTO = ko.validatedObservable(settings.NoRecursionForDTO);
        this.DisplayReadOnly = ko.validatedObservable(settings.DisplayReadOnly);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.FromEntity = ko.observable();
        this.LookupGroup = ko.observable();
        this.ToEntity = ko.observable();
        this.RelationshipLinks = ko.observableArray([]);
        this.Package = ko.observable();
        this.MVCAttributes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderEntityRelationshipGID != undefined) {
                loaded.BuilderEntityRelationshipGID(responseData.BuilderEntityRelationshipGID);
            }
            if (responseData.InheritedID != undefined) {
                loaded.InheritedID(responseData.InheritedID);
            }
            if (responseData.AttributeName != undefined) {
                loaded.AttributeName(responseData.AttributeName);
            }
            if (responseData.FieldOrdinal != undefined) {
                loaded.FieldOrdinal(responseData.FieldOrdinal);
            }
            if (responseData.SimpleDataType != undefined) {
                loaded.SimpleDataType(responseData.SimpleDataType);
            }
            if (responseData.DataType != undefined) {
                loaded.DataType(responseData.DataType);
            }
            if (responseData.HasGetter != undefined) {
                loaded.HasGetter(responseData.HasGetter);
            }
            if (responseData.HasSetter != undefined) {
                loaded.HasSetter(responseData.HasSetter);
            }
            if (responseData.BackpointedAttribute != undefined) {
                loaded.BackpointedAttribute(responseData.BackpointedAttribute);
            }
            if (responseData.ParentAttribute != undefined) {
                loaded.ParentAttribute(responseData.ParentAttribute);
            }
            if (responseData.TableName != undefined) {
                loaded.TableName(responseData.TableName);
            }
            if (responseData.EntityID != undefined) {
                loaded.EntityID(responseData.EntityID);
            }
            if (responseData.ToEntityID != undefined) {
                loaded.ToEntityID(responseData.ToEntityID);
            }
            if (responseData.Tooltip != undefined) {
                loaded.Tooltip(responseData.Tooltip);
            }
            if (responseData.RelationshipType != undefined) {
                loaded.RelationshipType(responseData.RelationshipType);
            }
            if (responseData.Transient != undefined) {
                loaded.Transient(responseData.Transient);
            }
            if (responseData.IsInherited != undefined) {
                loaded.IsInherited(responseData.IsInherited);
            }
            if (responseData.IsFK != undefined) {
                loaded.IsFK(responseData.IsFK);
            }
            if (responseData.IsRequired != undefined) {
                loaded.IsRequired(responseData.IsRequired);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Label != undefined) {
                loaded.Label(responseData.Label);
            }
            if (responseData.ShortLabel != undefined) {
                loaded.ShortLabel(responseData.ShortLabel);
            }
            if (responseData.Prompt != undefined) {
                loaded.Prompt(responseData.Prompt);
            }
            if (responseData.DefaultValue != undefined) {
                loaded.DefaultValue(responseData.DefaultValue);
            }
            if (responseData.CascadeAction != undefined) {
                loaded.CascadeAction(responseData.CascadeAction);
            }
            if (responseData.CsvDictionaryKeys != undefined) {
                loaded.CsvDictionaryKeys(responseData.CsvDictionaryKeys);
            }
            if (responseData.LookupGroupID != undefined) {
                loaded.LookupGroupID(responseData.LookupGroupID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.HierarchyType != undefined) {
                loaded.HierarchyType(responseData.HierarchyType);
            }
            if (responseData.InitializerType != undefined) {
                loaded.InitializerType(responseData.InitializerType);
            }
            if (responseData.Aggregated != undefined) {
                loaded.Aggregated(responseData.Aggregated);
            }
            if (responseData.AggregateRelationship != undefined) {
                loaded.AggregateRelationship(responseData.AggregateRelationship);
            }
            if (responseData.VersionAdded != undefined) {
                loaded.VersionAdded(responseData.VersionAdded);
            }
            if (responseData.VersionRemoved != undefined) {
                loaded.VersionRemoved(responseData.VersionRemoved);
            }
            if (responseData.ForeignKeyName != undefined) {
                loaded.ForeignKeyName(responseData.ForeignKeyName);
            }
            if (responseData.IsAnchor != undefined) {
                loaded.IsAnchor(responseData.IsAnchor);
            }
            if (responseData.Characteristics != undefined) {
                loaded.Characteristics(responseData.Characteristics);
            }
            if (responseData.SearchField != undefined) {
                loaded.SearchField(responseData.SearchField);
            }
            if (responseData.SearchResultField != undefined) {
                loaded.SearchResultField(responseData.SearchResultField);
            }
            if (responseData.PopupSearchField != undefined) {
                loaded.PopupSearchField(responseData.PopupSearchField);
            }
            if (responseData.PopupSearchResultField != undefined) {
                loaded.PopupSearchResultField(responseData.PopupSearchResultField);
            }
            if (responseData.LiveSearchResult != undefined) {
                loaded.LiveSearchResult(responseData.LiveSearchResult);
            }
            if (responseData.PopupJsonResult != undefined) {
                loaded.PopupJsonResult(responseData.PopupJsonResult);
            }
            if (responseData.SVDisplayField != undefined) {
                loaded.SVDisplayField(responseData.SVDisplayField);
            }
            if (responseData.TOCTableField != undefined) {
                loaded.TOCTableField(responseData.TOCTableField);
            }
            if (responseData.TOCListField != undefined) {
                loaded.TOCListField(responseData.TOCListField);
            }
            if (responseData.Hidden != undefined) {
                loaded.Hidden(responseData.Hidden);
            }
            if (responseData.IsParent != undefined) {
                loaded.IsParent(responseData.IsParent);
            }
            if (responseData.Context != undefined) {
                loaded.Context(responseData.Context);
            }
            if (responseData.SearchFieldDepth != undefined) {
                loaded.SearchFieldDepth(responseData.SearchFieldDepth);
            }
            if (responseData.TitledDisplayGroup != undefined) {
                loaded.TitledDisplayGroup(responseData.TitledDisplayGroup);
            }
            if (responseData.DisplayGroup != undefined) {
                loaded.DisplayGroup(responseData.DisplayGroup);
            }
            if (responseData.EditorMode != undefined) {
                loaded.EditorMode(responseData.EditorMode);
            }
            if (responseData.SearchMode != undefined) {
                loaded.SearchMode(responseData.SearchMode);
            }
            if (responseData.TOCItemMode != undefined) {
                loaded.TOCItemMode(responseData.TOCItemMode);
            }
            if (responseData.HeaderField != undefined) {
                loaded.HeaderField(responseData.HeaderField);
            }
            if (responseData.ShortForm != undefined) {
                loaded.ShortForm(responseData.ShortForm);
            }
            if (responseData.LongForm != undefined) {
                loaded.LongForm(responseData.LongForm);
            }
            if (responseData.TitledResultsGroup != undefined) {
                loaded.TitledResultsGroup(responseData.TitledResultsGroup);
            }
            if (responseData.ResultsGroup != undefined) {
                loaded.ResultsGroup(responseData.ResultsGroup);
            }
            if (responseData.ResultsOrder != undefined) {
                loaded.ResultsOrder(responseData.ResultsOrder);
            }
            if (responseData.InStaticPrimary != undefined) {
                loaded.InStaticPrimary(responseData.InStaticPrimary);
            }
            if (responseData.SortOrdinal != undefined) {
                loaded.SortOrdinal(responseData.SortOrdinal);
            }
            if (responseData.ApiSummaryRelationship != undefined) {
                loaded.ApiSummaryRelationship(responseData.ApiSummaryRelationship);
            }
            if (responseData.ApiDetailedRelationship != undefined) {
                loaded.ApiDetailedRelationship(responseData.ApiDetailedRelationship);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.LockParentOnChildEdit != undefined) {
                loaded.LockParentOnChildEdit(responseData.LockParentOnChildEdit);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.TOCOrdinal != undefined) {
                loaded.TOCOrdinal(responseData.TOCOrdinal);
            }
            if (responseData.SaveOrdinal != undefined) {
                loaded.SaveOrdinal(responseData.SaveOrdinal);
            }
            if (responseData.NoRecursionForATO != undefined) {
                loaded.NoRecursionForATO(responseData.NoRecursionForATO);
            }
            if (responseData.NoRecursionForDTO != undefined) {
                loaded.NoRecursionForDTO(responseData.NoRecursionForDTO);
            }
            if (responseData.DisplayReadOnly != undefined) {
                loaded.DisplayReadOnly(responseData.DisplayReadOnly);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.FromEntity != null) {
                loaded.FromEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.FromEntity));
            }
            if (responseData.LookupGroup != null) {
                loaded.LookupGroup(new smapi.entities.LookupGroupModel().LoadFromResponse(responseData.LookupGroup));
            }
            if (responseData.ToEntity != null) {
                loaded.ToEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.ToEntity));
            }
            if (responseData.RelationshipLinks != null && responseData.RelationshipLinks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RelationshipLinks.length; i++) {
                    items.push(new smapi.entities.EntityRelationshipLinkModel().LoadFromResponse(responseData.RelationshipLinks[i]));
                }
                loaded.RelationshipLinks(items);
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            if (responseData.MVCAttributes != null && responseData.MVCAttributes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MVCAttributes.length; i++) {
                    items.push(new smapi.entities.EntityRelationshipMVCAttributeModel().LoadFromResponse(responseData.MVCAttributes[i]));
                }
                loaded.MVCAttributes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityRelationship', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderEntityRelationshipGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.InheritedID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.AttributeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FieldOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SimpleDataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DataType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BackpointedAttribute.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ParentAttribute.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.TableName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ToEntityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Tooltip.extend({
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.RelationshipType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.Label.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ShortLabel.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Prompt.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DefaultValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CascadeAction.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.CsvDictionaryKeys.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LookupGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.HierarchyType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.InitializerType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AggregateRelationship.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.VersionAdded.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.VersionRemoved.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.ForeignKeyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Characteristics.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SearchFieldDepth.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TitledDisplayGroup.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.DisplayGroup.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.EditorMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SearchMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TOCItemMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TitledResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsGroup.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.ResultsOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TOCOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SaveOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityRelationshipLinkModel(options) {
        var defaults = {
            ParentID: 0,
            BuilderRelationshipLinkGID: null,
            RelationshipLinkType: '',
            MyLink: '',
            OtherLink: '',
            MyLinkProperty: '',
            OtherProperty: '',
            DefaultValue: '',
            LiteralValue: '',
            LinkOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.BuilderRelationshipLinkGID = ko.validatedObservable(settings.BuilderRelationshipLinkGID);
        this.RelationshipLinkType = ko.validatedObservable(settings.RelationshipLinkType);
        this.MyLink = ko.validatedObservable(settings.MyLink);
        this.OtherLink = ko.validatedObservable(settings.OtherLink);
        this.MyLinkProperty = ko.validatedObservable(settings.MyLinkProperty);
        this.OtherProperty = ko.validatedObservable(settings.OtherProperty);
        this.DefaultValue = ko.validatedObservable(settings.DefaultValue);
        this.LiteralValue = ko.validatedObservable(settings.LiteralValue);
        this.LinkOrder = ko.validatedObservable(settings.LinkOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.BuilderRelationshipLinkGID != undefined) {
                loaded.BuilderRelationshipLinkGID(responseData.BuilderRelationshipLinkGID);
            }
            if (responseData.RelationshipLinkType != undefined) {
                loaded.RelationshipLinkType(responseData.RelationshipLinkType);
            }
            if (responseData.MyLink != undefined) {
                loaded.MyLink(responseData.MyLink);
            }
            if (responseData.OtherLink != undefined) {
                loaded.OtherLink(responseData.OtherLink);
            }
            if (responseData.MyLinkProperty != undefined) {
                loaded.MyLinkProperty(responseData.MyLinkProperty);
            }
            if (responseData.OtherProperty != undefined) {
                loaded.OtherProperty(responseData.OtherProperty);
            }
            if (responseData.DefaultValue != undefined) {
                loaded.DefaultValue(responseData.DefaultValue);
            }
            if (responseData.LiteralValue != undefined) {
                loaded.LiteralValue(responseData.LiteralValue);
            }
            if (responseData.LinkOrder != undefined) {
                loaded.LinkOrder(responseData.LinkOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.EntityRelationshipModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityRelationshipLink', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BuilderRelationshipLinkGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.RelationshipLinkType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.MyLink.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.OtherLink.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MyLinkProperty.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.OtherProperty.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DefaultValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LiteralValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LinkOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CurrencyModel(options) {
        var defaults = {
            CultureCode: '',
            Code: '',
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CultureCode = ko.validatedObservable(settings.CultureCode);
        this.Code = ko.validatedObservable(settings.Code);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CultureCode != undefined) {
                loaded.CultureCode(responseData.CultureCode);
            }
            if (responseData.Code != undefined) {
                loaded.Code(responseData.Code);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Currency', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CultureCode.extend({
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.Code.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 3,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '3')
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityDBIndexModel(options) {
        var defaults = {
            BuilderDBIndexGID: null,
            Name: '',
            DBClustered: false,
            DBUnique: false,
            EntityID: 0,
            IsUserDefined: false,
            PackageID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderDBIndexGID = ko.validatedObservable(settings.BuilderDBIndexGID);
        this.Name = ko.validatedObservable(settings.Name);
        this.DBClustered = ko.validatedObservable(settings.DBClustered);
        this.DBUnique = ko.validatedObservable(settings.DBUnique);
        this.EntityID = ko.validatedObservable(settings.EntityID);
        this.IsUserDefined = ko.validatedObservable(settings.IsUserDefined);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Entity = ko.observable();
        this.Fields = ko.observableArray([]);
        this.Package = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderDBIndexGID != undefined) {
                loaded.BuilderDBIndexGID(responseData.BuilderDBIndexGID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.DBClustered != undefined) {
                loaded.DBClustered(responseData.DBClustered);
            }
            if (responseData.DBUnique != undefined) {
                loaded.DBUnique(responseData.DBUnique);
            }
            if (responseData.EntityID != undefined) {
                loaded.EntityID(responseData.EntityID);
            }
            if (responseData.IsUserDefined != undefined) {
                loaded.IsUserDefined(responseData.IsUserDefined);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Entity != null) {
                loaded.Entity(new smapi.entities.EntityModel().LoadFromResponse(responseData.Entity));
            }
            if (responseData.Fields != null && responseData.Fields.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Fields.length; i++) {
                    items.push(new smapi.entities.EntityDBIndexFieldModel().LoadFromResponse(responseData.Fields[i]));
                }
                loaded.Fields(items);
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityDBIndex', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderDBIndexGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.EntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityDBIndexFieldModel(options) {
        var defaults = {
            BuilderDBIndexFieldGID: null,
            Name: '',
            DBIndexID: 0,
            SortOrder: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BuilderDBIndexFieldGID = ko.validatedObservable(settings.BuilderDBIndexFieldGID);
        this.Name = ko.validatedObservable(settings.Name);
        this.DBIndexID = ko.validatedObservable(settings.DBIndexID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BuilderDBIndexFieldGID != undefined) {
                loaded.BuilderDBIndexFieldGID(responseData.BuilderDBIndexFieldGID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.DBIndexID != undefined) {
                loaded.DBIndexID(responseData.DBIndexID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.EntityDBIndexModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityDBIndexField', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BuilderDBIndexFieldGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DBIndexID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityFieldMVCAttributeModel(options) {
        var defaults = {
            ParentID: 0,
            Name: '',
            Value: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Value = ko.validatedObservable(settings.Value);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityFieldMVCAttribute', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityRelationshipMVCAttributeModel(options) {
        var defaults = {
            ParentID: 0,
            Name: '',
            Value: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Value = ko.validatedObservable(settings.Value);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Parent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.EntityRelationshipModel().LoadFromResponse(responseData.Parent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityRelationshipMVCAttribute', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ResourceRoleModel(options) {
        var defaults = {
            UserID: 0,
            RoleID: 0,
            ResourceID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.UserID = ko.validatedObservable(settings.UserID);
        this.RoleID = ko.validatedObservable(settings.RoleID);
        this.ResourceID = ko.validatedObservable(settings.ResourceID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Role = ko.observable();
        this.User = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.UserID != undefined) {
                loaded.UserID(responseData.UserID);
            }
            if (responseData.RoleID != undefined) {
                loaded.RoleID(responseData.RoleID);
            }
            if (responseData.ResourceID != undefined) {
                loaded.ResourceID(responseData.ResourceID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Role != null) {
                loaded.Role(new smapi.entities.RoleModel().LoadFromResponse(responseData.Role));
            }
            if (responseData.User != null) {
                loaded.User(new smapi.entities.UserModel().LoadFromResponse(responseData.User));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ResourceRole', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.UserID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RoleID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ResourceID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MatchListTargetModel(options) {
        var defaults = {
            PathToElement: '',
            MatchListID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PathToElement = ko.validatedObservable(settings.PathToElement);
        this.MatchListID = ko.validatedObservable(settings.MatchListID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MatchList = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PathToElement != undefined) {
                loaded.PathToElement(responseData.PathToElement);
            }
            if (responseData.MatchListID != undefined) {
                loaded.MatchListID(responseData.MatchListID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MatchList != null) {
                loaded.MatchList(new smapi.entities.MatchListModel().LoadFromResponse(responseData.MatchList));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.MatchListTarget', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PathToElement.extend({
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.MatchListID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MatchListModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            EntityGID: null,
            MatchCriteria: '',
            SortCriteria: '',
            Private: false,
            AdHoc: false,
            UserID: null,
            RefreshListID: null,
            ListPermissionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.EntityGID = ko.validatedObservable(settings.EntityGID);
        this.MatchCriteria = ko.validatedObservable(settings.MatchCriteria);
        this.SortCriteria = ko.validatedObservable(settings.SortCriteria);
        this.Private = ko.validatedObservable(settings.Private);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.UserID = ko.validatedObservable(settings.UserID);
        this.RefreshListID = ko.validatedObservable(settings.RefreshListID);
        this.ListPermissionID = ko.validatedObservable(settings.ListPermissionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MatchListItem = ko.observableArray([]);
        this.MatchListTargets = ko.observableArray([]);
        this.User = ko.observable();
        this.RefreshList = ko.observable();
        this.ListPermission = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.EntityGID != undefined) {
                loaded.EntityGID(responseData.EntityGID);
            }
            if (responseData.MatchCriteria != undefined) {
                loaded.MatchCriteria(responseData.MatchCriteria);
            }
            if (responseData.SortCriteria != undefined) {
                loaded.SortCriteria(responseData.SortCriteria);
            }
            if (responseData.Private != undefined) {
                loaded.Private(responseData.Private);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.UserID != undefined) {
                loaded.UserID(responseData.UserID);
            }
            if (responseData.RefreshListID != undefined) {
                loaded.RefreshListID(responseData.RefreshListID);
            }
            if (responseData.ListPermissionID != undefined) {
                loaded.ListPermissionID(responseData.ListPermissionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MatchListItem != null && responseData.MatchListItem.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MatchListItem.length; i++) {
                    items.push(new smapi.entities.MatchListItemModel().LoadFromResponse(responseData.MatchListItem[i]));
                }
                loaded.MatchListItem(items);
            }
            if (responseData.MatchListTargets != null && responseData.MatchListTargets.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MatchListTargets.length; i++) {
                    items.push(new smapi.entities.MatchListTargetModel().LoadFromResponse(responseData.MatchListTargets[i]));
                }
                loaded.MatchListTargets(items);
            }
            if (responseData.User != null) {
                loaded.User(new smapi.entities.UserModel().LoadFromResponse(responseData.User));
            }
            if (responseData.RefreshList != null) {
                loaded.RefreshList(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.RefreshList));
            }
            if (responseData.ListPermission != null) {
                loaded.ListPermission(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.ListPermission));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.MatchList', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 150,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '150')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EntityGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.MatchCriteria.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SortCriteria.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.UserID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RefreshListID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ListPermissionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MatchListItemModel(options) {
        var defaults = {
            ItemID: 0,
            MatchListID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ItemID = ko.validatedObservable(settings.ItemID);
        this.MatchListID = ko.validatedObservable(settings.MatchListID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MatchList = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ItemID != undefined) {
                loaded.ItemID(responseData.ItemID);
            }
            if (responseData.MatchListID != undefined) {
                loaded.MatchListID(responseData.MatchListID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MatchList != null) {
                loaded.MatchList(new smapi.entities.MatchListModel().LoadFromResponse(responseData.MatchList));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.MatchListItem', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ItemID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MatchListID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SystemLogModel(options) {
        var defaults = {
            OccurredWhen: null,
            HostName: '',
            Thread: '',
            TransactionId: '',
            EntityType: '',
            EntityKey: '',
            LogLevel: '',
            Location: '',
            UserName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.OccurredWhen = ko.validatedObservable(settings.OccurredWhen);
        this.HostName = ko.validatedObservable(settings.HostName);
        this.Thread = ko.validatedObservable(settings.Thread);
        this.TransactionId = ko.validatedObservable(settings.TransactionId);
        this.EntityType = ko.validatedObservable(settings.EntityType);
        this.EntityKey = ko.validatedObservable(settings.EntityKey);
        this.LogLevel = ko.validatedObservable(settings.LogLevel);
        this.Location = ko.validatedObservable(settings.Location);
        this.UserName = ko.validatedObservable(settings.UserName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.SystemLogMessage = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.OccurredWhen != undefined) {
                loaded.OccurredWhen(responseData.OccurredWhen);
            }
            if (responseData.HostName != undefined) {
                loaded.HostName(responseData.HostName);
            }
            if (responseData.Thread != undefined) {
                loaded.Thread(responseData.Thread);
            }
            if (responseData.TransactionId != undefined) {
                loaded.TransactionId(responseData.TransactionId);
            }
            if (responseData.EntityType != undefined) {
                loaded.EntityType(responseData.EntityType);
            }
            if (responseData.EntityKey != undefined) {
                loaded.EntityKey(responseData.EntityKey);
            }
            if (responseData.LogLevel != undefined) {
                loaded.LogLevel(responseData.LogLevel);
            }
            if (responseData.Location != undefined) {
                loaded.Location(responseData.Location);
            }
            if (responseData.UserName != undefined) {
                loaded.UserName(responseData.UserName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SystemLogMessage != null && responseData.SystemLogMessage.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.SystemLogMessage.length; i++) {
                    items.push(new smapi.entities.SystemLogMessageModel().LoadFromResponse(responseData.SystemLogMessage[i]));
                }
                loaded.SystemLogMessage(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SystemLog', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.OccurredWhen.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.HostName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Thread.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.TransactionId.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.EntityType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.EntityKey.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LogLevel.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 5,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '5')
            }
        });
        this.Location.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.UserName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SystemLogMessageModel(options) {
        var defaults = {
            SystemLogID: null,
            Message: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.SystemLogID = ko.validatedObservable(settings.SystemLogID);
        this.Message = ko.validatedObservable(settings.Message);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.SystemLog = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.SystemLogID != undefined) {
                loaded.SystemLogID(responseData.SystemLogID);
            }
            if (responseData.Message != undefined) {
                loaded.Message(responseData.Message);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SystemLog != null) {
                loaded.SystemLog(new smapi.entities.SystemLogModel().LoadFromResponse(responseData.SystemLog));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SystemLogMessage', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.SystemLogID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Message.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SystemLogExceptionModel(options) {
        var defaults = {
            SystemLogID: null,
            Exception: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.SystemLogID = ko.validatedObservable(settings.SystemLogID);
        this.Exception = ko.validatedObservable(settings.Exception);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.SystemLog = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.SystemLogID != undefined) {
                loaded.SystemLogID(responseData.SystemLogID);
            }
            if (responseData.Exception != undefined) {
                loaded.Exception(responseData.Exception);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SystemLog != null) {
                loaded.SystemLog(new smapi.entities.SystemLogModel().LoadFromResponse(responseData.SystemLog));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SystemLogException', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.SystemLogID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Exception.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SystemLogExtendedPropertyModel(options) {
        var defaults = {
            SystemLogID: null,
            ExtendedProperties: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.SystemLogID = ko.validatedObservable(settings.SystemLogID);
        this.ExtendedProperties = ko.validatedObservable(settings.ExtendedProperties);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.SystemLog = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.SystemLogID != undefined) {
                loaded.SystemLogID(responseData.SystemLogID);
            }
            if (responseData.ExtendedProperties != undefined) {
                loaded.ExtendedProperties(responseData.ExtendedProperties);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SystemLog != null) {
                loaded.SystemLog(new smapi.entities.SystemLogModel().LoadFromResponse(responseData.SystemLog));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SystemLogExtendedProperty', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.SystemLogID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExtendedProperties.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ReportExecModel(options) {
        var defaults = {
            UserID: 0,
            MatchListID: null,
            LocaleList: '',
            RunDate: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.UserID = ko.validatedObservable(settings.UserID);
        this.MatchListID = ko.validatedObservable(settings.MatchListID);
        this.LocaleList = ko.validatedObservable(settings.LocaleList);
        this.RunDate = ko.validatedObservable(settings.RunDate);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MatchList = ko.observable();
        this.User = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.UserID != undefined) {
                loaded.UserID(responseData.UserID);
            }
            if (responseData.MatchListID != undefined) {
                loaded.MatchListID(responseData.MatchListID);
            }
            if (responseData.LocaleList != undefined) {
                loaded.LocaleList(responseData.LocaleList);
            }
            if (responseData.RunDate != undefined) {
                loaded.RunDate(responseData.RunDate);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MatchList != null) {
                loaded.MatchList(new smapi.entities.MatchListModel().LoadFromResponse(responseData.MatchList));
            }
            if (responseData.User != null) {
                loaded.User(new smapi.entities.UserModel().LoadFromResponse(responseData.User));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ReportExec', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.UserID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MatchListID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LocaleList.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RunDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PermissionModel(options) {
        var defaults = {
            EntityPermissionID: null,
            SecuredObjectKeyString: '',
            PermissionSource: null,
            PermissionType: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.EntityPermissionID = ko.validatedObservable(settings.EntityPermissionID);
        this.SecuredObjectKeyString = ko.validatedObservable(settings.SecuredObjectKeyString);
        this.PermissionSource = ko.validatedObservable(settings.PermissionSource);
        this.PermissionType = ko.validatedObservable(settings.PermissionType);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Roles = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.EntityPermissionID != undefined) {
                loaded.EntityPermissionID(responseData.EntityPermissionID);
            }
            if (responseData.SecuredObjectKeyString != undefined) {
                loaded.SecuredObjectKeyString(responseData.SecuredObjectKeyString);
            }
            if (responseData.PermissionSource != undefined) {
                loaded.PermissionSource(responseData.PermissionSource);
            }
            if (responseData.PermissionType != undefined) {
                loaded.PermissionType(responseData.PermissionType);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Roles != null && responseData.Roles.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Roles.length; i++) {
                    items.push(new smapi.entities.RoleModel().LoadFromResponse(responseData.Roles[i]));
                }
                loaded.Roles(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Permission', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.EntityPermissionID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.SecuredObjectKeyString.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PermissionSource.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.PermissionType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RoleModel(options) {
        var defaults = {
            ApplicationID: 0,
            Name: '',
            Description: '',
            IsSystemRole: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ApplicationID = ko.validatedObservable(settings.ApplicationID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.IsSystemRole = ko.validatedObservable(settings.IsSystemRole);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Permissions = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ApplicationID != undefined) {
                loaded.ApplicationID(responseData.ApplicationID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.IsSystemRole != undefined) {
                loaded.IsSystemRole(responseData.IsSystemRole);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Permissions != null && responseData.Permissions.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Permissions.length; i++) {
                    items.push(new smapi.entities.PermissionModel().LoadFromResponse(responseData.Permissions[i]));
                }
                loaded.Permissions(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Role', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ApplicationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GroupLevelModel(options) {
        var defaults = {
            Name: '',
            GroupLevelWeight: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.GroupLevelWeight = ko.validatedObservable(settings.GroupLevelWeight);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Groups = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.GroupLevelWeight != undefined) {
                loaded.GroupLevelWeight(responseData.GroupLevelWeight);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Groups != null && responseData.Groups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Groups.length; i++) {
                    items.push(new smapi.entities.GroupModel().LoadFromResponse(responseData.Groups[i]));
                }
                loaded.Groups(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.GroupLevel', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupLevelWeight.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GroupRowAccessModel(options) {
        var defaults = {
            GroupID: 0,
            EntityTypeID: 0,
            EntityGID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.GroupID = ko.validatedObservable(settings.GroupID);
        this.EntityTypeID = ko.validatedObservable(settings.EntityTypeID);
        this.EntityGID = ko.validatedObservable(settings.EntityGID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Groups = ko.observable();
        this.EntityType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.GroupID != undefined) {
                loaded.GroupID(responseData.GroupID);
            }
            if (responseData.EntityTypeID != undefined) {
                loaded.EntityTypeID(responseData.EntityTypeID);
            }
            if (responseData.EntityGID != undefined) {
                loaded.EntityGID(responseData.EntityGID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Groups != null) {
                loaded.Groups(new smapi.entities.GroupModel().LoadFromResponse(responseData.Groups));
            }
            if (responseData.EntityType != null) {
                loaded.EntityType(new smapi.entities.EntityModel().LoadFromResponse(responseData.EntityType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.GroupRowAccess', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.GroupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EntityTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EntityGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityRowSecurityGroupsModel(options) {
        var defaults = {
            GroupID: 0,
            EntityTypeID: 0,
            EntityGID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.GroupID = ko.validatedObservable(settings.GroupID);
        this.EntityTypeID = ko.validatedObservable(settings.EntityTypeID);
        this.EntityGID = ko.validatedObservable(settings.EntityGID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Groups = ko.observable();
        this.EntityType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.GroupID != undefined) {
                loaded.GroupID(responseData.GroupID);
            }
            if (responseData.EntityTypeID != undefined) {
                loaded.EntityTypeID(responseData.EntityTypeID);
            }
            if (responseData.EntityGID != undefined) {
                loaded.EntityGID(responseData.EntityGID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Groups != null) {
                loaded.Groups(new smapi.entities.GroupModel().LoadFromResponse(responseData.Groups));
            }
            if (responseData.EntityType != null) {
                loaded.EntityType(new smapi.entities.EntityModel().LoadFromResponse(responseData.EntityType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityRowSecurityGroups', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.GroupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EntityTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EntityGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            GroupLevelID: null,
            ProviderID: null,
            ProviderKey: '',
            IsUnion: false,
            Abbreviation: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.GroupLevelID = ko.validatedObservable(settings.GroupLevelID);
        this.ProviderID = ko.validatedObservable(settings.ProviderID);
        this.ProviderKey = ko.validatedObservable(settings.ProviderKey);
        this.IsUnion = ko.validatedObservable(settings.IsUnion);
        this.Abbreviation = ko.validatedObservable(settings.Abbreviation);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GroupLevel = ko.observable();
        this.Groups = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.GroupLevelID != undefined) {
                loaded.GroupLevelID(responseData.GroupLevelID);
            }
            if (responseData.ProviderID != undefined) {
                loaded.ProviderID(responseData.ProviderID);
            }
            if (responseData.ProviderKey != undefined) {
                loaded.ProviderKey(responseData.ProviderKey);
            }
            if (responseData.IsUnion != undefined) {
                loaded.IsUnion(responseData.IsUnion);
            }
            if (responseData.Abbreviation != undefined) {
                loaded.Abbreviation(responseData.Abbreviation);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GroupLevel != null) {
                loaded.GroupLevel(new smapi.entities.GroupLevelModel().LoadFromResponse(responseData.GroupLevel));
            }
            if (responseData.Groups != null && responseData.Groups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Groups.length; i++) {
                    items.push(new smapi.entities.GroupModel().LoadFromResponse(responseData.Groups[i]));
                }
                loaded.Groups(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Group', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GroupLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProviderID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ProviderKey.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Abbreviation.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TRSRuleSetModel(options) {
        var defaults = {
            BoundTypeName: '',
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            WFVersion: null,
            RuleSetStr: '',
            FullTypeName: '',
            IsWebRule: false,
            ModuleID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BoundTypeName = ko.validatedObservable(settings.BoundTypeName);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.WFVersion = ko.validatedObservable(settings.WFVersion);
        this.RuleSetStr = ko.validatedObservable(settings.RuleSetStr);
        this.FullTypeName = ko.validatedObservable(settings.FullTypeName);
        this.IsWebRule = ko.validatedObservable(settings.IsWebRule);
        this.ModuleID = ko.validatedObservable(settings.ModuleID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Module = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BoundTypeName != undefined) {
                loaded.BoundTypeName(responseData.BoundTypeName);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.WFVersion != undefined) {
                loaded.WFVersion(responseData.WFVersion);
            }
            if (responseData.RuleSetStr != undefined) {
                loaded.RuleSetStr(responseData.RuleSetStr);
            }
            if (responseData.FullTypeName != undefined) {
                loaded.FullTypeName(responseData.FullTypeName);
            }
            if (responseData.IsWebRule != undefined) {
                loaded.IsWebRule(responseData.IsWebRule);
            }
            if (responseData.ModuleID != undefined) {
                loaded.ModuleID(responseData.ModuleID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Module != null) {
                loaded.Module(new smapi.entities.ModuleModel().LoadFromResponse(responseData.Module));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.TRSRuleSet', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BoundTypeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.WFVersion.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.RuleSetStr.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.FullTypeName.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ModuleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonalizationPathModel(options) {
        var defaults = {
            ActualPath: '',
            LoweredPath: '',
            WebApplicationID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ActualPath = ko.validatedObservable(settings.ActualPath);
        this.LoweredPath = ko.validatedObservable(settings.LoweredPath);
        this.WebApplicationID = ko.validatedObservable(settings.WebApplicationID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.WebApplication = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ActualPath != undefined) {
                loaded.ActualPath(responseData.ActualPath);
            }
            if (responseData.LoweredPath != undefined) {
                loaded.LoweredPath(responseData.LoweredPath);
            }
            if (responseData.WebApplicationID != undefined) {
                loaded.WebApplicationID(responseData.WebApplicationID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.WebApplication != null) {
                loaded.WebApplication(new smapi.entities.WebApplicationModel().LoadFromResponse(responseData.WebApplication));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.PersonalizationPath', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ActualPath.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LoweredPath.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.WebApplicationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonalizationAllUsersModel(options) {
        var defaults = {
            PageSettings: null,
            LastUpdatedDate: null,
            PathID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PageSettings = ko.validatedObservable(settings.PageSettings);
        this.LastUpdatedDate = ko.validatedObservable(settings.LastUpdatedDate);
        this.PathID = ko.validatedObservable(settings.PathID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Path = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PageSettings != undefined) {
                loaded.PageSettings(responseData.PageSettings);
            }
            if (responseData.LastUpdatedDate != undefined) {
                loaded.LastUpdatedDate(responseData.LastUpdatedDate);
            }
            if (responseData.PathID != undefined) {
                loaded.PathID(responseData.PathID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Path != null) {
                loaded.Path(new smapi.entities.PersonalizationPathModel().LoadFromResponse(responseData.Path));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.PersonalizationAllUsers', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PageSettings.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.LastUpdatedDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PathID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonalizationPerUserModel(options) {
        var defaults = {
            PageSettings: null,
            LastUpdatedDate: null,
            PathID: 0,
            UserID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PageSettings = ko.validatedObservable(settings.PageSettings);
        this.LastUpdatedDate = ko.validatedObservable(settings.LastUpdatedDate);
        this.PathID = ko.validatedObservable(settings.PathID);
        this.UserID = ko.validatedObservable(settings.UserID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Path = ko.observable();
        this.User = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PageSettings != undefined) {
                loaded.PageSettings(responseData.PageSettings);
            }
            if (responseData.LastUpdatedDate != undefined) {
                loaded.LastUpdatedDate(responseData.LastUpdatedDate);
            }
            if (responseData.PathID != undefined) {
                loaded.PathID(responseData.PathID);
            }
            if (responseData.UserID != undefined) {
                loaded.UserID(responseData.UserID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Path != null) {
                loaded.Path(new smapi.entities.PersonalizationPathModel().LoadFromResponse(responseData.Path));
            }
            if (responseData.User != null) {
                loaded.User(new smapi.entities.UserModel().LoadFromResponse(responseData.User));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.PersonalizationPerUser', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PageSettings.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.LastUpdatedDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PathID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UserID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ProfileModel(options) {
        var defaults = {
            PropertyNames: '',
            PropertyValuesString: '',
            PropertyValuesBinary: null,
            LastUpdatedDate: null,
            UserID: 0,
            SiteID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PropertyNames = ko.validatedObservable(settings.PropertyNames);
        this.PropertyValuesString = ko.validatedObservable(settings.PropertyValuesString);
        this.PropertyValuesBinary = ko.validatedObservable(settings.PropertyValuesBinary);
        this.LastUpdatedDate = ko.validatedObservable(settings.LastUpdatedDate);
        this.UserID = ko.validatedObservable(settings.UserID);
        this.SiteID = ko.validatedObservable(settings.SiteID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.User = ko.observable();
        this.Site = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PropertyNames != undefined) {
                loaded.PropertyNames(responseData.PropertyNames);
            }
            if (responseData.PropertyValuesString != undefined) {
                loaded.PropertyValuesString(responseData.PropertyValuesString);
            }
            if (responseData.PropertyValuesBinary != undefined) {
                loaded.PropertyValuesBinary(responseData.PropertyValuesBinary);
            }
            if (responseData.LastUpdatedDate != undefined) {
                loaded.LastUpdatedDate(responseData.LastUpdatedDate);
            }
            if (responseData.UserID != undefined) {
                loaded.UserID(responseData.UserID);
            }
            if (responseData.SiteID != undefined) {
                loaded.SiteID(responseData.SiteID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.User != null) {
                loaded.User(new smapi.entities.UserModel().LoadFromResponse(responseData.User));
            }
            if (responseData.Site != null) {
                loaded.Site(new smapi.entities.SiteModel().LoadFromResponse(responseData.Site));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Profile', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PropertyNames.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.PropertyValuesString.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.PropertyValuesBinary.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.LastUpdatedDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.UserID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SiteID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function FlintCredentialModel(options) {
        var defaults = {
            Value: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Value = ko.validatedObservable(settings.Value);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.FlintCredential', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function IconModel(options) {
        var defaults = {
            Name: '',
            IconFile: '',
            ThemedIconFile: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.IconFile = ko.validatedObservable(settings.IconFile);
        this.ThemedIconFile = ko.validatedObservable(settings.ThemedIconFile);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.IconFile != undefined) {
                loaded.IconFile(responseData.IconFile);
            }
            if (responseData.ThemedIconFile != undefined) {
                loaded.ThemedIconFile(responseData.ThemedIconFile);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Icon', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.IconFile.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ThemedIconFile.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AlertModel(options) {
        var defaults = {
            Name: '',
            AlertDate: null,
            AlertTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.AlertDate = ko.validatedObservable(settings.AlertDate);
        this.AlertTypeID = ko.validatedObservable(settings.AlertTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AlertType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.AlertDate != undefined) {
                loaded.AlertDate(responseData.AlertDate);
            }
            if (responseData.AlertTypeID != undefined) {
                loaded.AlertTypeID(responseData.AlertTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AlertType != null) {
                loaded.AlertType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.AlertType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Alert', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.AlertDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AlertTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function UserRuleSetModel(options) {
        var defaults = {
            UserID: 0,
            RuleSetID: 0,
            ParentRuleSetID: null,
            OriginalAncestorRuleSetID: null,
            Stale: false,
            StaleAsOfDate: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.UserID = ko.validatedObservable(settings.UserID);
        this.RuleSetID = ko.validatedObservable(settings.RuleSetID);
        this.ParentRuleSetID = ko.validatedObservable(settings.ParentRuleSetID);
        this.OriginalAncestorRuleSetID = ko.validatedObservable(settings.OriginalAncestorRuleSetID);
        this.Stale = ko.validatedObservable(settings.Stale);
        this.StaleAsOfDate = ko.validatedObservable(settings.StaleAsOfDate);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.User = ko.observable();
        this.RuleSet = ko.observable();
        this.ParentRuleSet = ko.observable();
        this.OriginalAncestorRuleSet = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.UserID != undefined) {
                loaded.UserID(responseData.UserID);
            }
            if (responseData.RuleSetID != undefined) {
                loaded.RuleSetID(responseData.RuleSetID);
            }
            if (responseData.ParentRuleSetID != undefined) {
                loaded.ParentRuleSetID(responseData.ParentRuleSetID);
            }
            if (responseData.OriginalAncestorRuleSetID != undefined) {
                loaded.OriginalAncestorRuleSetID(responseData.OriginalAncestorRuleSetID);
            }
            if (responseData.Stale != undefined) {
                loaded.Stale(responseData.Stale);
            }
            if (responseData.StaleAsOfDate != undefined) {
                loaded.StaleAsOfDate(responseData.StaleAsOfDate);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.User != null) {
                loaded.User(new smapi.entities.UserModel().LoadFromResponse(responseData.User));
            }
            if (responseData.RuleSet != null) {
                loaded.RuleSet(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.RuleSet));
            }
            if (responseData.ParentRuleSet != null) {
                loaded.ParentRuleSet(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.ParentRuleSet));
            }
            if (responseData.OriginalAncestorRuleSet != null) {
                loaded.OriginalAncestorRuleSet(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.OriginalAncestorRuleSet));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.UserRuleSet', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.UserID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RuleSetID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OriginalAncestorRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StaleAsOfDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GroupRuleSetModel(options) {
        var defaults = {
            GroupID: 0,
            RuleSetID: 0,
            ParentRuleSetID: null,
            OriginalAncestorRuleSetID: null,
            Stale: false,
            StaleAsOfDate: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.GroupID = ko.validatedObservable(settings.GroupID);
        this.RuleSetID = ko.validatedObservable(settings.RuleSetID);
        this.ParentRuleSetID = ko.validatedObservable(settings.ParentRuleSetID);
        this.OriginalAncestorRuleSetID = ko.validatedObservable(settings.OriginalAncestorRuleSetID);
        this.Stale = ko.validatedObservable(settings.Stale);
        this.StaleAsOfDate = ko.validatedObservable(settings.StaleAsOfDate);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Group = ko.observable();
        this.RuleSet = ko.observable();
        this.ParentRuleSet = ko.observable();
        this.OriginalAncestorRuleSet = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.GroupID != undefined) {
                loaded.GroupID(responseData.GroupID);
            }
            if (responseData.RuleSetID != undefined) {
                loaded.RuleSetID(responseData.RuleSetID);
            }
            if (responseData.ParentRuleSetID != undefined) {
                loaded.ParentRuleSetID(responseData.ParentRuleSetID);
            }
            if (responseData.OriginalAncestorRuleSetID != undefined) {
                loaded.OriginalAncestorRuleSetID(responseData.OriginalAncestorRuleSetID);
            }
            if (responseData.Stale != undefined) {
                loaded.Stale(responseData.Stale);
            }
            if (responseData.StaleAsOfDate != undefined) {
                loaded.StaleAsOfDate(responseData.StaleAsOfDate);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Group != null) {
                loaded.Group(new smapi.entities.GroupModel().LoadFromResponse(responseData.Group));
            }
            if (responseData.RuleSet != null) {
                loaded.RuleSet(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.RuleSet));
            }
            if (responseData.ParentRuleSet != null) {
                loaded.ParentRuleSet(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.ParentRuleSet));
            }
            if (responseData.OriginalAncestorRuleSet != null) {
                loaded.OriginalAncestorRuleSet(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.OriginalAncestorRuleSet));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.GroupRuleSet', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.GroupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RuleSetID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OriginalAncestorRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StaleAsOfDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DataChangedWatcherModel(options) {
        var defaults = {
            Name: '',
            PathToWorkflowBO: '',
            WorkfowInitiationRuleset: null,
            BusinessMeaningName: '',
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.PathToWorkflowBO = ko.validatedObservable(settings.PathToWorkflowBO);
        this.WorkfowInitiationRuleset = ko.validatedObservable(settings.WorkfowInitiationRuleset);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Properties = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.PathToWorkflowBO != undefined) {
                loaded.PathToWorkflowBO(responseData.PathToWorkflowBO);
            }
            if (responseData.WorkfowInitiationRuleset != undefined) {
                loaded.WorkfowInitiationRuleset(responseData.WorkfowInitiationRuleset);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Properties != null && responseData.Properties.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Properties.length; i++) {
                    items.push(new smapi.entities.DataChangedWatchPropertyModel().LoadFromResponse(responseData.Properties[i]));
                }
                loaded.Properties(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.DataChangedWatcher', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PathToWorkflowBO.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.WorkfowInitiationRuleset.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DataChangedWatchPropertyModel(options) {
        var defaults = {
            Name: '',
            EntityFieldID: null,
            BusinessMeaningName: '',
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.EntityFieldID = ko.validatedObservable(settings.EntityFieldID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EntityField = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.EntityFieldID != undefined) {
                loaded.EntityFieldID(responseData.EntityFieldID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EntityField != null) {
                loaded.EntityField(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.EntityField));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.DataChangedWatchProperty', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.EntityFieldID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LoggerModel(options) {
        var defaults = {
            CorrelationID: '',
            WhenLogged: null,
            Elapsed: null,
            UserName: '',
            HttpMethod: '',
            URL: '',
            Details: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CorrelationID = ko.validatedObservable(settings.CorrelationID);
        this.WhenLogged = ko.validatedObservable(settings.WhenLogged);
        this.Elapsed = ko.validatedObservable(settings.Elapsed);
        this.UserName = ko.validatedObservable(settings.UserName);
        this.HttpMethod = ko.validatedObservable(settings.HttpMethod);
        this.URL = ko.validatedObservable(settings.URL);
        this.Details = ko.validatedObservable(settings.Details);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CorrelationID != undefined) {
                loaded.CorrelationID(responseData.CorrelationID);
            }
            if (responseData.WhenLogged != undefined) {
                loaded.WhenLogged(responseData.WhenLogged);
            }
            if (responseData.Elapsed != undefined) {
                loaded.Elapsed(responseData.Elapsed);
            }
            if (responseData.UserName != undefined) {
                loaded.UserName(responseData.UserName);
            }
            if (responseData.HttpMethod != undefined) {
                loaded.HttpMethod(responseData.HttpMethod);
            }
            if (responseData.URL != undefined) {
                loaded.URL(responseData.URL);
            }
            if (responseData.Details != undefined) {
                loaded.Details(responseData.Details);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Logger', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CorrelationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 38,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '38')
            }
        });
        this.WhenLogged.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Elapsed.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.UserName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.HttpMethod.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4')
            }
        });
        this.URL.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 2000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '2000')
            }
        });
        this.Details.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LookupTablesLoaderModel(options) {
        var defaults = {
            Name: '',
            Type: '',
            Active: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Type = ko.validatedObservable(settings.Type);
        this.Active = ko.validatedObservable(settings.Active);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Type != undefined) {
                loaded.Type(responseData.Type);
            }
            if (responseData.Active != undefined) {
                loaded.Active(responseData.Active);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.LookupTablesLoader', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Type.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function FlintSettingModel(options) {
        var defaults = {
            ApplicationName: '',
            SiteName: '',
            AllowedLocales: '',
            SystemLocales: '',
            AlwaysPromptUser: '',
            ChartImageHandler: '',
            ExternalGroupRuleSet: '',
            AllowedAssemblies: '',
            LoadWatchers: '',
            ReportServerUrl: '',
            ExtraLogging: '',
            DefaultTheme: '',
            EditModeGroup: '',
            EnableAJAX: '',
            ShowRawException: '',
            RecreateCounterCategories: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ApplicationName = ko.validatedObservable(settings.ApplicationName);
        this.SiteName = ko.validatedObservable(settings.SiteName);
        this.AllowedLocales = ko.validatedObservable(settings.AllowedLocales);
        this.SystemLocales = ko.validatedObservable(settings.SystemLocales);
        this.AlwaysPromptUser = ko.validatedObservable(settings.AlwaysPromptUser);
        this.ChartImageHandler = ko.validatedObservable(settings.ChartImageHandler);
        this.ExternalGroupRuleSet = ko.validatedObservable(settings.ExternalGroupRuleSet);
        this.AllowedAssemblies = ko.validatedObservable(settings.AllowedAssemblies);
        this.LoadWatchers = ko.validatedObservable(settings.LoadWatchers);
        this.ReportServerUrl = ko.validatedObservable(settings.ReportServerUrl);
        this.ExtraLogging = ko.validatedObservable(settings.ExtraLogging);
        this.DefaultTheme = ko.validatedObservable(settings.DefaultTheme);
        this.EditModeGroup = ko.validatedObservable(settings.EditModeGroup);
        this.EnableAJAX = ko.validatedObservable(settings.EnableAJAX);
        this.ShowRawException = ko.validatedObservable(settings.ShowRawException);
        this.RecreateCounterCategories = ko.validatedObservable(settings.RecreateCounterCategories);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ApplicationName != undefined) {
                loaded.ApplicationName(responseData.ApplicationName);
            }
            if (responseData.SiteName != undefined) {
                loaded.SiteName(responseData.SiteName);
            }
            if (responseData.AllowedLocales != undefined) {
                loaded.AllowedLocales(responseData.AllowedLocales);
            }
            if (responseData.SystemLocales != undefined) {
                loaded.SystemLocales(responseData.SystemLocales);
            }
            if (responseData.AlwaysPromptUser != undefined) {
                loaded.AlwaysPromptUser(responseData.AlwaysPromptUser);
            }
            if (responseData.ChartImageHandler != undefined) {
                loaded.ChartImageHandler(responseData.ChartImageHandler);
            }
            if (responseData.ExternalGroupRuleSet != undefined) {
                loaded.ExternalGroupRuleSet(responseData.ExternalGroupRuleSet);
            }
            if (responseData.AllowedAssemblies != undefined) {
                loaded.AllowedAssemblies(responseData.AllowedAssemblies);
            }
            if (responseData.LoadWatchers != undefined) {
                loaded.LoadWatchers(responseData.LoadWatchers);
            }
            if (responseData.ReportServerUrl != undefined) {
                loaded.ReportServerUrl(responseData.ReportServerUrl);
            }
            if (responseData.ExtraLogging != undefined) {
                loaded.ExtraLogging(responseData.ExtraLogging);
            }
            if (responseData.DefaultTheme != undefined) {
                loaded.DefaultTheme(responseData.DefaultTheme);
            }
            if (responseData.EditModeGroup != undefined) {
                loaded.EditModeGroup(responseData.EditModeGroup);
            }
            if (responseData.EnableAJAX != undefined) {
                loaded.EnableAJAX(responseData.EnableAJAX);
            }
            if (responseData.ShowRawException != undefined) {
                loaded.ShowRawException(responseData.ShowRawException);
            }
            if (responseData.RecreateCounterCategories != undefined) {
                loaded.RecreateCounterCategories(responseData.RecreateCounterCategories);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.FlintSetting', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ApplicationName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SiteName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.AllowedLocales.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SystemLocales.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.AlwaysPromptUser.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ChartImageHandler.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ExternalGroupRuleSet.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.AllowedAssemblies.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.LoadWatchers.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ReportServerUrl.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ExtraLogging.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.DefaultTheme.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.EditModeGroup.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.EnableAJAX.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ShowRawException.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.RecreateCounterCategories.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ReportModel(options) {
        var defaults = {
            MenuText: '',
            ShowInReportsPane: false,
            ReportPath: '',
            Description: '',
            MenuPath: '',
            Title: '',
            SortOrder: 0,
            MVCActionID: null,
            ReportParametersModel: '',
            OutputFormatID: null,
            ReportTypeID: null,
            FilterCriteria: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.MenuText = ko.validatedObservable(settings.MenuText);
        this.ShowInReportsPane = ko.validatedObservable(settings.ShowInReportsPane);
        this.ReportPath = ko.validatedObservable(settings.ReportPath);
        this.Description = ko.validatedObservable(settings.Description);
        this.MenuPath = ko.validatedObservable(settings.MenuPath);
        this.Title = ko.validatedObservable(settings.Title);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.MVCActionID = ko.validatedObservable(settings.MVCActionID);
        this.ReportParametersModel = ko.validatedObservable(settings.ReportParametersModel);
        this.OutputFormatID = ko.validatedObservable(settings.OutputFormatID);
        this.ReportTypeID = ko.validatedObservable(settings.ReportTypeID);
        this.FilterCriteria = ko.validatedObservable(settings.FilterCriteria);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MVCAction = ko.observable();
        this.ReportFields = ko.observableArray([]);
        this.ReportFilters = ko.observableArray([]);
        this.ReportGroups = ko.observableArray([]);
        this.OutputFormat = ko.observable();
        this.ReportType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.MenuText != undefined) {
                loaded.MenuText(responseData.MenuText);
            }
            if (responseData.ShowInReportsPane != undefined) {
                loaded.ShowInReportsPane(responseData.ShowInReportsPane);
            }
            if (responseData.ReportPath != undefined) {
                loaded.ReportPath(responseData.ReportPath);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.MenuPath != undefined) {
                loaded.MenuPath(responseData.MenuPath);
            }
            if (responseData.Title != undefined) {
                loaded.Title(responseData.Title);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.MVCActionID != undefined) {
                loaded.MVCActionID(responseData.MVCActionID);
            }
            if (responseData.ReportParametersModel != undefined) {
                loaded.ReportParametersModel(responseData.ReportParametersModel);
            }
            if (responseData.OutputFormatID != undefined) {
                loaded.OutputFormatID(responseData.OutputFormatID);
            }
            if (responseData.ReportTypeID != undefined) {
                loaded.ReportTypeID(responseData.ReportTypeID);
            }
            if (responseData.FilterCriteria != undefined) {
                loaded.FilterCriteria(responseData.FilterCriteria);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MVCAction != null) {
                loaded.MVCAction(new smapi.entities.MVCActionModel().LoadFromResponse(responseData.MVCAction));
            }
            if (responseData.ReportFields != null && responseData.ReportFields.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReportFields.length; i++) {
                    items.push(new smapi.entities.ReportFieldModel().LoadFromResponse(responseData.ReportFields[i]));
                }
                loaded.ReportFields(items);
            }
            if (responseData.ReportFilters != null && responseData.ReportFilters.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReportFilters.length; i++) {
                    items.push(new smapi.entities.ReportFilterModel().LoadFromResponse(responseData.ReportFilters[i]));
                }
                loaded.ReportFilters(items);
            }
            if (responseData.ReportGroups != null && responseData.ReportGroups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReportGroups.length; i++) {
                    items.push(new smapi.entities.ReportGroupModel().LoadFromResponse(responseData.ReportGroups[i]));
                }
                loaded.ReportGroups(items);
            }
            if (responseData.OutputFormat != null) {
                loaded.OutputFormat(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.OutputFormat));
            }
            if (responseData.ReportType != null) {
                loaded.ReportType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.ReportType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Report', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.MenuText.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ReportPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.MenuPath.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Title.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MVCActionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReportParametersModel.extend({
            maxLength: {
                params: 200,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '200')
            }
        });
        this.OutputFormatID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReportTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ReportLabelModel(options) {
        var defaults = {
            FieldPath: '',
            Label: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.FieldPath = ko.validatedObservable(settings.FieldPath);
        this.Label = ko.validatedObservable(settings.Label);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.FieldPath != undefined) {
                loaded.FieldPath(responseData.FieldPath);
            }
            if (responseData.Label != undefined) {
                loaded.Label(responseData.Label);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ReportLabel', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.FieldPath.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 256,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '256')
            }
        });
        this.Label.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 256,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '256')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ReportFieldModel(options) {
        var defaults = {
            EntityFieldID: null,
            FormatID: null,
            DecimalPlacesID: null,
            AggregateFunctionID: null,
            ShowThousands: false,
            ShowCurrency: false,
            AdvancedFieldName: '',
            DisplayLabel: '',
            SortOrder: 0,
            ExpressionPath: '',
            ExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.EntityFieldID = ko.validatedObservable(settings.EntityFieldID);
        this.FormatID = ko.validatedObservable(settings.FormatID);
        this.DecimalPlacesID = ko.validatedObservable(settings.DecimalPlacesID);
        this.AggregateFunctionID = ko.validatedObservable(settings.AggregateFunctionID);
        this.ShowThousands = ko.validatedObservable(settings.ShowThousands);
        this.ShowCurrency = ko.validatedObservable(settings.ShowCurrency);
        this.AdvancedFieldName = ko.validatedObservable(settings.AdvancedFieldName);
        this.DisplayLabel = ko.validatedObservable(settings.DisplayLabel);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ExpressionPath = ko.validatedObservable(settings.ExpressionPath);
        this.ExpressionID = ko.validatedObservable(settings.ExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EntityField = ko.observable();
        this.Format = ko.observable();
        this.AggregateFunction = ko.observable();
        this.DecimalPlaces = ko.observable();
        this.Expression = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.EntityFieldID != undefined) {
                loaded.EntityFieldID(responseData.EntityFieldID);
            }
            if (responseData.FormatID != undefined) {
                loaded.FormatID(responseData.FormatID);
            }
            if (responseData.DecimalPlacesID != undefined) {
                loaded.DecimalPlacesID(responseData.DecimalPlacesID);
            }
            if (responseData.AggregateFunctionID != undefined) {
                loaded.AggregateFunctionID(responseData.AggregateFunctionID);
            }
            if (responseData.ShowThousands != undefined) {
                loaded.ShowThousands(responseData.ShowThousands);
            }
            if (responseData.ShowCurrency != undefined) {
                loaded.ShowCurrency(responseData.ShowCurrency);
            }
            if (responseData.AdvancedFieldName != undefined) {
                loaded.AdvancedFieldName(responseData.AdvancedFieldName);
            }
            if (responseData.DisplayLabel != undefined) {
                loaded.DisplayLabel(responseData.DisplayLabel);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ExpressionPath != undefined) {
                loaded.ExpressionPath(responseData.ExpressionPath);
            }
            if (responseData.ExpressionID != undefined) {
                loaded.ExpressionID(responseData.ExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EntityField != null) {
                loaded.EntityField(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.EntityField));
            }
            if (responseData.Format != null) {
                loaded.Format(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Format));
            }
            if (responseData.AggregateFunction != null) {
                loaded.AggregateFunction(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.AggregateFunction));
            }
            if (responseData.DecimalPlaces != null) {
                loaded.DecimalPlaces(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.DecimalPlaces));
            }
            if (responseData.Expression != null) {
                loaded.Expression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.Expression));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ReportField', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.EntityFieldID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FormatID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DecimalPlacesID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AggregateFunctionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdvancedFieldName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DisplayLabel.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpressionPath.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ReportFilterModel(options) {
        var defaults = {
            EntityFieldID: null,
            OperatorID: null,
            ComparisonValue: '',
            UseAsParameter: false,
            LogicalOperator: null,
            SortOrder: 0,
            AdvancedFieldName: '',
            ExpressionPath: '',
            ExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.EntityFieldID = ko.validatedObservable(settings.EntityFieldID);
        this.OperatorID = ko.validatedObservable(settings.OperatorID);
        this.ComparisonValue = ko.validatedObservable(settings.ComparisonValue);
        this.UseAsParameter = ko.validatedObservable(settings.UseAsParameter);
        this.LogicalOperator = ko.validatedObservable(settings.LogicalOperator);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.AdvancedFieldName = ko.validatedObservable(settings.AdvancedFieldName);
        this.ExpressionPath = ko.validatedObservable(settings.ExpressionPath);
        this.ExpressionID = ko.validatedObservable(settings.ExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EntityField = ko.observable();
        this.Operator = ko.observable();
        this.Expression = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.EntityFieldID != undefined) {
                loaded.EntityFieldID(responseData.EntityFieldID);
            }
            if (responseData.OperatorID != undefined) {
                loaded.OperatorID(responseData.OperatorID);
            }
            if (responseData.ComparisonValue != undefined) {
                loaded.ComparisonValue(responseData.ComparisonValue);
            }
            if (responseData.UseAsParameter != undefined) {
                loaded.UseAsParameter(responseData.UseAsParameter);
            }
            if (responseData.LogicalOperator != undefined) {
                loaded.LogicalOperator(responseData.LogicalOperator);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.AdvancedFieldName != undefined) {
                loaded.AdvancedFieldName(responseData.AdvancedFieldName);
            }
            if (responseData.ExpressionPath != undefined) {
                loaded.ExpressionPath(responseData.ExpressionPath);
            }
            if (responseData.ExpressionID != undefined) {
                loaded.ExpressionID(responseData.ExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EntityField != null) {
                loaded.EntityField(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.EntityField));
            }
            if (responseData.Operator != null) {
                loaded.Operator(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Operator));
            }
            if (responseData.Expression != null) {
                loaded.Expression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.Expression));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ReportFilter', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.EntityFieldID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OperatorID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ComparisonValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdvancedFieldName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExpressionPath.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ReportGroupModel(options) {
        var defaults = {
            EntityFieldID: null,
            ShowDetailRows: false,
            ShowHeaderRow: false,
            ShowFooterRow: false,
            SortOrder: 0,
            AdvancedFieldName: '',
            ExpressionPath: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.EntityFieldID = ko.validatedObservable(settings.EntityFieldID);
        this.ShowDetailRows = ko.validatedObservable(settings.ShowDetailRows);
        this.ShowHeaderRow = ko.validatedObservable(settings.ShowHeaderRow);
        this.ShowFooterRow = ko.validatedObservable(settings.ShowFooterRow);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.AdvancedFieldName = ko.validatedObservable(settings.AdvancedFieldName);
        this.ExpressionPath = ko.validatedObservable(settings.ExpressionPath);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EntityField = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.EntityFieldID != undefined) {
                loaded.EntityFieldID(responseData.EntityFieldID);
            }
            if (responseData.ShowDetailRows != undefined) {
                loaded.ShowDetailRows(responseData.ShowDetailRows);
            }
            if (responseData.ShowHeaderRow != undefined) {
                loaded.ShowHeaderRow(responseData.ShowHeaderRow);
            }
            if (responseData.ShowFooterRow != undefined) {
                loaded.ShowFooterRow(responseData.ShowFooterRow);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.AdvancedFieldName != undefined) {
                loaded.AdvancedFieldName(responseData.AdvancedFieldName);
            }
            if (responseData.ExpressionPath != undefined) {
                loaded.ExpressionPath(responseData.ExpressionPath);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EntityField != null) {
                loaded.EntityField(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.EntityField));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ReportGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.EntityFieldID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdvancedFieldName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExpressionPath.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TenantModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Tenant', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MenuItemModel(options) {
        var defaults = {
            ParentID: null,
            MenuItemSectionID: null,
            Name: '',
            Description: '',
            IsReportingMenu: false,
            NavigateToURL: '',
            ImageURL: '',
            ModuleID: null,
            Target: '',
            MenuSequence: 0,
            SortOrdinal: 0,
            BusinessMeaningName: '',
            MVCActionID: null,
            Placeholder: false,
            Location: '',
            GlossaryParentID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ParentID = ko.validatedObservable(settings.ParentID);
        this.MenuItemSectionID = ko.validatedObservable(settings.MenuItemSectionID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.IsReportingMenu = ko.validatedObservable(settings.IsReportingMenu);
        this.NavigateToURL = ko.validatedObservable(settings.NavigateToURL);
        this.ImageURL = ko.validatedObservable(settings.ImageURL);
        this.ModuleID = ko.validatedObservable(settings.ModuleID);
        this.Target = ko.validatedObservable(settings.Target);
        this.MenuSequence = ko.validatedObservable(settings.MenuSequence);
        this.SortOrdinal = ko.validatedObservable(settings.SortOrdinal);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.MVCActionID = ko.validatedObservable(settings.MVCActionID);
        this.Placeholder = ko.validatedObservable(settings.Placeholder);
        this.Location = ko.validatedObservable(settings.Location);
        this.GlossaryParentID = ko.validatedObservable(settings.GlossaryParentID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MenuItems = ko.observableArray([]);
        this.Parent = ko.observable();
        this.Module = ko.observable();
        this.MVCAction = ko.observable();
        this.GlossaryParent = ko.observable();
        this.MenuItemSection = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ParentID != undefined) {
                loaded.ParentID(responseData.ParentID);
            }
            if (responseData.MenuItemSectionID != undefined) {
                loaded.MenuItemSectionID(responseData.MenuItemSectionID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.IsReportingMenu != undefined) {
                loaded.IsReportingMenu(responseData.IsReportingMenu);
            }
            if (responseData.NavigateToURL != undefined) {
                loaded.NavigateToURL(responseData.NavigateToURL);
            }
            if (responseData.ImageURL != undefined) {
                loaded.ImageURL(responseData.ImageURL);
            }
            if (responseData.ModuleID != undefined) {
                loaded.ModuleID(responseData.ModuleID);
            }
            if (responseData.Target != undefined) {
                loaded.Target(responseData.Target);
            }
            if (responseData.MenuSequence != undefined) {
                loaded.MenuSequence(responseData.MenuSequence);
            }
            if (responseData.SortOrdinal != undefined) {
                loaded.SortOrdinal(responseData.SortOrdinal);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.MVCActionID != undefined) {
                loaded.MVCActionID(responseData.MVCActionID);
            }
            if (responseData.Placeholder != undefined) {
                loaded.Placeholder(responseData.Placeholder);
            }
            if (responseData.Location != undefined) {
                loaded.Location(responseData.Location);
            }
            if (responseData.GlossaryParentID != undefined) {
                loaded.GlossaryParentID(responseData.GlossaryParentID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MenuItems != null && responseData.MenuItems.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MenuItems.length; i++) {
                    items.push(new smapi.entities.MenuItemModel().LoadFromResponse(responseData.MenuItems[i]));
                }
                loaded.MenuItems(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.entities.MenuItemModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.Module != null) {
                loaded.Module(new smapi.entities.ModuleModel().LoadFromResponse(responseData.Module));
            }
            if (responseData.MVCAction != null) {
                loaded.MVCAction(new smapi.entities.MVCActionModel().LoadFromResponse(responseData.MVCAction));
            }
            if (responseData.GlossaryParent != null) {
                loaded.GlossaryParent(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.GlossaryParent));
            }
            if (responseData.MenuItemSection != null) {
                loaded.MenuItemSection(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.MenuItemSection));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.MenuItem', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ParentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MenuItemSectionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.NavigateToURL.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ImageURL.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ModuleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Target.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MenuSequence.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MVCActionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Location.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.GlossaryParentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PageActionModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ResourceKey: '',
            MenuItemID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ResourceKey = ko.validatedObservable(settings.ResourceKey);
        this.MenuItemID = ko.validatedObservable(settings.MenuItemID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MenuItem = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ResourceKey != undefined) {
                loaded.ResourceKey(responseData.ResourceKey);
            }
            if (responseData.MenuItemID != undefined) {
                loaded.MenuItemID(responseData.MenuItemID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MenuItem != null) {
                loaded.MenuItem(new smapi.entities.MenuItemModel().LoadFromResponse(responseData.MenuItem));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.PageAction', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 150,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '150')
            }
        });
        this.ResourceKey.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MenuItemID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MVCActionModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Controller: '',
            Action: '',
            Area: '',
            ExcludeFromHistory: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Controller = ko.validatedObservable(settings.Controller);
        this.Action = ko.validatedObservable(settings.Action);
        this.Area = ko.validatedObservable(settings.Area);
        this.ExcludeFromHistory = ko.validatedObservable(settings.ExcludeFromHistory);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Controller != undefined) {
                loaded.Controller(responseData.Controller);
            }
            if (responseData.Action != undefined) {
                loaded.Action(responseData.Action);
            }
            if (responseData.Area != undefined) {
                loaded.Area(responseData.Area);
            }
            if (responseData.ExcludeFromHistory != undefined) {
                loaded.ExcludeFromHistory(responseData.ExcludeFromHistory);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.MVCAction', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.Controller.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Action.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Area.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DataAuditModel(options) {
        var defaults = {
            Name: '',
            AuditEntityID: null,
            AuditCreate: false,
            AuditUpdate: false,
            AuditDelete: false,
            AuditAll: false,
            BusinessMeaningName: '',
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.AuditEntityID = ko.validatedObservable(settings.AuditEntityID);
        this.AuditCreate = ko.validatedObservable(settings.AuditCreate);
        this.AuditUpdate = ko.validatedObservable(settings.AuditUpdate);
        this.AuditDelete = ko.validatedObservable(settings.AuditDelete);
        this.AuditAll = ko.validatedObservable(settings.AuditAll);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Properties = ko.observableArray([]);
        this.Relationships = ko.observableArray([]);
        this.AuditEntity = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.AuditEntityID != undefined) {
                loaded.AuditEntityID(responseData.AuditEntityID);
            }
            if (responseData.AuditCreate != undefined) {
                loaded.AuditCreate(responseData.AuditCreate);
            }
            if (responseData.AuditUpdate != undefined) {
                loaded.AuditUpdate(responseData.AuditUpdate);
            }
            if (responseData.AuditDelete != undefined) {
                loaded.AuditDelete(responseData.AuditDelete);
            }
            if (responseData.AuditAll != undefined) {
                loaded.AuditAll(responseData.AuditAll);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Properties != null && responseData.Properties.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Properties.length; i++) {
                    items.push(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.Properties[i]));
                }
                loaded.Properties(items);
            }
            if (responseData.Relationships != null && responseData.Relationships.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Relationships.length; i++) {
                    items.push(new smapi.entities.EntityRelationshipModel().LoadFromResponse(responseData.Relationships[i]));
                }
                loaded.Relationships(items);
            }
            if (responseData.AuditEntity != null) {
                loaded.AuditEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.AuditEntity));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.DataAudit', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.AuditEntityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AuditHistoryModel(options) {
        var defaults = {
            AuditKey: '',
            ChangedData: '',
            EntityID: 0,
            FieldID: 0,
            RelationshipID: 0,
            InstanceID: 0,
            InstanceGID: null,
            EntityName: '',
            FieldRelationship: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AuditKey = ko.validatedObservable(settings.AuditKey);
        this.ChangedData = ko.validatedObservable(settings.ChangedData);
        this.EntityID = ko.validatedObservable(settings.EntityID);
        this.FieldID = ko.validatedObservable(settings.FieldID);
        this.RelationshipID = ko.validatedObservable(settings.RelationshipID);
        this.InstanceID = ko.validatedObservable(settings.InstanceID);
        this.InstanceGID = ko.validatedObservable(settings.InstanceGID);
        this.EntityName = ko.validatedObservable(settings.EntityName);
        this.FieldRelationship = ko.validatedObservable(settings.FieldRelationship);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AuditKey != undefined) {
                loaded.AuditKey(responseData.AuditKey);
            }
            if (responseData.ChangedData != undefined) {
                loaded.ChangedData(responseData.ChangedData);
            }
            if (responseData.EntityID != undefined) {
                loaded.EntityID(responseData.EntityID);
            }
            if (responseData.FieldID != undefined) {
                loaded.FieldID(responseData.FieldID);
            }
            if (responseData.RelationshipID != undefined) {
                loaded.RelationshipID(responseData.RelationshipID);
            }
            if (responseData.InstanceID != undefined) {
                loaded.InstanceID(responseData.InstanceID);
            }
            if (responseData.InstanceGID != undefined) {
                loaded.InstanceGID(responseData.InstanceGID);
            }
            if (responseData.EntityName != undefined) {
                loaded.EntityName(responseData.EntityName);
            }
            if (responseData.FieldRelationship != undefined) {
                loaded.FieldRelationship(responseData.FieldRelationship);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.AuditHistory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AuditKey.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ChangedData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.EntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FieldID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RelationshipID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InstanceID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InstanceGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.EntityName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FieldRelationship.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContextMenuModel(options) {
        var defaults = {
            MenuItemSectionID: 0,
            ParentEntityID: 0,
            TargetEntityID: 0,
            Path: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.MenuItemSectionID = ko.validatedObservable(settings.MenuItemSectionID);
        this.ParentEntityID = ko.validatedObservable(settings.ParentEntityID);
        this.TargetEntityID = ko.validatedObservable(settings.TargetEntityID);
        this.Path = ko.validatedObservable(settings.Path);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ParentEntity = ko.observable();
        this.TargetEntity = ko.observable();
        this.MenuItemSection = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.MenuItemSectionID != undefined) {
                loaded.MenuItemSectionID(responseData.MenuItemSectionID);
            }
            if (responseData.ParentEntityID != undefined) {
                loaded.ParentEntityID(responseData.ParentEntityID);
            }
            if (responseData.TargetEntityID != undefined) {
                loaded.TargetEntityID(responseData.TargetEntityID);
            }
            if (responseData.Path != undefined) {
                loaded.Path(responseData.Path);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ParentEntity != null) {
                loaded.ParentEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.ParentEntity));
            }
            if (responseData.TargetEntity != null) {
                loaded.TargetEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.TargetEntity));
            }
            if (responseData.MenuItemSection != null) {
                loaded.MenuItemSection(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.MenuItemSection));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ContextMenu', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.MenuItemSectionID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TargetEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Path.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LinkModel(options) {
        var defaults = {
            LinkLabel: '',
            SourceUrl: '',
            DestUrl: '',
            LinkActionTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.LinkLabel = ko.validatedObservable(settings.LinkLabel);
        this.SourceUrl = ko.validatedObservable(settings.SourceUrl);
        this.DestUrl = ko.validatedObservable(settings.DestUrl);
        this.LinkActionTypeID = ko.validatedObservable(settings.LinkActionTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.LinkActionType = ko.observable();
        this.LinkCounters = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.LinkLabel != undefined) {
                loaded.LinkLabel(responseData.LinkLabel);
            }
            if (responseData.SourceUrl != undefined) {
                loaded.SourceUrl(responseData.SourceUrl);
            }
            if (responseData.DestUrl != undefined) {
                loaded.DestUrl(responseData.DestUrl);
            }
            if (responseData.LinkActionTypeID != undefined) {
                loaded.LinkActionTypeID(responseData.LinkActionTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.LinkActionType != null) {
                loaded.LinkActionType(new smapi.entities.LinkActionTypeModel().LoadFromResponse(responseData.LinkActionType));
            }
            if (responseData.LinkCounters != null && responseData.LinkCounters.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.LinkCounters.length; i++) {
                    items.push(new smapi.entities.LinkCounterModel().LoadFromResponse(responseData.LinkCounters[i]));
                }
                loaded.LinkCounters(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.Link', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.LinkLabel.extend({
            maxLength: {
                params: 256,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '256')
            }
        });
        this.SourceUrl.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.DestUrl.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.LinkActionTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LinkCounterModel(options) {
        var defaults = {
            TrackingCode: '',
            SentCount: 0,
            ActionCount: 0,
            LinkID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.TrackingCode = ko.validatedObservable(settings.TrackingCode);
        this.SentCount = ko.validatedObservable(settings.SentCount);
        this.ActionCount = ko.validatedObservable(settings.ActionCount);
        this.LinkID = ko.validatedObservable(settings.LinkID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Link = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.TrackingCode != undefined) {
                loaded.TrackingCode(responseData.TrackingCode);
            }
            if (responseData.SentCount != undefined) {
                loaded.SentCount(responseData.SentCount);
            }
            if (responseData.ActionCount != undefined) {
                loaded.ActionCount(responseData.ActionCount);
            }
            if (responseData.LinkID != undefined) {
                loaded.LinkID(responseData.LinkID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Link != null) {
                loaded.Link(new smapi.entities.LinkModel().LoadFromResponse(responseData.Link));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.LinkCounter', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.TrackingCode.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.SentCount.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ActionCount.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LinkID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LinkActionTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.LinkActionType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SecurityGroupManagementConditionModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SecurityGroupManagementID: null,
            BaseTypeID: null,
            Operator: '',
            Value: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SecurityGroupManagementID = ko.validatedObservable(settings.SecurityGroupManagementID);
        this.BaseTypeID = ko.validatedObservable(settings.BaseTypeID);
        this.Operator = ko.validatedObservable(settings.Operator);
        this.Value = ko.validatedObservable(settings.Value);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ExpressionID = ko.validatedObservable(settings.ExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.BaseType = ko.observable();
        this.SecurityGroupManagement = ko.observable();
        this.Expression = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SecurityGroupManagementID != undefined) {
                loaded.SecurityGroupManagementID(responseData.SecurityGroupManagementID);
            }
            if (responseData.BaseTypeID != undefined) {
                loaded.BaseTypeID(responseData.BaseTypeID);
            }
            if (responseData.Operator != undefined) {
                loaded.Operator(responseData.Operator);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ExpressionID != undefined) {
                loaded.ExpressionID(responseData.ExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.BaseType != null) {
                loaded.BaseType(new smapi.entities.EntityModel().LoadFromResponse(responseData.BaseType));
            }
            if (responseData.SecurityGroupManagement != null) {
                loaded.SecurityGroupManagement(new smapi.entities.SecurityGroupManagementModel().LoadFromResponse(responseData.SecurityGroupManagement));
            }
            if (responseData.Expression != null) {
                loaded.Expression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.Expression));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SecurityGroupManagementCondition', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.SecurityGroupManagementID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BaseTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Operator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SecurityGroupManagementModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Enabled: false,
            SortOrder: 0,
            ParentEntityID: 0,
            ChildEntityID: 0,
            RuleSetID: 0,
            BusinessMeaningName: '',
            ParentExpressionID: null,
            ChildExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Enabled = ko.validatedObservable(settings.Enabled);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ParentEntityID = ko.validatedObservable(settings.ParentEntityID);
        this.ChildEntityID = ko.validatedObservable(settings.ChildEntityID);
        this.RuleSetID = ko.validatedObservable(settings.RuleSetID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ParentExpressionID = ko.validatedObservable(settings.ParentExpressionID);
        this.ChildExpressionID = ko.validatedObservable(settings.ChildExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ParentEntity = ko.observable();
        this.ChildEntity = ko.observable();
        this.Conditions = ko.observableArray([]);
        this.Groups = ko.observableArray([]);
        this.RuleSet = ko.observable();
        this.ParentExpression = ko.observable();
        this.ChildExpression = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Enabled != undefined) {
                loaded.Enabled(responseData.Enabled);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ParentEntityID != undefined) {
                loaded.ParentEntityID(responseData.ParentEntityID);
            }
            if (responseData.ChildEntityID != undefined) {
                loaded.ChildEntityID(responseData.ChildEntityID);
            }
            if (responseData.RuleSetID != undefined) {
                loaded.RuleSetID(responseData.RuleSetID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ParentExpressionID != undefined) {
                loaded.ParentExpressionID(responseData.ParentExpressionID);
            }
            if (responseData.ChildExpressionID != undefined) {
                loaded.ChildExpressionID(responseData.ChildExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ParentEntity != null) {
                loaded.ParentEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.ParentEntity));
            }
            if (responseData.ChildEntity != null) {
                loaded.ChildEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.ChildEntity));
            }
            if (responseData.Conditions != null && responseData.Conditions.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Conditions.length; i++) {
                    items.push(new smapi.entities.SecurityGroupManagementConditionModel().LoadFromResponse(responseData.Conditions[i]));
                }
                loaded.Conditions(items);
            }
            if (responseData.Groups != null && responseData.Groups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Groups.length; i++) {
                    items.push(new smapi.entities.GroupModel().LoadFromResponse(responseData.Groups[i]));
                }
                loaded.Groups(items);
            }
            if (responseData.RuleSet != null) {
                loaded.RuleSet(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.RuleSet));
            }
            if (responseData.ParentExpression != null) {
                loaded.ParentExpression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.ParentExpression));
            }
            if (responseData.ChildExpression != null) {
                loaded.ChildExpression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.ChildExpression));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SecurityGroupManagement', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ChildEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RuleSetID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ParentExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ChildExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TRSExpressionNodeModel(options) {
        var defaults = {
            InstanceName: '',
            PropertyName: '',
            SystemType: '',
            EntityFieldID: null,
            EntityRelationshipID: null,
            ReverseEntityRelationshipID: null,
            ExpressionID: null,
            NodeOrdinal: 0,
            NodeType: null,
            IsCollection: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.InstanceName = ko.validatedObservable(settings.InstanceName);
        this.PropertyName = ko.validatedObservable(settings.PropertyName);
        this.SystemType = ko.validatedObservable(settings.SystemType);
        this.EntityFieldID = ko.validatedObservable(settings.EntityFieldID);
        this.EntityRelationshipID = ko.validatedObservable(settings.EntityRelationshipID);
        this.ReverseEntityRelationshipID = ko.validatedObservable(settings.ReverseEntityRelationshipID);
        this.ExpressionID = ko.validatedObservable(settings.ExpressionID);
        this.NodeOrdinal = ko.validatedObservable(settings.NodeOrdinal);
        this.NodeType = ko.validatedObservable(settings.NodeType);
        this.IsCollection = ko.validatedObservable(settings.IsCollection);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EntityField = ko.observable();
        this.EntityRelationship = ko.observable();
        this.ReverseEntityRelationship = ko.observable();
        this.Expression = ko.observable();
        this.Filters = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.InstanceName != undefined) {
                loaded.InstanceName(responseData.InstanceName);
            }
            if (responseData.PropertyName != undefined) {
                loaded.PropertyName(responseData.PropertyName);
            }
            if (responseData.SystemType != undefined) {
                loaded.SystemType(responseData.SystemType);
            }
            if (responseData.EntityFieldID != undefined) {
                loaded.EntityFieldID(responseData.EntityFieldID);
            }
            if (responseData.EntityRelationshipID != undefined) {
                loaded.EntityRelationshipID(responseData.EntityRelationshipID);
            }
            if (responseData.ReverseEntityRelationshipID != undefined) {
                loaded.ReverseEntityRelationshipID(responseData.ReverseEntityRelationshipID);
            }
            if (responseData.ExpressionID != undefined) {
                loaded.ExpressionID(responseData.ExpressionID);
            }
            if (responseData.NodeOrdinal != undefined) {
                loaded.NodeOrdinal(responseData.NodeOrdinal);
            }
            if (responseData.NodeType != undefined) {
                loaded.NodeType(responseData.NodeType);
            }
            if (responseData.IsCollection != undefined) {
                loaded.IsCollection(responseData.IsCollection);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EntityField != null) {
                loaded.EntityField(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.EntityField));
            }
            if (responseData.EntityRelationship != null) {
                loaded.EntityRelationship(new smapi.entities.EntityRelationshipModel().LoadFromResponse(responseData.EntityRelationship));
            }
            if (responseData.ReverseEntityRelationship != null) {
                loaded.ReverseEntityRelationship(new smapi.entities.EntityRelationshipModel().LoadFromResponse(responseData.ReverseEntityRelationship));
            }
            if (responseData.Expression != null) {
                loaded.Expression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.Expression));
            }
            if (responseData.Filters != null && responseData.Filters.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Filters.length; i++) {
                    items.push(new smapi.entities.TRSExpressionFilterModel().LoadFromResponse(responseData.Filters[i]));
                }
                loaded.Filters(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.TRSExpressionNode', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.InstanceName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PropertyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SystemType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EntityFieldID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EntityRelationshipID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReverseEntityRelationshipID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NodeOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NodeType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TRSExpressionModel(options) {
        var defaults = {
            ExpressionType: null,
            RawExpression: '',
            EnteredValue: '',
            BoundEntityID: null,
            BoundSystemType: '',
            BoundInstanceName: '',
            ComparisonFieldID: null,
            ComparisonFieldSystemType: '',
            RuleSetStr: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ExpressionType = ko.validatedObservable(settings.ExpressionType);
        this.RawExpression = ko.validatedObservable(settings.RawExpression);
        this.EnteredValue = ko.validatedObservable(settings.EnteredValue);
        this.BoundEntityID = ko.validatedObservable(settings.BoundEntityID);
        this.BoundSystemType = ko.validatedObservable(settings.BoundSystemType);
        this.BoundInstanceName = ko.validatedObservable(settings.BoundInstanceName);
        this.ComparisonFieldID = ko.validatedObservable(settings.ComparisonFieldID);
        this.ComparisonFieldSystemType = ko.validatedObservable(settings.ComparisonFieldSystemType);
        this.RuleSetStr = ko.validatedObservable(settings.RuleSetStr);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.BoundEntity = ko.observable();
        this.ComparisonField = ko.observable();
        this.Nodes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ExpressionType != undefined) {
                loaded.ExpressionType(responseData.ExpressionType);
            }
            if (responseData.RawExpression != undefined) {
                loaded.RawExpression(responseData.RawExpression);
            }
            if (responseData.EnteredValue != undefined) {
                loaded.EnteredValue(responseData.EnteredValue);
            }
            if (responseData.BoundEntityID != undefined) {
                loaded.BoundEntityID(responseData.BoundEntityID);
            }
            if (responseData.BoundSystemType != undefined) {
                loaded.BoundSystemType(responseData.BoundSystemType);
            }
            if (responseData.BoundInstanceName != undefined) {
                loaded.BoundInstanceName(responseData.BoundInstanceName);
            }
            if (responseData.ComparisonFieldID != undefined) {
                loaded.ComparisonFieldID(responseData.ComparisonFieldID);
            }
            if (responseData.ComparisonFieldSystemType != undefined) {
                loaded.ComparisonFieldSystemType(responseData.ComparisonFieldSystemType);
            }
            if (responseData.RuleSetStr != undefined) {
                loaded.RuleSetStr(responseData.RuleSetStr);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.BoundEntity != null) {
                loaded.BoundEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.BoundEntity));
            }
            if (responseData.ComparisonField != null) {
                loaded.ComparisonField(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.ComparisonField));
            }
            if (responseData.Nodes != null && responseData.Nodes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Nodes.length; i++) {
                    items.push(new smapi.entities.TRSExpressionNodeModel().LoadFromResponse(responseData.Nodes[i]));
                }
                loaded.Nodes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.TRSExpression', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ExpressionType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.RawExpression.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.EnteredValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BoundEntityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BoundSystemType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BoundInstanceName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ComparisonFieldID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ComparisonFieldSystemType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TRSExpressionFilterModel(options) {
        var defaults = {
            Name: '',
            SourceExpressionID: null,
            ComparisonExpressionID: null,
            Operator: null,
            ExpressionNodeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.SourceExpressionID = ko.validatedObservable(settings.SourceExpressionID);
        this.ComparisonExpressionID = ko.validatedObservable(settings.ComparisonExpressionID);
        this.Operator = ko.validatedObservable(settings.Operator);
        this.ExpressionNodeID = ko.validatedObservable(settings.ExpressionNodeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.SourceExpression = ko.observable();
        this.ComparisonExpression = ko.observable();
        this.ExpressionNode = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.SourceExpressionID != undefined) {
                loaded.SourceExpressionID(responseData.SourceExpressionID);
            }
            if (responseData.ComparisonExpressionID != undefined) {
                loaded.ComparisonExpressionID(responseData.ComparisonExpressionID);
            }
            if (responseData.Operator != undefined) {
                loaded.Operator(responseData.Operator);
            }
            if (responseData.ExpressionNodeID != undefined) {
                loaded.ExpressionNodeID(responseData.ExpressionNodeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SourceExpression != null) {
                loaded.SourceExpression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.SourceExpression));
            }
            if (responseData.ComparisonExpression != null) {
                loaded.ComparisonExpression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.ComparisonExpression));
            }
            if (responseData.ExpressionNode != null) {
                loaded.ExpressionNode(new smapi.entities.TRSExpressionNodeModel().LoadFromResponse(responseData.ExpressionNode));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.TRSExpressionFilter', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourceExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ComparisonExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Operator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExpressionNodeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LifecycleEventModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.LifecycleEvent', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EntityLifecycleEventModel(options) {
        var defaults = {
            EntityID: 0,
            TRSRulesetID: 0,
            LifecycleEventID: 0,
            SortOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.EntityID = ko.validatedObservable(settings.EntityID);
        this.TRSRulesetID = ko.validatedObservable(settings.TRSRulesetID);
        this.LifecycleEventID = ko.validatedObservable(settings.LifecycleEventID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.TRSRuleset = ko.observable();
        this.LifecycleEvent = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.EntityID != undefined) {
                loaded.EntityID(responseData.EntityID);
            }
            if (responseData.TRSRulesetID != undefined) {
                loaded.TRSRulesetID(responseData.TRSRulesetID);
            }
            if (responseData.LifecycleEventID != undefined) {
                loaded.LifecycleEventID(responseData.LifecycleEventID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TRSRuleset != null) {
                loaded.TRSRuleset(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.TRSRuleset));
            }
            if (responseData.LifecycleEvent != null) {
                loaded.LifecycleEvent(new smapi.entities.LifecycleEventModel().LoadFromResponse(responseData.LifecycleEvent));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.EntityLifecycleEvent', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.EntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TRSRulesetID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LifecycleEventID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BuildVersionModel(options) {
        var defaults = {
            Version: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Version = ko.validatedObservable(settings.Version);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Version != undefined) {
                loaded.Version(responseData.Version);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BuildVersion', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Version.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationSettingsModel(options) {
        var defaults = {
            SettingName: '',
            SettingValue: '',
            SettingSortOrder: 0,
            SettingLabel: '',
            SettingDescription: '',
            IsRequired: false,
            IsHidden: false,
            FieldGroupID: 0,
            FormatString: '',
            RegExFormat: '',
            Mask: '',
            RegExMatch: '',
            TypeID: null,
            SimpleTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.SettingName = ko.validatedObservable(settings.SettingName);
        this.SettingValue = ko.validatedObservable(settings.SettingValue);
        this.SettingSortOrder = ko.validatedObservable(settings.SettingSortOrder);
        this.SettingLabel = ko.validatedObservable(settings.SettingLabel);
        this.SettingDescription = ko.validatedObservable(settings.SettingDescription);
        this.IsRequired = ko.validatedObservable(settings.IsRequired);
        this.IsHidden = ko.validatedObservable(settings.IsHidden);
        this.FieldGroupID = ko.validatedObservable(settings.FieldGroupID);
        this.FormatString = ko.validatedObservable(settings.FormatString);
        this.RegExFormat = ko.validatedObservable(settings.RegExFormat);
        this.Mask = ko.validatedObservable(settings.Mask);
        this.RegExMatch = ko.validatedObservable(settings.RegExMatch);
        this.TypeID = ko.validatedObservable(settings.TypeID);
        this.SimpleTypeID = ko.validatedObservable(settings.SimpleTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.FieldGroup = ko.observable();
        this.Type = ko.observable();
        this.SimpleType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.SettingName != undefined) {
                loaded.SettingName(responseData.SettingName);
            }
            if (responseData.SettingValue != undefined) {
                loaded.SettingValue(responseData.SettingValue);
            }
            if (responseData.SettingSortOrder != undefined) {
                loaded.SettingSortOrder(responseData.SettingSortOrder);
            }
            if (responseData.SettingLabel != undefined) {
                loaded.SettingLabel(responseData.SettingLabel);
            }
            if (responseData.SettingDescription != undefined) {
                loaded.SettingDescription(responseData.SettingDescription);
            }
            if (responseData.IsRequired != undefined) {
                loaded.IsRequired(responseData.IsRequired);
            }
            if (responseData.IsHidden != undefined) {
                loaded.IsHidden(responseData.IsHidden);
            }
            if (responseData.FieldGroupID != undefined) {
                loaded.FieldGroupID(responseData.FieldGroupID);
            }
            if (responseData.FormatString != undefined) {
                loaded.FormatString(responseData.FormatString);
            }
            if (responseData.RegExFormat != undefined) {
                loaded.RegExFormat(responseData.RegExFormat);
            }
            if (responseData.Mask != undefined) {
                loaded.Mask(responseData.Mask);
            }
            if (responseData.RegExMatch != undefined) {
                loaded.RegExMatch(responseData.RegExMatch);
            }
            if (responseData.TypeID != undefined) {
                loaded.TypeID(responseData.TypeID);
            }
            if (responseData.SimpleTypeID != undefined) {
                loaded.SimpleTypeID(responseData.SimpleTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.FieldGroup != null) {
                loaded.FieldGroup(new smapi.entities.ApplicationSettingFieldGroupModel().LoadFromResponse(responseData.FieldGroup));
            }
            if (responseData.Type != null) {
                loaded.Type(new smapi.entities.ApplicationSettingFieldTypeModel().LoadFromResponse(responseData.Type));
            }
            if (responseData.SimpleType != null) {
                loaded.SimpleType(new smapi.entities.ApplicationSettingSimpleFieldTypeModel().LoadFromResponse(responseData.SimpleType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ApplicationSettings', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.SettingName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SettingSortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SettingLabel.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.FieldGroupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FormatString.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RegExFormat.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Mask.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RegExMatch.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.TypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SimpleTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SDKPackageModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Version: '',
            SortOrder: 0,
            AuthorID: null,
            Enabled: false,
            SystemProtected: false,
            RichDescription: '',
            DateOriginallyPublished: null,
            DateLastRevisionPublished: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Version = ko.validatedObservable(settings.Version);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.AuthorID = ko.validatedObservable(settings.AuthorID);
        this.Enabled = ko.validatedObservable(settings.Enabled);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.RichDescription = ko.validatedObservable(settings.RichDescription);
        this.DateOriginallyPublished = ko.validatedObservable(settings.DateOriginallyPublished);
        this.DateLastRevisionPublished = ko.validatedObservable(settings.DateLastRevisionPublished);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Author = ko.observable();
        this.PrerequisitePackages = ko.observableArray([]);
        this.Parameters = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Version != undefined) {
                loaded.Version(responseData.Version);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.AuthorID != undefined) {
                loaded.AuthorID(responseData.AuthorID);
            }
            if (responseData.Enabled != undefined) {
                loaded.Enabled(responseData.Enabled);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.RichDescription != undefined) {
                loaded.RichDescription(responseData.RichDescription);
            }
            if (responseData.DateOriginallyPublished != undefined) {
                loaded.DateOriginallyPublished(responseData.DateOriginallyPublished);
            }
            if (responseData.DateLastRevisionPublished != undefined) {
                loaded.DateLastRevisionPublished(responseData.DateLastRevisionPublished);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Author != null) {
                loaded.Author(new smapi.entities.SDKPackageAuthorModel().LoadFromResponse(responseData.Author));
            }
            if (responseData.PrerequisitePackages != null && responseData.PrerequisitePackages.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PrerequisitePackages.length; i++) {
                    items.push(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.PrerequisitePackages[i]));
                }
                loaded.PrerequisitePackages(items);
            }
            if (responseData.Parameters != null && responseData.Parameters.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Parameters.length; i++) {
                    items.push(new smapi.entities.SDKPackageParameterModel().LoadFromResponse(responseData.Parameters[i]));
                }
                loaded.Parameters(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SDKPackage', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Version.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AuthorID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateOriginallyPublished.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DateLastRevisionPublished.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SDKPackageParameterModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Value: '',
            Version: '',
            SortOrder: 0,
            SDKPackageID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Value = ko.validatedObservable(settings.Value);
        this.Version = ko.validatedObservable(settings.Version);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.SDKPackageID = ko.validatedObservable(settings.SDKPackageID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.SDKPackage = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.Version != undefined) {
                loaded.Version(responseData.Version);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.SDKPackageID != undefined) {
                loaded.SDKPackageID(responseData.SDKPackageID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SDKPackage != null) {
                loaded.SDKPackage(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.SDKPackage));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SDKPackageParameter', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Version.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SDKPackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function FieldFormatModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Format: '',
            Type: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Format = ko.validatedObservable(settings.Format);
        this.Type = ko.validatedObservable(settings.Type);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Format != undefined) {
                loaded.Format(responseData.Format);
            }
            if (responseData.Type != undefined) {
                loaded.Type(responseData.Type);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.FieldFormat', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Format.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Type.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function BusinessMeaningNameUsedModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            EntityID: 0,
            Location: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.EntityID = ko.validatedObservable(settings.EntityID);
        this.Location = ko.validatedObservable(settings.Location);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Entity = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.EntityID != undefined) {
                loaded.EntityID(responseData.EntityID);
            }
            if (responseData.Location != undefined) {
                loaded.Location(responseData.Location);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Entity != null) {
                loaded.Entity(new smapi.entities.EntityModel().LoadFromResponse(responseData.Entity));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.BusinessMeaningNameUsed', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Location.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SDKPackageAuthorModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            AuthorName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.AuthorName = ko.validatedObservable(settings.AuthorName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.AuthorName != undefined) {
                loaded.AuthorName(responseData.AuthorName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SDKPackageAuthor', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AuthorName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationSettingTabModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ApplicationSettingTab', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationSettingFieldGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            TabID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.TabID = ko.validatedObservable(settings.TabID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Tab = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.TabID != undefined) {
                loaded.TabID(responseData.TabID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Tab != null) {
                loaded.Tab(new smapi.entities.ApplicationSettingTabModel().LoadFromResponse(responseData.Tab));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ApplicationSettingFieldGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TabID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationSettingSimpleFieldTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ApplicationSettingSimpleFieldType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationSettingFieldTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            GlossaryID: null,
            SimpleTypeID: null,
            IsGlossary: false,
            IncludeProtocol: false,
            IsRelativePath: false,
            Separator: '',
            ObjectValue: '',
            ObjectText: '',
            IsNewlineSeparated: false,
            CharactersEscaped: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.GlossaryID = ko.validatedObservable(settings.GlossaryID);
        this.SimpleTypeID = ko.validatedObservable(settings.SimpleTypeID);
        this.IsGlossary = ko.validatedObservable(settings.IsGlossary);
        this.IncludeProtocol = ko.validatedObservable(settings.IncludeProtocol);
        this.IsRelativePath = ko.validatedObservable(settings.IsRelativePath);
        this.Separator = ko.validatedObservable(settings.Separator);
        this.ObjectValue = ko.validatedObservable(settings.ObjectValue);
        this.ObjectText = ko.validatedObservable(settings.ObjectText);
        this.IsNewlineSeparated = ko.validatedObservable(settings.IsNewlineSeparated);
        this.CharactersEscaped = ko.validatedObservable(settings.CharactersEscaped);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GlossaryParent = ko.observable();
        this.SimpleType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.GlossaryID != undefined) {
                loaded.GlossaryID(responseData.GlossaryID);
            }
            if (responseData.SimpleTypeID != undefined) {
                loaded.SimpleTypeID(responseData.SimpleTypeID);
            }
            if (responseData.IsGlossary != undefined) {
                loaded.IsGlossary(responseData.IsGlossary);
            }
            if (responseData.IncludeProtocol != undefined) {
                loaded.IncludeProtocol(responseData.IncludeProtocol);
            }
            if (responseData.IsRelativePath != undefined) {
                loaded.IsRelativePath(responseData.IsRelativePath);
            }
            if (responseData.Separator != undefined) {
                loaded.Separator(responseData.Separator);
            }
            if (responseData.ObjectValue != undefined) {
                loaded.ObjectValue(responseData.ObjectValue);
            }
            if (responseData.ObjectText != undefined) {
                loaded.ObjectText(responseData.ObjectText);
            }
            if (responseData.IsNewlineSeparated != undefined) {
                loaded.IsNewlineSeparated(responseData.IsNewlineSeparated);
            }
            if (responseData.CharactersEscaped != undefined) {
                loaded.CharactersEscaped(responseData.CharactersEscaped);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GlossaryParent != null) {
                loaded.GlossaryParent(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.GlossaryParent));
            }
            if (responseData.SimpleType != null) {
                loaded.SimpleType(new smapi.entities.ApplicationSettingSimpleFieldTypeModel().LoadFromResponse(responseData.SimpleType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ApplicationSettingFieldType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.GlossaryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SimpleTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Separator.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ObjectValue.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ObjectText.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function IntegrationSettingsModel(options) {
        var defaults = {
            SettingName: '',
            SettingValue: '',
            SettingSortOrder: 0,
            SettingLabel: '',
            SettingDescription: '',
            IsRequired: false,
            IsHidden: false,
            IntegratedApplicationID: null,
            FieldGroupID: null,
            TypeID: null,
            SimpleTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.SettingName = ko.validatedObservable(settings.SettingName);
        this.SettingValue = ko.validatedObservable(settings.SettingValue);
        this.SettingSortOrder = ko.validatedObservable(settings.SettingSortOrder);
        this.SettingLabel = ko.validatedObservable(settings.SettingLabel);
        this.SettingDescription = ko.validatedObservable(settings.SettingDescription);
        this.IsRequired = ko.validatedObservable(settings.IsRequired);
        this.IsHidden = ko.validatedObservable(settings.IsHidden);
        this.IntegratedApplicationID = ko.validatedObservable(settings.IntegratedApplicationID);
        this.FieldGroupID = ko.validatedObservable(settings.FieldGroupID);
        this.TypeID = ko.validatedObservable(settings.TypeID);
        this.SimpleTypeID = ko.validatedObservable(settings.SimpleTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.IntegratedApplication = ko.observable();
        this.FieldGroup = ko.observable();
        this.Type = ko.observable();
        this.SimpleType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.SettingName != undefined) {
                loaded.SettingName(responseData.SettingName);
            }
            if (responseData.SettingValue != undefined) {
                loaded.SettingValue(responseData.SettingValue);
            }
            if (responseData.SettingSortOrder != undefined) {
                loaded.SettingSortOrder(responseData.SettingSortOrder);
            }
            if (responseData.SettingLabel != undefined) {
                loaded.SettingLabel(responseData.SettingLabel);
            }
            if (responseData.SettingDescription != undefined) {
                loaded.SettingDescription(responseData.SettingDescription);
            }
            if (responseData.IsRequired != undefined) {
                loaded.IsRequired(responseData.IsRequired);
            }
            if (responseData.IsHidden != undefined) {
                loaded.IsHidden(responseData.IsHidden);
            }
            if (responseData.IntegratedApplicationID != undefined) {
                loaded.IntegratedApplicationID(responseData.IntegratedApplicationID);
            }
            if (responseData.FieldGroupID != undefined) {
                loaded.FieldGroupID(responseData.FieldGroupID);
            }
            if (responseData.TypeID != undefined) {
                loaded.TypeID(responseData.TypeID);
            }
            if (responseData.SimpleTypeID != undefined) {
                loaded.SimpleTypeID(responseData.SimpleTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.IntegratedApplication != null) {
                loaded.IntegratedApplication(new smapi.entities.IntegratedApplicationModel().LoadFromResponse(responseData.IntegratedApplication));
            }
            if (responseData.FieldGroup != null) {
                loaded.FieldGroup(new smapi.entities.IntegrationSettingFieldGroupModel().LoadFromResponse(responseData.FieldGroup));
            }
            if (responseData.Type != null) {
                loaded.Type(new smapi.entities.ApplicationSettingFieldTypeModel().LoadFromResponse(responseData.Type));
            }
            if (responseData.SimpleType != null) {
                loaded.SimpleType(new smapi.entities.ApplicationSettingSimpleFieldTypeModel().LoadFromResponse(responseData.SimpleType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.IntegrationSettings', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.SettingName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SettingSortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SettingLabel.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.IntegratedApplicationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FieldGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SimpleTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function IntegrationSettingTabModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.IntegrationSettingTab', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function IntegrationSettingFieldGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            TabID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.TabID = ko.validatedObservable(settings.TabID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Tab = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.TabID != undefined) {
                loaded.TabID(responseData.TabID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Tab != null) {
                loaded.Tab(new smapi.entities.IntegrationSettingTabModel().LoadFromResponse(responseData.Tab));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.IntegrationSettingFieldGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TabID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function IntegratedApplicationModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            PollingFrequency: 0,
            PollingFrequencyUnit: '',
            ListenerProcessClass: '',
            ListenerProcessActive: false,
            ListenerProcessLastActiveDate: null,
            ListenerProcessAssembly: '',
            CustomController: '',
            CustomControllerAfterSaveAction: '',
            ExtPollingFrequency: 0,
            ExtPollingFrequencyUnit: '',
            ExtListenerProcessClass: '',
            ExtListenerProcessActive: false,
            ExtListenerProcessLastActiveDate: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.PollingFrequency = ko.validatedObservable(settings.PollingFrequency);
        this.PollingFrequencyUnit = ko.validatedObservable(settings.PollingFrequencyUnit);
        this.ListenerProcessClass = ko.validatedObservable(settings.ListenerProcessClass);
        this.ListenerProcessActive = ko.validatedObservable(settings.ListenerProcessActive);
        this.ListenerProcessLastActiveDate = ko.validatedObservable(settings.ListenerProcessLastActiveDate);
        this.ListenerProcessAssembly = ko.validatedObservable(settings.ListenerProcessAssembly);
        this.CustomController = ko.validatedObservable(settings.CustomController);
        this.CustomControllerAfterSaveAction = ko.validatedObservable(settings.CustomControllerAfterSaveAction);
        this.ExtPollingFrequency = ko.validatedObservable(settings.ExtPollingFrequency);
        this.ExtPollingFrequencyUnit = ko.validatedObservable(settings.ExtPollingFrequencyUnit);
        this.ExtListenerProcessClass = ko.validatedObservable(settings.ExtListenerProcessClass);
        this.ExtListenerProcessActive = ko.validatedObservable(settings.ExtListenerProcessActive);
        this.ExtListenerProcessLastActiveDate = ko.validatedObservable(settings.ExtListenerProcessLastActiveDate);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.PollingFrequency != undefined) {
                loaded.PollingFrequency(responseData.PollingFrequency);
            }
            if (responseData.PollingFrequencyUnit != undefined) {
                loaded.PollingFrequencyUnit(responseData.PollingFrequencyUnit);
            }
            if (responseData.ListenerProcessClass != undefined) {
                loaded.ListenerProcessClass(responseData.ListenerProcessClass);
            }
            if (responseData.ListenerProcessActive != undefined) {
                loaded.ListenerProcessActive(responseData.ListenerProcessActive);
            }
            if (responseData.ListenerProcessLastActiveDate != undefined) {
                loaded.ListenerProcessLastActiveDate(responseData.ListenerProcessLastActiveDate);
            }
            if (responseData.ListenerProcessAssembly != undefined) {
                loaded.ListenerProcessAssembly(responseData.ListenerProcessAssembly);
            }
            if (responseData.CustomController != undefined) {
                loaded.CustomController(responseData.CustomController);
            }
            if (responseData.CustomControllerAfterSaveAction != undefined) {
                loaded.CustomControllerAfterSaveAction(responseData.CustomControllerAfterSaveAction);
            }
            if (responseData.ExtPollingFrequency != undefined) {
                loaded.ExtPollingFrequency(responseData.ExtPollingFrequency);
            }
            if (responseData.ExtPollingFrequencyUnit != undefined) {
                loaded.ExtPollingFrequencyUnit(responseData.ExtPollingFrequencyUnit);
            }
            if (responseData.ExtListenerProcessClass != undefined) {
                loaded.ExtListenerProcessClass(responseData.ExtListenerProcessClass);
            }
            if (responseData.ExtListenerProcessActive != undefined) {
                loaded.ExtListenerProcessActive(responseData.ExtListenerProcessActive);
            }
            if (responseData.ExtListenerProcessLastActiveDate != undefined) {
                loaded.ExtListenerProcessLastActiveDate(responseData.ExtListenerProcessLastActiveDate);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.IntegratedApplication', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.PollingFrequency.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: 1,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '1')
            }, 
            max: {
                params: 1728000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '1728000')
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PollingFrequencyUnit.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ListenerProcessClass.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.ListenerProcessLastActiveDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ListenerProcessAssembly.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CustomController.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CustomControllerAfterSaveAction.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExtPollingFrequency.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: 1,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '1')
            }, 
            max: {
                params: 1728000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '1728000')
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExtPollingFrequencyUnit.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExtListenerProcessClass.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.ExtListenerProcessLastActiveDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PasswordPatternModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            HasToContainLowerCase: false,
            HasToContainUpperCase: false,
            HasToContainDigit: false,
            HasToContainSpecialCharacter: false,
            SortOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.HasToContainLowerCase = ko.validatedObservable(settings.HasToContainLowerCase);
        this.HasToContainUpperCase = ko.validatedObservable(settings.HasToContainUpperCase);
        this.HasToContainDigit = ko.validatedObservable(settings.HasToContainDigit);
        this.HasToContainSpecialCharacter = ko.validatedObservable(settings.HasToContainSpecialCharacter);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.HasToContainLowerCase != undefined) {
                loaded.HasToContainLowerCase(responseData.HasToContainLowerCase);
            }
            if (responseData.HasToContainUpperCase != undefined) {
                loaded.HasToContainUpperCase(responseData.HasToContainUpperCase);
            }
            if (responseData.HasToContainDigit != undefined) {
                loaded.HasToContainDigit(responseData.HasToContainDigit);
            }
            if (responseData.HasToContainSpecialCharacter != undefined) {
                loaded.HasToContainSpecialCharacter(responseData.HasToContainSpecialCharacter);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.PasswordPattern', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PackageFileTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Extension: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Extension = ko.validatedObservable(settings.Extension);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Extension != undefined) {
                loaded.Extension(responseData.Extension);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.PackageFileType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Extension.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationServiceModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            VirtualDirectory: '',
            IsWebApp: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.VirtualDirectory = ko.validatedObservable(settings.VirtualDirectory);
        this.IsWebApp = ko.validatedObservable(settings.IsWebApp);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.VirtualDirectory != undefined) {
                loaded.VirtualDirectory(responseData.VirtualDirectory);
            }
            if (responseData.IsWebApp != undefined) {
                loaded.IsWebApp(responseData.IsWebApp);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.ApplicationService', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.VirtualDirectory.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SupportAssemblyModel(options) {
        var defaults = {
            FileName: '',
            AssemblyName: '',
            Version: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.FileName = ko.validatedObservable(settings.FileName);
        this.AssemblyName = ko.validatedObservable(settings.AssemblyName);
        this.Version = ko.validatedObservable(settings.Version);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationServices = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.AssemblyName != undefined) {
                loaded.AssemblyName(responseData.AssemblyName);
            }
            if (responseData.Version != undefined) {
                loaded.Version(responseData.Version);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationServices != null && responseData.ApplicationServices.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationServices.length; i++) {
                    items.push(new smapi.entities.ApplicationServiceModel().LoadFromResponse(responseData.ApplicationServices[i]));
                }
                loaded.ApplicationServices(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.SupportAssembly', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.FileName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AssemblyName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Version.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PackageResourceModel(options) {
        var defaults = {
            FileName: '',
            SourcePath: '',
            DestPath: '',
            Enabled: false,
            PackageID: null,
            ApplicationServiceID: null,
            FileTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.FileName = ko.validatedObservable(settings.FileName);
        this.SourcePath = ko.validatedObservable(settings.SourcePath);
        this.DestPath = ko.validatedObservable(settings.DestPath);
        this.Enabled = ko.validatedObservable(settings.Enabled);
        this.PackageID = ko.validatedObservable(settings.PackageID);
        this.ApplicationServiceID = ko.validatedObservable(settings.ApplicationServiceID);
        this.FileTypeID = ko.validatedObservable(settings.FileTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Package = ko.observable();
        this.ApplicationService = ko.observable();
        this.FileType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.SourcePath != undefined) {
                loaded.SourcePath(responseData.SourcePath);
            }
            if (responseData.DestPath != undefined) {
                loaded.DestPath(responseData.DestPath);
            }
            if (responseData.Enabled != undefined) {
                loaded.Enabled(responseData.Enabled);
            }
            if (responseData.PackageID != undefined) {
                loaded.PackageID(responseData.PackageID);
            }
            if (responseData.ApplicationServiceID != undefined) {
                loaded.ApplicationServiceID(responseData.ApplicationServiceID);
            }
            if (responseData.FileTypeID != undefined) {
                loaded.FileTypeID(responseData.FileTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Package != null) {
                loaded.Package(new smapi.entities.SDKPackageModel().LoadFromResponse(responseData.Package));
            }
            if (responseData.ApplicationService != null) {
                loaded.ApplicationService(new smapi.entities.ApplicationServiceModel().LoadFromResponse(responseData.ApplicationService));
            }
            if (responseData.FileType != null) {
                loaded.FileType(new smapi.entities.PackageFileTypeModel().LoadFromResponse(responseData.FileType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.Flint.BLL.Entities.PackageResource', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.FileName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourcePath.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DestPath.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PackageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ApplicationServiceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FileTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LoadTemplates(basePath, targetDiv) {
        var uri = basePath + '/SMAPI.entities.combined-1.0.0.html';
        jQuery.ajax({
            url: uri,
            type: 'GET',
            async: false,
            success: function (template) {
                jQuery("#" + targetDiv).append(template);
            }
        });
    }
    
    
    $.extend(true, smapi.entities, {
        AssemblyVersionModel: AssemblyVersionModel,
        AssemblyScriptModel: AssemblyScriptModel,
        UserModel: UserModel,
        TRSIdentityModel: TRSIdentityModel,
        TRSGroupIdentityModel: TRSGroupIdentityModel,
        TRSMembershipUserModel: TRSMembershipUserModel,
        TRSMembershipUserCertificateModel: TRSMembershipUserCertificateModel,
        LocaleModel: LocaleModel,
        WebApplicationModel: WebApplicationModel,
        AuthenticationProviderDefModel: AuthenticationProviderDefModel,
        EntityBuilderModel: EntityBuilderModel,
        BuilderEnumerationModel: BuilderEnumerationModel,
        BuilderInterfaceModel: BuilderInterfaceModel,
        BuilderInterfacePropertyModel: BuilderInterfacePropertyModel,
        BuilderInterfaceRelationshipModel: BuilderInterfaceRelationshipModel,
        BuilderIndexerModel: BuilderIndexerModel,
        BuilderIndexModel: BuilderIndexModel,
        BuilderIndexEqualPropertyModel: BuilderIndexEqualPropertyModel,
        BuilderIndexRangePropertyModel: BuilderIndexRangePropertyModel,
        BuilderEntityModel: BuilderEntityModel,
        BuilderEntityFieldModel: BuilderEntityFieldModel,
        BuilderEntityRelationshipModel: BuilderEntityRelationshipModel,
        BuilderEntityLookupRelationshipModel: BuilderEntityLookupRelationshipModel,
        BulderEntityBusinessMeaningRelationshipModel: BulderEntityBusinessMeaningRelationshipModel,
        BuilderEntityRelationshipLinkModel: BuilderEntityRelationshipLinkModel,
        BuilderEntityQueryModel: BuilderEntityQueryModel,
        QueryPartModel: QueryPartModel,
        QueryPartGroupModel: QueryPartGroupModel,
        QueryPartBindingModel: QueryPartBindingModel,
        QueryPartLiteralModel: QueryPartLiteralModel,
        BuilderEntityDBIndexModel: BuilderEntityDBIndexModel,
        BuilderEntityDBIndexFieldModel: BuilderEntityDBIndexFieldModel,
        BuilderEntityFieldMVCAttributeModel: BuilderEntityFieldMVCAttributeModel,
        BuilderEntityRelationshipMVCAttributeModel: BuilderEntityRelationshipMVCAttributeModel,
        LookupGroupModel: LookupGroupModel,
        GlossaryModel: GlossaryModel,
        ModuleAssemblyModel: ModuleAssemblyModel,
        SiteModel: SiteModel,
        ModuleModel: ModuleModel,
        LookupGroupingModel: LookupGroupingModel,
        LookupGroupingAssociationModel: LookupGroupingAssociationModel,
        EntityModel: EntityModel,
        EntityFieldModel: EntityFieldModel,
        EntityRelationshipModel: EntityRelationshipModel,
        EntityRelationshipLinkModel: EntityRelationshipLinkModel,
        CurrencyModel: CurrencyModel,
        EntityDBIndexModel: EntityDBIndexModel,
        EntityDBIndexFieldModel: EntityDBIndexFieldModel,
        EntityFieldMVCAttributeModel: EntityFieldMVCAttributeModel,
        EntityRelationshipMVCAttributeModel: EntityRelationshipMVCAttributeModel,
        ResourceRoleModel: ResourceRoleModel,
        MatchListTargetModel: MatchListTargetModel,
        MatchListModel: MatchListModel,
        MatchListItemModel: MatchListItemModel,
        SystemLogModel: SystemLogModel,
        SystemLogMessageModel: SystemLogMessageModel,
        SystemLogExceptionModel: SystemLogExceptionModel,
        SystemLogExtendedPropertyModel: SystemLogExtendedPropertyModel,
        ReportExecModel: ReportExecModel,
        PermissionModel: PermissionModel,
        RoleModel: RoleModel,
        GroupLevelModel: GroupLevelModel,
        GroupRowAccessModel: GroupRowAccessModel,
        EntityRowSecurityGroupsModel: EntityRowSecurityGroupsModel,
        GroupModel: GroupModel,
        TRSRuleSetModel: TRSRuleSetModel,
        PersonalizationPathModel: PersonalizationPathModel,
        PersonalizationAllUsersModel: PersonalizationAllUsersModel,
        PersonalizationPerUserModel: PersonalizationPerUserModel,
        ProfileModel: ProfileModel,
        FlintCredentialModel: FlintCredentialModel,
        IconModel: IconModel,
        AlertModel: AlertModel,
        UserRuleSetModel: UserRuleSetModel,
        GroupRuleSetModel: GroupRuleSetModel,
        DataChangedWatcherModel: DataChangedWatcherModel,
        DataChangedWatchPropertyModel: DataChangedWatchPropertyModel,
        LoggerModel: LoggerModel,
        LookupTablesLoaderModel: LookupTablesLoaderModel,
        FlintSettingModel: FlintSettingModel,
        ReportModel: ReportModel,
        ReportLabelModel: ReportLabelModel,
        ReportFieldModel: ReportFieldModel,
        ReportFilterModel: ReportFilterModel,
        ReportGroupModel: ReportGroupModel,
        TenantModel: TenantModel,
        MenuItemModel: MenuItemModel,
        PageActionModel: PageActionModel,
        MVCActionModel: MVCActionModel,
        DataAuditModel: DataAuditModel,
        AuditHistoryModel: AuditHistoryModel,
        ContextMenuModel: ContextMenuModel,
        LinkModel: LinkModel,
        LinkCounterModel: LinkCounterModel,
        LinkActionTypeModel: LinkActionTypeModel,
        SecurityGroupManagementConditionModel: SecurityGroupManagementConditionModel,
        SecurityGroupManagementModel: SecurityGroupManagementModel,
        TRSExpressionNodeModel: TRSExpressionNodeModel,
        TRSExpressionModel: TRSExpressionModel,
        TRSExpressionFilterModel: TRSExpressionFilterModel,
        LifecycleEventModel: LifecycleEventModel,
        EntityLifecycleEventModel: EntityLifecycleEventModel,
        BuildVersionModel: BuildVersionModel,
        ApplicationSettingsModel: ApplicationSettingsModel,
        SDKPackageModel: SDKPackageModel,
        SDKPackageParameterModel: SDKPackageParameterModel,
        FieldFormatModel: FieldFormatModel,
        BusinessMeaningNameUsedModel: BusinessMeaningNameUsedModel,
        SDKPackageAuthorModel: SDKPackageAuthorModel,
        ApplicationSettingTabModel: ApplicationSettingTabModel,
        ApplicationSettingFieldGroupModel: ApplicationSettingFieldGroupModel,
        ApplicationSettingSimpleFieldTypeModel: ApplicationSettingSimpleFieldTypeModel,
        ApplicationSettingFieldTypeModel: ApplicationSettingFieldTypeModel,
        IntegrationSettingsModel: IntegrationSettingsModel,
        IntegrationSettingTabModel: IntegrationSettingTabModel,
        IntegrationSettingFieldGroupModel: IntegrationSettingFieldGroupModel,
        IntegratedApplicationModel: IntegratedApplicationModel,
        PasswordPatternModel: PasswordPatternModel,
        PackageFileTypeModel: PackageFileTypeModel,
        ApplicationServiceModel: ApplicationServiceModel,
        SupportAssemblyModel: SupportAssemblyModel,
        PackageResourceModel: PackageResourceModel,
        LoadTemplates: LoadTemplates
    });
})(jQuery);
